import TTF from '@/TweenTransformer';

export default function SymbolImporter(lib,cjs,ss,p){

(lib.dot_with2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.dot_with1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.trianlge = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape_1.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape_2.setTransform(-17.9,-19.5,0.32,0.32,0,0,0,-1.6,-2.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape_3.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape_4.setTransform(-17.9,-19.5,0.32,0.32,0,0,0,-1.6,-2.1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("Aj+klIH9ElIn9Emg");
	this.shape_5.setTransform(-24.4,-1,0.442,0.442,0,0,0,-1.7,-2.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("Ajog5IgsAAIAAjsIGZDsIAsAAIBkA5In9Emg");
	this.shape_6.setTransform(2.6,0);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("Aj8CSIAAkjIH5Ejg");
	this.shape_7.setTransform(-0.2,-14.8);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("Aj+iUIH4AAIAFADIn9Elg");
	this.shape_8.setTransform(0,14.6);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AiODaIhwBBIAApMIBwBBIAABYIBcA0IAAhXIExCwIkxCwIAABYIhcA1g");
	this.shape_9.setTransform(-0.4,-7.2);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AjXj4IGvD4ImvD6g");
	this.shape_10.setTransform(3.9,0);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AixjMIFjDMIljDNg");
	this.shape_11.setTransform(7.7,0);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AiSipIElCpIklCqg");
	this.shape_12.setTransform(10.8,0);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("Ahkh0IDJB0IjJB1g");
	this.shape_13.setTransform(15.4,0);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AhKhWICVBWIiVBXg");
	this.shape_14.setTransform(18,0);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("Agvg2IBfA2IhfA3g");
	this.shape_15.setTransform(20.7,0);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_2,p:{regY:-2.1,y:-19.5,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.6,x:-17.9,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},7).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2.6,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:18.2,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},8).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2.6,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:18.2,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},8).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2,y:18.2,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:8.8,x:-1.6,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.1,x:-1.6,y:-10,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},7).toE({state:[{t:this.shape_2,p:{regY:-2,y:8.8,x:-1.6,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.1,x:-1.6,y:-10,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},5).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape}]},5).toE({state:[]},7).toE({state:[{t:this.shape}]},14).toE({state:[{t:this.shape_2,p:{regY:-2.6,y:-0.7,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},15).toE({state:[{t:this.shape_5,p:{scaleX:0.442,scaleY:0.442,x:-24.4,y:-1}},{t:this.shape_4,p:{regX:-1.8,regY:-2,scaleX:0.442,scaleY:0.442,x:-1.8,y:12.1}},{t:this.shape_3,p:{regY:-2.2,y:-13.9,regX:-1.8,scaleX:0.442,scaleY:0.442,x:-1.8}},{t:this.shape_2,p:{regY:-2,y:-0.8,x:20.7,regX:-1.7,scaleX:0.442,scaleY:0.442}},{t:this.shape_1,p:{regY:-2,x:-24.4,y:-26.7,regX:-1.7,scaleX:0.442,scaleY:0.442}},{t:this.shape}]},7).toE({state:[{t:this.shape_5,p:{scaleX:0.681,scaleY:0.681,x:-36.9,y:-1.6}},{t:this.shape_4,p:{regX:-1.8,regY:-2,scaleX:0.681,scaleY:0.681,x:-2.2,y:18.6}},{t:this.shape_3,p:{regY:-2.2,y:-21.6,regX:-1.8,scaleX:0.681,scaleY:0.681,x:-2.2}},{t:this.shape_2,p:{regY:-2,y:-1.2,x:32.6,regX:-1.7,scaleX:0.681,scaleY:0.681}},{t:this.shape_1,p:{regY:-2,x:-36.9,y:-41.2,regX:-1.7,scaleX:0.681,scaleY:0.681}},{t:this.shape}]},4).toE({state:[{t:this.shape}]},4).toE({state:[{t:this.shape_6}]},137).toE({state:[{t:this.shape}]},10).toE({state:[{t:this.shape_7}]},31).toE({state:[{t:this.shape_8}]},8).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape_9}]},100).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape_9}]},24).toE({state:[{t:this.shape}]},5).toE({state:[{t:this.shape}]},47).toE({state:[{t:this.shape_10}]},7).toE({state:[{t:this.shape_11}]},9).toE({state:[{t:this.shape_12}]},8).toE({state:[{t:this.shape_13}]},6).toE({state:[{t:this.shape_14}]},6).toE({state:[{t:this.shape_15}]},4).toE({state:[]},42).waitE(167));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(7).toE({regY:-2,y:18.2},0).waitE(8).toE({regY:-2.1,x:-1.6,y:-10},0).waitE(15).toE({regY:-2,x:14.7,y:-0.6},0).waitE(16).toE({regX:0,regY:0,scaleX:0.5,scaleY:0.5,x:-3.7,y:0},0).toE({_off:true},7).waitE(14).toE({_off:false,regX:-1.6,regY:-2,scaleX:0.32,scaleY:0.32,x:14.7,y:-0.6},0).waitE(15).toE({regY:-2.1,x:-1.6,y:-10},0).waitE(7).toE({regX:-1.7,scaleX:0.44,scaleY:0.44,x:-24.4,y:25.2},0).waitE(4).toE({regY:-2.2,scaleX:0.68,scaleY:0.68,x:-36.9,y:38.8},0).waitE(4).toE({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0},0).toE({_off:true},137).waitE(10).toE({_off:false},0).toE({_off:true},31).waitE(14).toE({_off:false},0).toE({_off:true},100).waitE(6).toE({_off:false},0).toE({_off:true},24).waitE(5).toE({_off:false},0).waitE(47).toE({_off:true},7).waitE(242));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.6,-9.3,16.3,18.9);

(lib.trianlge_green = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape_1.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape_2.setTransform(-17.9,-19.5,0.32,0.32,0,0,0,-1.6,-2.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape_3.setTransform(-17.9,-0.7,0.32,0.32,0,0,0,-1.6,-2.6);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape_4.setTransform(-17.9,-19.5,0.32,0.32,0,0,0,-1.6,-2.1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#6FC699").s().p("Aj+klIH9ElIn9Emg");
	this.shape_5.setTransform(-24.4,-1,0.442,0.442,0,0,0,-1.7,-2.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#6FC699").s().p("Ajog5IgsAAIAAjsIGZDsIAsAAIBkA5In9Emg");
	this.shape_6.setTransform(2.6,0);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#6FC699").s().p("Aj8CSIAAkjIH5Ejg");
	this.shape_7.setTransform(-0.2,-14.8);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#6FC699").s().p("Aj+iUIH4AAIAFADIn9Elg");
	this.shape_8.setTransform(0,14.6);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#6FC699").s().p("AiODaIhwBBIAApMIBwBBIAABYIBcA0IAAhXIExCwIkxCwIAABYIhcA1g");
	this.shape_9.setTransform(-0.4,-7.2);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#6FC699").s().p("AjXj4IGvD4ImvD6g");
	this.shape_10.setTransform(3.9,0);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#6FC699").s().p("AixjMIFjDMIljDNg");
	this.shape_11.setTransform(7.7,0);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#6FC699").s().p("AiSipIElCpIklCqg");
	this.shape_12.setTransform(10.8,0);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#6FC699").s().p("Ahkh0IDJB0IjJB1g");
	this.shape_13.setTransform(15.4,0);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#6FC699").s().p("AhKhWICVBWIiVBXg");
	this.shape_14.setTransform(18,0);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#6FC699").s().p("Agvg2IBfA2IhfA3g");
	this.shape_15.setTransform(20.7,0);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_2,p:{regY:-2.1,y:-19.5,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.6,x:-17.9,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},7).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2.6,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:18.2,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},8).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2.6,y:-0.7,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:18.2,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},8).toE({state:[{t:this.shape_4,p:{regX:-1.6,regY:-2.1,scaleX:0.32,scaleY:0.32,x:-17.9,y:-19.5}},{t:this.shape_3,p:{regY:-2,y:18.2,regX:-1.6,scaleX:0.32,scaleY:0.32,x:-17.9}},{t:this.shape_2,p:{regY:-2,y:8.8,x:-1.6,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.1,x:-1.6,y:-10,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},7).toE({state:[{t:this.shape_2,p:{regY:-2,y:8.8,x:-1.6,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2.1,x:-1.6,y:-10,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},5).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape}]},5).toE({state:[]},7).toE({state:[{t:this.shape}]},14).toE({state:[{t:this.shape_2,p:{regY:-2.6,y:-0.7,x:-17.9,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape_1,p:{regY:-2,x:-1.6,y:8.8,regX:-1.6,scaleX:0.32,scaleY:0.32}},{t:this.shape}]},15).toE({state:[{t:this.shape_5,p:{scaleX:0.442,scaleY:0.442,x:-24.4,y:-1}},{t:this.shape_4,p:{regX:-1.8,regY:-2,scaleX:0.442,scaleY:0.442,x:-1.8,y:12.1}},{t:this.shape_3,p:{regY:-2.2,y:-13.9,regX:-1.8,scaleX:0.442,scaleY:0.442,x:-1.8}},{t:this.shape_2,p:{regY:-2,y:-0.8,x:20.7,regX:-1.7,scaleX:0.442,scaleY:0.442}},{t:this.shape_1,p:{regY:-2,x:-24.4,y:-26.7,regX:-1.7,scaleX:0.442,scaleY:0.442}},{t:this.shape}]},7).toE({state:[{t:this.shape_5,p:{scaleX:0.681,scaleY:0.681,x:-36.9,y:-1.6}},{t:this.shape_4,p:{regX:-1.8,regY:-2,scaleX:0.681,scaleY:0.681,x:-2.2,y:18.6}},{t:this.shape_3,p:{regY:-2.2,y:-21.6,regX:-1.8,scaleX:0.681,scaleY:0.681,x:-2.2}},{t:this.shape_2,p:{regY:-2,y:-1.2,x:32.6,regX:-1.7,scaleX:0.681,scaleY:0.681}},{t:this.shape_1,p:{regY:-2,x:-36.9,y:-41.2,regX:-1.7,scaleX:0.681,scaleY:0.681}},{t:this.shape}]},4).toE({state:[{t:this.shape}]},4).toE({state:[{t:this.shape_6}]},137).toE({state:[{t:this.shape}]},10).toE({state:[{t:this.shape_7}]},31).toE({state:[{t:this.shape_8}]},8).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape_9}]},100).toE({state:[{t:this.shape}]},6).toE({state:[{t:this.shape_9}]},24).toE({state:[{t:this.shape}]},5).toE({state:[{t:this.shape}]},47).toE({state:[{t:this.shape_10}]},7).toE({state:[{t:this.shape_11}]},9).toE({state:[{t:this.shape_12}]},8).toE({state:[{t:this.shape_13}]},6).toE({state:[{t:this.shape_14}]},6).toE({state:[{t:this.shape_15}]},4).toE({state:[]},42).waitE(167));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(7).toE({regY:-2,y:18.2},0).waitE(8).toE({regY:-2.1,x:-1.6,y:-10},0).waitE(15).toE({regY:-2,x:14.7,y:-0.6},0).waitE(16).toE({regX:0,regY:0,scaleX:0.5,scaleY:0.5,x:-3.7,y:0},0).toE({_off:true},7).waitE(14).toE({_off:false,regX:-1.6,regY:-2,scaleX:0.32,scaleY:0.32,x:14.7,y:-0.6},0).waitE(15).toE({regY:-2.1,x:-1.6,y:-10},0).waitE(7).toE({regX:-1.7,scaleX:0.44,scaleY:0.44,x:-24.4,y:25.2},0).waitE(4).toE({regY:-2.2,scaleX:0.68,scaleY:0.68,x:-36.9,y:38.8},0).waitE(4).toE({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0},0).toE({_off:true},137).waitE(10).toE({_off:false},0).toE({_off:true},31).waitE(14).toE({_off:false},0).toE({_off:true},100).waitE(6).toE({_off:false},0).toE({_off:true},24).waitE(5).toE({_off:false},0).waitE(47).toE({_off:true},7).waitE(242));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.6,-9.3,16.3,18.9);

(lib.sence6_movemnet_13 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_6();
	this.instance.parent = this;
	this.instance.setTransform(-106.2,-103,0.223,0.223,-1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-106.2,-106.7,212.5,213.4);


(lib.sence6_movemnet_12 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_6();
	this.instance.parent = this;
	this.instance.setTransform(-106.2,-103,0.223,0.223,-1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-106.2,-106.7,212.5,213.4);


(lib.sence6_movemnet_11 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_6();
	this.instance.parent = this;
	this.instance.setTransform(-144.2,-33.6,0.223,0.223,-32);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-144.2,-144.3,288.4,288.7);


(lib.sence6_movemnet_10 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_9();
	this.instance.parent = this;
	this.instance.setTransform(-96.2,-48.3,0.215,0.215);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-96.2,-48.3,192.4,96.8);


(lib.sence6_movemnet_9 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_9();
	this.instance.parent = this;
	this.instance.setTransform(-96.2,-48.4,0.215,0.215);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-96.2,-48.4,192.4,96.8);


(lib.sence6_movemnet_7 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_8();
	this.instance.parent = this;
	this.instance.setTransform(-125.9,-73,0.218,0.218);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-125.9,-73,251.8,146.1);


(lib.sence6_movemnet_6 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_8();
	this.instance.parent = this;
	this.instance.setTransform(-63.5,-36.8,0.11,0.11);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-63.5,-36.8,127,73.7);


(lib.sence6_movemnet_5 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_7();
	this.instance.parent = this;
	this.instance.setTransform(-47.9,-42.5,0.218,0.218);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.9,-42.5,95.9,85);


(lib.sence6_movemnet_4 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence6_bitmap_7();
	this.instance.parent = this;
	this.instance.setTransform(-47.9,-42.5,0.218,0.218);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.9,-42.5,95.9,85);

(lib.circle_green = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#6FC699").s().p("AgRASQgIgIABgKQgBgKAIgHQAHgIAKABQAKgBAIAIQAHAHAAAKQAAAKgHAIQgIAHgKAAQgKAAgHgHg");
	this.shape.setTransform(-0.1,-0.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#6FC699").s().p("AAMBpIAAAAIAAhJIgGADQgNAIgTABIgNAAIgCgYQgXgDgSgQQgRgPgFgWIBEgEIgBAAQgCgHABgHQgDghAVgYQAMgMAOgHIAKgEIAABiQAHgCAHAAQAVgBASAIIADAfQAKADAJAIQAJAIAGAJIhJADQALARABAVQABAggVAYIgKAKg");
	this.shape_1.setTransform(-1.5,2.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#6FC699").s().p("ADHDJIAAABIh7iHIgEAOQgOAnggAgQgNANgNAKIgrgpQguAgg8AAQg8AAgvghIB7h6IgDADQgPgKgNgNQg6g5AAhRQAAgpAQgkQAGgOAIgMICjC1QAKgOANgNQAkglAugOIA6AzQAagIAfAAQAcAAAZAHIiBB+QAwANAlAmQA5A5AABQQAAARgCARg");
	this.shape_2.setTransform(-0.9,1.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#6FC699").s().p("AAbE9QhMA0hhAAQhkAAhNg2IDLjIIgGAFQgXgRgXgWQhehdABiEQAAhfAvhLIBHBDQATgdAagaQA7g7BLgWIBcBSQArgMAxAAQAtAAApALIjQDNQBNAVA8A8QBcBbAACCQABAcgFAbIhahQQgQBehIBHQgVAWgYARg");
	this.shape_3.setTransform(-1.4,0.3);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#6FC699").s().p("ABaEoQheBBh6AAQh9AAhghEIIJoDQBgAaBMBLQBzBzAAChQAAAjgGAiIhwhkQgUB2haBZQgbAbgdAVgAlZC8QhzhzAAihQAAhzA6hbIBWBSQAXgjAgggQBJhJBbgaIBwBkQA1gPA7AAQA3AAAyANIoJIDQgdgUgbgbg");
	this.shape_4.setTransform(3.2,-2.1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#6FC699").s().p("AB3ELQhfBBh5AAQiiAAhzhzQhzhzAAihQAAhzA6hbIBWBSQAXgjAgggQBJhJBbgaIBxBkQA0gPA7AAQCiAABzByQBzBzAAChQAAAjgGAiIhwhkQgUB2haBZQgbAbgdAVg");
	this.shape_5.setTransform(1.4,-2.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#6FC699").s().p("AkpEDQhyhyAAihQAAhzA6hcIBWBTIAFgJIhDhDQAWgeAcgcQBJhJBbgaIAdAaQAzgOA4AAQCiAAByByQBzBzAAChQAAAjgFAiIgZgXQgVB0hYBXQgbAbgdAVIhXhTIBDBCQhgBBh5AAQiiAAhzhzg");
	this.shape_6.setTransform(0.3,-0.2);
	this.shape_6._off = true;

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#6FC699").s().p("AkUEUQhyhygBiiQABihByhzQBzhyChgBQCiABByByQB0BzgBChQABCih0ByQhyB0iigBQihABhzh0g");
	this.shape_7._off = true;

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#6FC699").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdIEZAAQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcg");
	this.shape_8.setTransform(0,0.3);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#6FC699").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQCMDUCNjUQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiDhxh6Bxg");
	this.shape_9.setTransform(0,0.3);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#6FC699").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQB8ILCdoLQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiIoVh1IVg");
	this.shape_10.setTransform(0,0.3);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#6FC699").s().p("AAeAJIAAg0QA2g/A5kGQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQgwkrgxg9gAkUESQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQA2EdA6AyQAFAEAFADIAAAfQgFAFgFAHQgwBIgyEYQhTgchDhDg");
	this.shape_11.setTransform(0,0.3);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#6FC699").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQgiFcAiFjQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQBGlQhGlYg");

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#6FC699").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQkvFKEvF1Qg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQEFlIkFlgg");

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#6FC699").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQmRFbGRFkQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQFqlMlqlcg");

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},3).toE({state:[{t:this.shape_4}]},3).toE({state:[{t:this.shape_5}]},3).toE({state:[{t:this.shape_6}]},3).toE({state:[{t:this.shape_7}]},3).toE({state:[{t:this.shape_6}]},44).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_6}]},226).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_6}]},110).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_6}]},161).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},26).toE({state:[{t:this.shape_9}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[{t:this.shape_14}]},2).toE({state:[]},2).waitE(92));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_6)).waitE(21).toE({_off:false},0).toE({_off:true},3).waitE(44).toE({_off:false},0).toE({_off:true},5).waitE(226).toE({_off:false},0).toE({_off:true},6).waitE(110).toE({_off:false},0).toE({_off:true},5).waitE(161).toE({_off:false},0).toE({_off:true},5).waitE(134));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_7)).waitE(24).toE({_off:false},0).toE({_off:true},44).waitE(5).toE({_off:false},0).toE({_off:true},226).waitE(6).toE({_off:false},0).toE({_off:true},110).waitE(5).toE({_off:false},0).toE({_off:true},161).waitE(5).toE({_off:false},0).toE({_off:true},26).waitE(108));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.6,-2.6,5.1,5.1);


(lib.triangle2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFC351").s().p("AgkgpIBJApIhJAqg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFC351").s().p("AhWhjICtBjIitBkg");

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFC351").s().p("AiLihIEXChIkXCig");
	this.shape_2._off = true;

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFC351").s().p("Ah4AEIggAAIAAilIEXChIgGAEIAgAAIkRCeg");
	this.shape_3.setTransform(-2.9,0);
	this.shape_3._off = true;

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFC351").s().p("Ag7hEIB3BEIh3BFg");

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},197).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},66).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},130).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},18).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},17).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},72).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},7).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_4}]},45).toE({state:[]},2).waitE(141));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_2)).waitE(5).toE({_off:false},0).toE({_off:true},197).waitE(3).toE({_off:false},0).toE({_off:true},66).waitE(2).toE({_off:false},0).toE({_off:true},130).waitE(3).toE({_off:false},0).toE({_off:true},18).waitE(3).toE({_off:false},0).toE({_off:true},17).waitE(3).toE({_off:false},0).toE({_off:true},72).waitE(3).toE({_off:false},0).toE({_off:true},7).waitE(3).toE({_off:false},0).toE({_off:true},45).waitE(143));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_3)).waitE(202).toE({_off:false},0).toE({_off:true},3).waitE(66).toE({_off:false},0).toE({_off:true},2).waitE(130).toE({_off:false},0).toE({_off:true},3).waitE(18).toE({_off:false},0).toE({_off:true},3).waitE(17).toE({_off:false},0).toE({_off:true},3).waitE(72).toE({_off:false},0).toE({_off:true},3).waitE(7).toE({_off:false},0).toE({_off:true},3).waitE(188));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);

(lib.triangle_green_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.trianlge_green();
	this.instance.parent = this;
	this.instance.setTransform(17.5,-0.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:60,x:38.4,y:-27},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.1,-9.4,16.4,18.9);

(lib.giftbox = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_3
	this.instance = new lib.sence6_movemnet_9("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(36.2,-107.6);
	this.instance._off = true;

	this.instance_1 = new lib.sence6_movemnet_10("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(125.2,39.4);
	this.instance_1._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(36).toE({_off:false},0).toE({_off:true,x:125.2,y:39.4},67).waitE(617));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).waitE(36).toE({_off:false},67).toE({x:126.1,y:65},256).waitE(131).toE({alpha:0.801},0).waitE(3).toE({alpha:0.602},0).waitE(3).toE({alpha:0.398},0).waitE(3).toE({alpha:0.199},0).toE({_off:true},3).waitE(218));

	// 圖層_4
	this.instance_2 = new lib.sence6_movemnet_11("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(-22.2,-132.4);
	this.instance_2._off = true;

	this.instance_3 = new lib.sence6_movemnet_12("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(9,-134);
	this.instance_3._off = true;

	this.instance_4 = new lib.sence6_movemnet_13("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(65.8,-19.3);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_2}]},25).toE({state:[{t:this.instance_3}]},8).toE({state:[{t:this.instance_4}]},20).toE({state:[]},547).waitE(120));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(25).toE({_off:false},0).toE({_off:true,x:9,y:-134},8).waitE(687));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(25).toE({_off:false},8).toE({_off:true,x:65.8,y:-19.3},20).waitE(667));

	// 圖層_5
	this.instance_5 = new lib.sence6_movemnet_6("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(-16.5,-82.1);
	this.instance_5._off = true;

	this.instance_6 = new lib.sence6_movemnet_7("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(-103.1,-63.9);
	this.instance_6._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_5)).waitE(34).toE({_off:false},0).toE({_off:true,x:-103.1,y:-63.9},19).waitE(667));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_6)).waitE(34).toE({_off:false},19).toE({x:-96,y:-14.2},50).toE({y:13},256).waitE(155).toE({alpha:0.801},0).waitE(3).toE({alpha:0.602},0).waitE(3).toE({alpha:0.398},0).waitE(3).toE({alpha:0.199},0).toE({_off:true},4).waitE(193));

	// 圖層_2
	this.instance_7 = new lib.sence6_movemnet_4("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(-30,-90.5);
	this.instance_7._off = true;

	this.instance_8 = new lib.sence6_movemnet_5("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(-100,27.5);
	this.instance_8._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_7)).waitE(27).toE({_off:false},0).toE({x:-97.1,y:-54.4},8).toE({_off:true,x:-100,y:27.5},12).waitE(673));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_8)).waitE(35).toE({_off:false},12).waitE(56).toE({startPosition:0},0).waitE(449).toE({alpha:0.801},0).waitE(3).toE({alpha:0.602},0).waitE(3).toE({alpha:0.398},0).waitE(3).toE({alpha:0.199},0).toE({_off:true},4).waitE(155));

	// 圖層_1
	this.instance_9 = new lib.sence6_bitmap_3();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-229,-411,2.46,2.46);

	this.instance_10 = new lib.sence6_bitmap_2();
	this.instance_10.parent = this;
	this.instance_10.setTransform(96,-232);

	this.instance_11 = new lib.sence6_bitmap_4();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-151,-267);

	this.instance_12 = new lib.sence6_bitmap_5();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-128,-133,0.233,0.233);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_10,p:{x:96,y:-232}},{t:this.instance_9,p:{scaleX:2.46,scaleY:2.46,x:-229,y:-411}}]},8).toE({state:[{t:this.instance_10,p:{x:-145,y:-258}},{t:this.instance_9,p:{scaleX:1.18,scaleY:1.18,x:-33,y:-287}}]},3).toE({state:[{t:this.instance_11}]},3).toE({state:[{t:this.instance_12}]},11).toE({state:[{t:this.instance_10,p:{x:-145,y:-258}},{t:this.instance_9,p:{scaleX:1.18,scaleY:1.18,x:-33,y:-287}}]},575).toE({state:[{t:this.instance_10,p:{x:-15,y:-286}},{t:this.instance_9,p:{scaleX:1,scaleY:1,x:-120,y:-203}}]},4).toE({state:[{t:this.instance_10,p:{x:-145,y:-231}},{t:this.instance_9,p:{scaleX:1,scaleY:1,x:-33,y:-279}}]},3).toE({state:[]},3).waitE(110));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.circle_green_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle_green();
	this.instance.parent = this;
	this.instance.setTransform(0.1,-0.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:80,x:31.2,y:23.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.5,-2.7,5.1,5.1);

(lib.rect_green = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#6FC699").s().p("AgSAAIASgQIATARIgSAQg");
	this.shape.setTransform(0,-48.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#6FC699").s().p("AglgSIASgSIA5A5IgSAQg");
	this.shape_1.setTransform(2,-46.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#6FC699").s().p("Ag4gmIASgRIBfBgIgRAPg");
	this.shape_2.setTransform(3.9,-45);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#6FC699").s().p("AhMg6IATgRICGCIIgSAPg");
	this.shape_3.setTransform(5.8,-43);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#6FC699").s().p("AhfhNIASgSICtCwIgSAPg");
	this.shape_4.setTransform(7.8,-41);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#6FC699").s().p("AhzhhIATgRIDTDXIgRAOg");
	this.shape_5.setTransform(9.7,-39.1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#6FC699").s().p("AiGh1IATgRID6D/IgSAOg");
	this.shape_6.setTransform(11.7,-37.1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#6FC699").s().p("AiaiIIATgSIEiEnIgSAOg");
	this.shape_7.setTransform(13.6,-35.1);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#6FC699").s().p("AiticIATgRIFIFOIgSANg");
	this.shape_8.setTransform(15.5,-33.2);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#6FC699").s().p("AjAiwIASgRIFvF2IgRANg");
	this.shape_9.setTransform(17.5,-31.2);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#6FC699").s().p("AjOioIAogmIF1F6IgnAkg");
	this.shape_10.setTransform(16.7,-29.8);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#6FC699").s().p("AjcigIA9g8IF7GBIg7A4g");
	this.shape_11.setTransform(16,-28.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#6FC699").s().p("AjpiYIBShSIGBGHIhRBOg");
	this.shape_12.setTransform(15.2,-27.1);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#6FC699").s().p("Aj3iRIBohmIGHGMIhnBjg");
	this.shape_13.setTransform(14.4,-25.8);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#6FC699").s().p("AkEiJIB8h8IGNGSIh7B5g");
	this.shape_14.setTransform(13.7,-24.4);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#6FC699").s().p("AkSiBICSiRIGTGXIiRCPg");
	this.shape_15.setTransform(12.9,-23);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#6FC699").s().p("Akgh5ICninIGaGdIinCkg");
	this.shape_16.setTransform(12.2,-21.7);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#6FC699").s().p("AkthyIC8i7IGfGjIi7C4g");
	this.shape_17.setTransform(11.4,-20.3);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#6FC699").s().p("Ak7hqIDSjRIGlGpIjRDOg");
	this.shape_18.setTransform(10.6,-19);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#6FC699").s().p("AlIhjIDmjmIGrGvIjmDkg");
	this.shape_19.setTransform(9.9,-17.6);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#6FC699").s().p("AlWhbID8j7IGxG0Ij7D5g");
	this.shape_20.setTransform(9.1,-16.3);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#6FC699").s().p("AlkhTIERkRIG4G7IkREOg");
	this.shape_21.setTransform(8.4,-14.9);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#6FC699").s().p("AlxhMIEmklIG9HAIkmEjg");
	this.shape_22.setTransform(7.6,-13.5);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#6FC699").s().p("Al/hEIE7k7IHEHGIk8E5g");
	this.shape_23.setTransform(6.9,-12.2);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#6FC699").s().p("AmNg8IFRlRIHKHMIlRFPg");
	this.shape_24.setTransform(6.1,-10.8);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#6FC699").s().p("Amag1IFmllIHPHRIlmFkg");
	this.shape_25.setTransform(5.3,-9.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#6FC699").s().p("AmogtIF7l7IHWHXIl7F6g");
	this.shape_26.setTransform(4.6,-8.1);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#6FC699").s().p("Am2glIGRmQIHbHdImQGOg");
	this.shape_27.setTransform(3.8,-6.8);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#6FC699").s().p("AnDgeIGlmlIHiHiImlGlg");
	this.shape_28.setTransform(3.1,-5.4);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#6FC699").s().p("AnRgWIG7m6IHoHoIm7G5g");
	this.shape_29.setTransform(2.3,-4);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#6FC699").s().p("AnegOIHQnQIHtHuInQHPg");
	this.shape_30.setTransform(1.5,-2.7);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#6FC699").s().p("AnsgHIHlnlIH0H0InlHlg");
	this.shape_31.setTransform(0.8,-1.3);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#6FC699").s().p("An6AAIH6n5IH7H5In7H6g");
	this.shape_32._off = true;

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#6FC699").s().p("AoJgOIDRjRIjfjbIAwgvIDfDaICvivIBOBJIAogqIH7H6Ig7A7IhOhJIiZCZIjfjbIgwAxIDeDaIjTDVg");
	this.shape_33.setTransform(1.5,1.6);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#6FC699").s().p("AgMFmIgYAXIn6n5IBIhIIBxB1IGKmLIH6H6Im6G7g");
	this.shape_34.setTransform(0.5,1.1);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#6FC699").s().p("AjiEYICFiAIgkglIIAnzIBDBDIiFCBIC+C8In7H6gAn6AAIH6n5IDeDeIoAHzg");
	this.shape_35.setTransform(0,-6);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#6FC699").s().p("AklAAIH6n5IBQBQIAANTIhQBQg");
	this.shape_36.setTransform(-21.3,-5.4);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#6FC699").s().p("AlXFGIAAqKIC1i1IH6H5In6H6g");
	this.shape_37.setTransform(16.3,6);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#6FC699").s().p("An6AAIDCjAIJxAAIDCDAIn7H6gAjCk2IDCjDIDDDDg");
	this.shape_38.setTransform(0,4.8);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#6FC699").s().p("AltCMILbAAIluFugAnWAkIgkgkIH6n5IH7H5IgkAkg");
	this.shape_39.setTransform(0,12);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#6FC699").s().p("An6ibIDCjCIJxAAIDCDCIn7H5g");
	this.shape_40.setTransform(0,15.7);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#6FC699").s().p("AknibIDBjCIGOAAIAAJlIhWBWg");
	this.shape_41.setTransform(-21,15.7);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#6FC699").s().p("AivCdIh4h4IDBjBIGOAAIAAE5g");
	this.shape_42.setTransform(-21,-3.6);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#6FC699").s().p("Ai5CdIAAk5IFzAAIAAE5g");
	this.shape_43.setTransform(-10,-3.6);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#6FC699").s().p("AA0CdIAAk5ICGAAIAAE5gAi5CdIAAk5ICWAAIAAE5g");
	this.shape_44.setTransform(-10,-3.6);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#6FC699").s().p("Ah+CAIAAj/ID9AAIAAD/g");
	this.shape_45.setTransform(-4.1,-0.8);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},1).toE({state:[{t:this.shape_2}]},1).toE({state:[{t:this.shape_3}]},1).toE({state:[{t:this.shape_4}]},1).toE({state:[{t:this.shape_5}]},1).toE({state:[{t:this.shape_6}]},1).toE({state:[{t:this.shape_7}]},1).toE({state:[{t:this.shape_8}]},1).toE({state:[{t:this.shape_9}]},1).toE({state:[{t:this.shape_10}]},1).toE({state:[{t:this.shape_11}]},1).toE({state:[{t:this.shape_12}]},1).toE({state:[{t:this.shape_13}]},1).toE({state:[{t:this.shape_14}]},1).toE({state:[{t:this.shape_15}]},1).toE({state:[{t:this.shape_16}]},1).toE({state:[{t:this.shape_17}]},1).toE({state:[{t:this.shape_18}]},1).toE({state:[{t:this.shape_19}]},1).toE({state:[{t:this.shape_20}]},1).toE({state:[{t:this.shape_21}]},1).toE({state:[{t:this.shape_22}]},1).toE({state:[{t:this.shape_23}]},1).toE({state:[{t:this.shape_24}]},1).toE({state:[{t:this.shape_25}]},1).toE({state:[{t:this.shape_26}]},1).toE({state:[{t:this.shape_27}]},1).toE({state:[{t:this.shape_28}]},1).toE({state:[{t:this.shape_29}]},1).toE({state:[{t:this.shape_30}]},1).toE({state:[{t:this.shape_31}]},1).toE({state:[{t:this.shape_32}]},1).toE({state:[{t:this.shape_33}]},13).toE({state:[{t:this.shape_32}]},7).toE({state:[{t:this.shape_34}]},12).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_35,p:{y:-6}}]},35).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_35,p:{y:9}}]},13).toE({state:[{t:this.shape_32}]},3).toE({state:[{t:this.shape_35,p:{y:-4.3}}]},4).toE({state:[{t:this.shape_32}]},8).toE({state:[{t:this.shape_36}]},208).toE({state:[{t:this.shape_37}]},4).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_38}]},35).toE({state:[{t:this.shape_39}]},4).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_40}]},128).toE({state:[{t:this.shape_41}]},65).toE({state:[{t:this.shape_42}]},25).toE({state:[{t:this.shape_43}]},25).toE({state:[{t:this.shape_44}]},14).toE({state:[{t:this.shape_45}]},6).toE({state:[]},11).waitE(48));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_32)).waitE(32).toE({_off:false},0).toE({_off:true},13).waitE(7).toE({_off:false},0).toE({_off:true},12).waitE(5).toE({_off:false},0).toE({_off:true},35).waitE(5).toE({_off:false},0).toE({_off:true},13).waitE(3).toE({_off:false},0).toE({_off:true},4).waitE(8).toE({_off:false},0).toE({_off:true},208).waitE(9).toE({_off:false},0).toE({_off:true},35).waitE(9).toE({_off:false},0).toE({_off:true},128).waitE(194));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.8,-50.6,3.7,3.4);

(lib.rect_green_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rect_green();
	this.instance.parent = this;
	this.instance.setTransform(-2.9,33.7);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-30,x:7.7,y:53.3},239).toE({regX:-0.1,regY:0.1,scaleX:1,scaleY:1,rotation:-90,x:-8.4,y:44.1},183).toE({scaleX:1,scaleY:1,rotation:-180,x:-18.9,y:38.1},117).toE({scaleX:1,scaleY:1,rotation:-200,x:-34.7,y:28.7},180).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.8,-16.9,3.7,3.4);


(lib.triangle_red = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6647C").s().p("AgkgpIBJApIhJAqg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E6647C").s().p("AhWhjICtBjIitBkg");

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#E6647C").s().p("AiLihIEXChIkXCig");
	this.shape_2._off = true;

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#E6647C").s().p("Ah4AEIggAAIAAilIEXChIgGAEIAgAAIkRCeg");
	this.shape_3.setTransform(-2.9,0);
	this.shape_3._off = true;

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#E6647C").s().p("Ag7hEIB3BEIh3BFg");

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},197).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},66).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},130).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},18).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},17).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},72).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},7).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_4}]},45).toE({state:[]},2).waitE(141));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_2)).waitE(5).toE({_off:false},0).toE({_off:true},197).waitE(3).toE({_off:false},0).toE({_off:true},66).waitE(2).toE({_off:false},0).toE({_off:true},130).waitE(3).toE({_off:false},0).toE({_off:true},18).waitE(3).toE({_off:false},0).toE({_off:true},17).waitE(3).toE({_off:false},0).toE({_off:true},72).waitE(3).toE({_off:false},0).toE({_off:true},7).waitE(3).toE({_off:false},0).toE({_off:true},45).waitE(143));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_3)).waitE(202).toE({_off:false},0).toE({_off:true},3).waitE(66).toE({_off:false},0).toE({_off:true},2).waitE(130).toE({_off:false},0).toE({_off:true},3).waitE(18).toE({_off:false},0).toE({_off:true},3).waitE(17).toE({_off:false},0).toE({_off:true},3).waitE(72).toE({_off:false},0).toE({_off:true},3).waitE(7).toE({_off:false},0).toE({_off:true},3).waitE(188));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);

(lib.triangle_blue = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#29BCD0").s().p("AgLAMQgFgFAAgHQAAgGAFgFQAFgFAGAAQAHAAAFAFQAFAFAAAGQAAAHgFAFQgFAFgHAAQgGAAgFgFg");
	this.shape.setTransform(0.4,7.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#29BCD0").s().p("AAjE0IAlg/ICcA/gADjDiIiWg8IAgg3ICTBMIAWAngAkWjnIArhMIBRCMg");
	this.shape_1.setTransform(4,3.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#29BCD0").s().p("AiNE2IA6hmID6BmgAC0ELIkHhqIA4hhIECCGIAnBFgAkOiJIBjirIC2E8g");
	this.shape_2.setTransform(4,0.3);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#29BCD0").s().p("AkmE0IBcieIGICegACfEQImIieIBTiOIGCDGIA6BmgAjChIICIjrID5Gxg");
	this.shape_3.setTransform(1.6,-0.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#29BCD0").s().p("Ak1EMIE2oXIE1IXg");
	this.shape_4._off = true;

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#29BCD0").s().p("AkhEYICFjlIgpgXICzkzIE0IYIhnAAIAmAXg");
	this.shape_5.setTransform(0.1,-1.5);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#29BCD0").s().p("AgnCHIiCjRIAig8IERAGIAhA4Ih3DPg");
	this.shape_6.setTransform(0.1,11.9);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#29BCD0").s().p("AkjD9IBzjHIB9DHgABSD3IBoi4IBqC4gAh3gmIB7jWIB/Dcg");
	this.shape_7.setTransform(-0.3,0.3);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#29BCD0").s().p("AgaBdIhbiQIAYgqIC8AFIAXAmIhRCPg");
	this.shape_8.setTransform(0.1,9.8);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#29BCD0").s().p("AkADWIBPiIIBUCIgABwDTIBIh/IBJB/gAhFhZIBHh8IBKB/g");
	this.shape_9.setTransform(-0.1,1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#29BCD0").s().p("AgOA0IgyhQIANgXIBoADIAMAVIgtBPg");
	this.shape_10.setTransform(0.4,7.8);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#29BCD0").s().p("ACIC7IAqhLIArBLgAjcC1IAnhDIAqBDgAgshwIAqhKIAqBMg");
	this.shape_11.setTransform(0.5,0.9);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},4).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},3).toE({state:[{t:this.shape_4}]},5).toE({state:[{t:this.shape_5}]},267).toE({state:[{t:this.shape_4}]},7).toE({state:[{t:this.shape_5}]},61).toE({state:[{t:this.shape_4}]},5).toE({state:[{t:this.shape_5}]},60).toE({state:[{t:this.shape_4}]},6).toE({state:[{t:this.shape_5}]},41).toE({state:[{t:this.shape_4}]},5).toE({state:[{t:this.shape_4}]},105).toE({state:[{t:this.shape_7},{t:this.shape_6}]},3).toE({state:[{t:this.shape_9},{t:this.shape_8}]},3).toE({state:[{t:this.shape_11},{t:this.shape_10}]},2).toE({state:[]},2).waitE(138));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_4)).waitE(15).toE({_off:false},0).toE({_off:true},267).waitE(7).toE({_off:false},0).toE({_off:true},61).waitE(5).toE({_off:false},0).toE({_off:true},60).waitE(6).toE({_off:false},0).toE({_off:true},41).waitE(5).toE({_off:false},0).waitE(105).toE({_off:true},3).waitE(145));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.3,5.9,3.4,3.4);

(lib.rect1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#6552AB").s().p("AgSAAIASgQIATARIgSAQg");
	this.shape.setTransform(0,-48.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#6552AB").s().p("AglgSIASgSIA5A5IgSAQg");
	this.shape_1.setTransform(2,-46.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#6552AB").s().p("Ag4gmIASgRIBfBgIgRAPg");
	this.shape_2.setTransform(3.9,-45);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#6552AB").s().p("AhMg6IATgRICGCIIgSAPg");
	this.shape_3.setTransform(5.8,-43);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#6552AB").s().p("AhfhNIASgSICtCwIgSAPg");
	this.shape_4.setTransform(7.8,-41);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#6552AB").s().p("AhzhhIATgRIDTDXIgRAOg");
	this.shape_5.setTransform(9.7,-39.1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#6552AB").s().p("AiGh1IATgRID6D/IgSAOg");
	this.shape_6.setTransform(11.7,-37.1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#6552AB").s().p("AiaiIIATgSIEiEnIgSAOg");
	this.shape_7.setTransform(13.6,-35.1);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#6552AB").s().p("AiticIATgRIFIFOIgSANg");
	this.shape_8.setTransform(15.5,-33.2);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#6552AB").s().p("AjAiwIASgRIFvF2IgRANg");
	this.shape_9.setTransform(17.5,-31.2);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#6552AB").s().p("AjOioIAogmIF1F6IgnAkg");
	this.shape_10.setTransform(16.7,-29.8);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#6552AB").s().p("AjcigIA9g8IF7GBIg7A4g");
	this.shape_11.setTransform(16,-28.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#6552AB").s().p("AjpiYIBShSIGBGHIhRBOg");
	this.shape_12.setTransform(15.2,-27.1);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#6552AB").s().p("Aj3iRIBohmIGHGMIhnBjg");
	this.shape_13.setTransform(14.4,-25.8);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#6552AB").s().p("AkEiJIB8h8IGNGSIh7B5g");
	this.shape_14.setTransform(13.7,-24.4);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#6552AB").s().p("AkSiBICSiRIGTGXIiRCPg");
	this.shape_15.setTransform(12.9,-23);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#6552AB").s().p("Akgh5ICninIGaGdIinCkg");
	this.shape_16.setTransform(12.2,-21.7);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#6552AB").s().p("AkthyIC8i7IGfGjIi7C4g");
	this.shape_17.setTransform(11.4,-20.3);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#6552AB").s().p("Ak7hqIDSjRIGlGpIjRDOg");
	this.shape_18.setTransform(10.6,-19);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#6552AB").s().p("AlIhjIDmjmIGrGvIjmDkg");
	this.shape_19.setTransform(9.9,-17.6);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#6552AB").s().p("AlWhbID8j7IGxG0Ij7D5g");
	this.shape_20.setTransform(9.1,-16.3);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#6552AB").s().p("AlkhTIERkRIG4G7IkREOg");
	this.shape_21.setTransform(8.4,-14.9);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#6552AB").s().p("AlxhMIEmklIG9HAIkmEjg");
	this.shape_22.setTransform(7.6,-13.5);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#6552AB").s().p("Al/hEIE7k7IHEHGIk8E5g");
	this.shape_23.setTransform(6.9,-12.2);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#6552AB").s().p("AmNg8IFRlRIHKHMIlRFPg");
	this.shape_24.setTransform(6.1,-10.8);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#6552AB").s().p("Amag1IFmllIHPHRIlmFkg");
	this.shape_25.setTransform(5.3,-9.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#6552AB").s().p("AmogtIF7l7IHWHXIl7F6g");
	this.shape_26.setTransform(4.6,-8.1);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#6552AB").s().p("Am2glIGRmQIHbHdImQGOg");
	this.shape_27.setTransform(3.8,-6.8);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#6552AB").s().p("AnDgeIGlmlIHiHiImlGlg");
	this.shape_28.setTransform(3.1,-5.4);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#6552AB").s().p("AnRgWIG7m6IHoHoIm7G5g");
	this.shape_29.setTransform(2.3,-4);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#6552AB").s().p("AnegOIHQnQIHtHuInQHPg");
	this.shape_30.setTransform(1.5,-2.7);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#6552AB").s().p("AnsgHIHlnlIH0H0InlHlg");
	this.shape_31.setTransform(0.8,-1.3);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#6552AB").s().p("An6AAIH6n5IH7H5In7H6g");
	this.shape_32._off = true;

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#653AB6").s().p("ACZDRIm6mgIAhgiIApgpIH5H6Ig6A7g");
	this.shape_33.setTransform(26.1,-11.6);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#6552AB").s().p("AnEgOIDQjRIjejbIAvgvIDfDaICwivIBMBJIghAhIG8GhIiZCZIjfjbIgwAxIDeDaIjUDVg");
	this.shape_34.setTransform(-5.3,1.6);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#6538B8").s().p("AjoinIA/g/IGSGFIhMBHg");
	this.shape_35.setTransform(10.3,-12.4);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#6552AB").s().p("AgMFmIgYAXIn6n5IBIhIIBxB1IDfjeIGFGNIBMhHImSmFIBshuIH6H6Im6G7g");
	this.shape_36.setTransform(0.5,1.1);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#6537B0").s().p("Aj9D/IgkglIIAnzIBDBDIiFCBIl/Fvg");
	this.shape_37.setTransform(16,-16.3);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#6552AB").s().p("AjiEYICFiAIAbAbIF/lvIC+C8In7H6gAn6AAIH6n5IDeDeIoAHzg");
	this.shape_38.setTransform(0,-6);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#6552AB").s().p("AklAAIH6n5IBQBQIAANTIhQBQg");
	this.shape_39.setTransform(-21.3,-5.4);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#6552AB").s().p("AlXFGIAAqKIC1i1IH6H5In6H6g");
	this.shape_40.setTransform(16.3,6);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#6552AB").s().p("An6AAIDCjAIJxAAIDCDAIn7H6gAjCk2IDCjDIDDDDg");
	this.shape_41.setTransform(0,4.8);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#6552AB").s().p("AltCMILbAAIluFugAnWAkIgkgkIH6n5IH7H5IgkAkg");
	this.shape_42.setTransform(0,12);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#6552AB").s().p("An6ibIDCjCIJxAAIDCDCIn7H5g");
	this.shape_43.setTransform(0,15.7);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#6552AB").s().p("AknibIDBjCIGOAAIAAJlIhWBWg");
	this.shape_44.setTransform(-21,15.7);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#6552AB").s().p("AivCdIh4h4IDBjBIGOAAIAAE5g");
	this.shape_45.setTransform(-21,-3.6);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#6552AB").s().p("Ai5CdIAAk5IFzAAIAAE5g");
	this.shape_46.setTransform(-10,-3.6);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#6552AB").s().p("AA0CdIAAk5ICGAAIAAE5gAi5CdIAAk5ICWAAIAAE5g");
	this.shape_47.setTransform(-10,-3.6);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#6552AB").s().p("Ah+CAIAAj/ID9AAIAAD/g");
	this.shape_48.setTransform(-4.1,-0.8);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},1).toE({state:[{t:this.shape_2}]},1).toE({state:[{t:this.shape_3}]},1).toE({state:[{t:this.shape_4}]},1).toE({state:[{t:this.shape_5}]},1).toE({state:[{t:this.shape_6}]},1).toE({state:[{t:this.shape_7}]},1).toE({state:[{t:this.shape_8}]},1).toE({state:[{t:this.shape_9}]},1).toE({state:[{t:this.shape_10}]},1).toE({state:[{t:this.shape_11}]},1).toE({state:[{t:this.shape_12}]},1).toE({state:[{t:this.shape_13}]},1).toE({state:[{t:this.shape_14}]},1).toE({state:[{t:this.shape_15}]},1).toE({state:[{t:this.shape_16}]},1).toE({state:[{t:this.shape_17}]},1).toE({state:[{t:this.shape_18}]},1).toE({state:[{t:this.shape_19}]},1).toE({state:[{t:this.shape_20}]},1).toE({state:[{t:this.shape_21}]},1).toE({state:[{t:this.shape_22}]},1).toE({state:[{t:this.shape_23}]},1).toE({state:[{t:this.shape_24}]},1).toE({state:[{t:this.shape_25}]},1).toE({state:[{t:this.shape_26}]},1).toE({state:[{t:this.shape_27}]},1).toE({state:[{t:this.shape_28}]},1).toE({state:[{t:this.shape_29}]},1).toE({state:[{t:this.shape_30}]},1).toE({state:[{t:this.shape_31}]},1).toE({state:[{t:this.shape_32}]},1).toE({state:[{t:this.shape_34},{t:this.shape_33}]},13).toE({state:[{t:this.shape_32}]},7).toE({state:[{t:this.shape_36},{t:this.shape_35}]},12).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_38,p:{y:-6}},{t:this.shape_37,p:{y:-16.3}}]},35).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_38,p:{y:9}},{t:this.shape_37,p:{y:-1.3}}]},13).toE({state:[{t:this.shape_32}]},3).toE({state:[{t:this.shape_38,p:{y:-4.3}},{t:this.shape_37,p:{y:-14.6}}]},4).toE({state:[{t:this.shape_32}]},8).toE({state:[{t:this.shape_39}]},208).toE({state:[{t:this.shape_40}]},4).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_41}]},35).toE({state:[{t:this.shape_42}]},4).toE({state:[{t:this.shape_32}]},5).toE({state:[{t:this.shape_43}]},128).toE({state:[{t:this.shape_44}]},65).toE({state:[{t:this.shape_45}]},25).toE({state:[{t:this.shape_46}]},25).toE({state:[{t:this.shape_47}]},14).toE({state:[{t:this.shape_48}]},6).toE({state:[]},11).waitE(48));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_32)).waitE(32).toE({_off:false},0).toE({_off:true},13).waitE(7).toE({_off:false},0).toE({_off:true},12).waitE(5).toE({_off:false},0).toE({_off:true},35).waitE(5).toE({_off:false},0).toE({_off:true},13).waitE(3).toE({_off:false},0).toE({_off:true},4).waitE(8).toE({_off:false},0).toE({_off:true},208).waitE(9).toE({_off:false},0).toE({_off:true},35).waitE(9).toE({_off:false},0).toE({_off:true},128).waitE(194));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.8,-50.6,3.7,3.4);

(lib.rect2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFC351").s().p("AgmApIAAhRIBNAAIAABRg");
	this.shape.setTransform(3.8,-3.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFC351").s().p("AhVBXIAAisIACgBICoCpIgEAEg");
	this.shape_1.setTransform(8.4,-8.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFC351").s().p("AhVCoIAAlPIACgBICoCoIioCpg");
	this.shape_2.setTransform(8.4,0);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFC351").s().p("AjMAAIDMjMIDNDMIjNDNg");

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFC351").s().p("ArNAAILNrNILOLNIrOLOg");

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFC351").s().p("AoAAAIIAoAIIBIAIoBIBg");
	this.shape_5._off = true;

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFC351").s().p("AoPhEID6j7IIBIAIj6D7gAiwjdIDdjeIBRAAIGSGSIAACNIi/C/g");
	this.shape_6.setTransform(-2.7,-1.2);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFC351").s().p("AoGhZIJYmWIA4BRIipNmIhRA3gACon+IFfIHIoHFeg");
	this.shape_7.setTransform(1,4.5);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFC351").s().p("AnsgOIHZnZIIAIAInPHPg");
	this.shape_8.setTransform(2,-2.5);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFC351").s().p("AnKgyIGVmVIIAIBImOGNg");
	this.shape_9.setTransform(5.4,-5.7);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFC351").s().p("AkpChIAAn0IBThUIIAIAIlNFPg");
	this.shape_10.setTransform(21.5,-8.9);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFC351").s().p("AkcBdIAAmqIA5g5IIAIAIkNENg");
	this.shape_11.setTransform(22.8,-12.2);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFC351").s().p("AjDAvIAAl+IGHGIIAAC2IhgBhg");
	this.shape_12.setTransform(23.4,-14.8);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFC351").s().p("AhXAlIAAjzICvCwIAADtg");
	this.shape_13.setTransform(29.5,-9.9);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFC351").s().p("AgnAMIAAhoIBQBRIAABog");
	this.shape_14.setTransform(37,-9.1);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},31).toE({state:[{t:this.shape_2}]},39).toE({state:[{t:this.shape_3}]},16).toE({state:[{t:this.shape_4}]},11).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},68).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},44).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},18).toE({state:[{t:this.shape_5}]},5).toE({state:[{t:this.shape_7}]},110).toE({state:[{t:this.shape_5}]},6).toE({state:[{t:this.shape_7}]},36).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},87).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_8}]},47).toE({state:[{t:this.shape_8}]},2).toE({state:[{t:this.shape_9}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[{t:this.shape_14}]},2).toE({state:[]},2).waitE(166));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_5)).waitE(101).toE({_off:false},0).toE({_off:true},68).waitE(4).toE({_off:false},0).toE({_off:true},44).waitE(4).toE({_off:false},0).toE({_off:true},18).waitE(5).toE({_off:false},0).toE({_off:true},110).waitE(6).toE({_off:false},0).toE({_off:true},36).waitE(4).toE({_off:false},0).toE({_off:true},87).waitE(4).toE({_off:false},0).toE({_off:true},47).waitE(182));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.1,-7.7,7.8,8.2);

(lib.rect3 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// flash0.ai
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#29BCD0").s().p("AkAEBIAAoCIIBAAIAAICg");
	this.shape.setTransform(-0.3,-33.5,0.43,0.43,45,0,0,0,-0.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#29BCD0").s().p("AkAEBIAAoCIIBAAIAAICg");
	this.shape_1.setTransform(-0.3,-33.5,0.43,0.43,45,0,0,0,-0.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#29BCD0").s().p("AkAEBIAAoCIICAAIAAICg");
	this.shape_2.setTransform(33.2,0.1,0.43,0.43,45,0,0,0,-0.2);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#29BCD0").s().p("AkAECIAAoCIICAAIAAICg");
	this.shape_3.setTransform(16.3,17,0.43,0.43,45);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#29BCD0").s().p("AkAECIAAoDIICAAIAAIDg");
	this.shape_4.setTransform(-0.5,33.8,0.43,0.43,45,0,0,0,-0.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#29BCD0").s().p("AkAECIAAoDIIBAAIAAIDg");
	this.shape_5.setTransform(-17.3,17,0.43,0.43,45,0,0,0,-0.2);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#29BCD0").s().p("AkAECIAAoDIIBAAIAAIDg");
	this.shape_6.setTransform(-34.1,0.1,0.43,0.43,45,0,0,-0.1,-0.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#29BCD0").s().p("AkAECIAAoCIIBAAIAAICg");
	this.shape_7.setTransform(-0.4,0.1,0.43,0.43,45,0,0,-0.1,-0.2);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#29BCD0").s().p("AkAECIAAoCIIBAAIAAICg");
	this.shape_8.setTransform(-17.2,-16.7,0.43,0.43,45,0,0,-0.1,-0.2);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#29BCD0").s().p("AiKFjIArgsIigihIg+A+IjBjBIDBjAIARASICRiRIgSgRIDAjBIC6C6IApgpICcCcIiTCUIALALIBZhYICcCbIiPCPIAaAaIjPDQIgagaIiQCPg");
	this.shape_9.setTransform(-2.3,-4.9);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape,p:{x:-0.3,y:-33.5,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}}]}).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,y:-39.2,regX:0}},{t:this.shape,p:{x:19.3,y:-19.6,regY:-0.1,scaleX:0.503,scaleY:0.503,regX:0}},{t:this.shape_2,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,x:39,y:0,regX:0}},{t:this.shape_8,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,x:-20.1,y:-19.5,regX:-0.1}},{t:this.shape_7,p:{regX:-0.2,regY:-0.1,scaleX:0.503,scaleY:0.503}},{t:this.shape_3,p:{scaleX:0.503,scaleY:0.503,x:19.2,y:19.8,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.2,scaleX:0.503,scaleY:0.503,x:-39.8,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.503,scaleY:0.503,x:-20.1,y:19.9,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.503,scaleY:0.503,x:-0.4,y:39.5,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},4).toE({state:[{t:this.shape_9}]},59).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},5).toE({state:[{t:this.shape_9}]},62).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},6).toE({state:[{t:this.shape_9}]},142).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},6).toE({state:[{t:this.shape_1,p:{regY:-0.3,scaleX:0.46,scaleY:0.46,y:-33.5,regX:-0.2}},{t:this.shape,p:{x:16.5,y:-16.7,regY:-0.1,scaleX:0.46,scaleY:0.46,regX:0}},{t:this.shape_2,p:{regY:-0.1,scaleX:0.46,scaleY:0.46,x:33.2,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.1,scaleX:0.46,scaleY:0.46,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.2,regY:-0.1,scaleX:0.46,scaleY:0.46}},{t:this.shape_3,p:{scaleX:0.46,scaleY:0.46,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.46,scaleY:0.46,x:-34,regX:-0.2}},{t:this.shape_5,p:{scaleX:0.46,scaleY:0.46,x:-17.2,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.46,scaleY:0.46,x:-0.5,y:33.8,regX:-0.1,regY:-0.2}}]},158).toE({state:[{t:this.shape_1,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,y:-33.5,regX:-0.1}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.3,scaleX:0.44,scaleY:0.44,regX:-0.1}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.44,scaleY:0.44,x:33.2,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,x:-17.2,y:-16.7,regX:-0.2}},{t:this.shape_7,p:{regX:-0.1,regY:-0.3,scaleX:0.44,scaleY:0.44}},{t:this.shape_3,p:{scaleX:0.44,scaleY:0.44,x:16.4,y:17,regY:-0.1,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,x:-34,regX:-0.2}},{t:this.shape_5,p:{scaleX:0.44,scaleY:0.44,x:-17.3,y:17,regX:-0.1,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.44,scaleY:0.44,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},4).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.22,scaleY:0.22,x:-17.3,y:17,regX:-0.3,regY:-0.1}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},15).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.22,scaleY:0.22,x:33.3,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.4,scaleX:0.22,scaleY:0.22,x:-17.2,y:-16.7,regX:-0.2}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},51).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.22,scaleY:0.22,y:-33.5,regX:-0.2}},{t:this.shape,p:{x:16.5,y:-16.7,regY:-0.2,scaleX:0.22,scaleY:0.22,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},37).toE({state:[{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_7,p:{regX:-0.3,regY:-0.3,scaleX:0.22,scaleY:0.22}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},31).toE({state:[{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_3,p:{scaleX:0.22,scaleY:0.22,x:16.4,y:16.9,regY:-0.3,regX:-0.3}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},6).toE({state:[{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_5,p:{scaleX:0.22,scaleY:0.22,x:-34.1,y:0.1,regX:-0.2,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:-0.3,regY:-0.3}}]},11).toE({state:[{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_4,p:{scaleX:0.22,scaleY:0.22,x:-0.4,y:33.8,regX:-0.1,regY:-0.3}}]},29).toE({state:[]},3).waitE(54));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16,-49.1,31.3,31.3);

(lib.orange_slide = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.single_phone_bitmap8();
	this.instance.parent = this;
	this.instance.setTransform(-83,-56);

	this.instance_1 = new lib.single_phone_bitmap9();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-84,-44);

	this.instance_2 = new lib.single_phone_bitmap10();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1,-35);

	this.instance_3 = new lib.single_phone_bitmap14();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-82,-50,0.33,0.33);

	this.instance_4 = new lib.single_phone_bitmap13();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-85,-60);

	this.instance_5 = new lib.single_phone_bitmap12();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-2,-48);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance}]}).toE({state:[]},15).toE({state:[{t:this.instance}]},6).toE({state:[]},7).toE({state:[{t:this.instance}]},11).toE({state:[{t:this.instance_1},{t:this.instance}]},9).toE({state:[{t:this.instance_1},{t:this.instance},{t:this.instance_2}]},8).toE({state:[{t:this.instance_3}]},8).toE({state:[{t:this.instance_5,p:{x:-2,y:-48}},{t:this.instance_4,p:{x:-85,y:-60}}]},160).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.instance_5,p:{x:4,y:-61}},{t:this.instance_4,p:{x:-79,y:-38}}]},84).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.instance_1},{t:this.instance},{t:this.instance_2}]},205).toE({state:[{t:this.instance_1},{t:this.instance}]},3).toE({state:[{t:this.instance}]},3).toE({state:[]},3).waitE(188));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-83,-56,99,107);

(lib.rc_conbine = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFEFE").s().p("AgpARQgSgRAAgYIABgKIB1AAIABAKQAAAYgSARQgRASgZAAQgYAAgRgSg");
	this.shape.setTransform(0,2.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFEFE").s().p("AAYA7QgUgCgNgPQgSgRAAgZQAAgYASgRQANgPAUgCIAEgBIAAB3IgEgBg");
	this.shape_1.setTransform(-3.2,0);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape_2.setTransform(0.2,-0.2);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AhFAkIAAhHIAIAAIB3AAIAMAAIAABHg");
	this.shape_3.setTransform(0.2,3.1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFEFE").s().p("Ag7AbQACgVAQgPQAOgPAUgCIAHgBQAZAAARASQAQAPACAVg");
	this.shape_4.setTransform(0,-3.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFEFE").s().p("AAZA7QgUgCgOgPQgRgRAAgZQAAgYARgRQAOgPAUgCIACgBIAAB3IgCgBg");
	this.shape_5.setTransform(-3.3,0);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFEFE").s().p("AgNBpQgjgEgagaQgfgfAAgsQAAgrAfgfQAagaAjgEIANgBQAsAAAfAfQAfAfAAArQAAAsgfAfQgfAfgsAAIgNgBg");

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFEFE").s().p("AgHA7QgUgCgOgPQgSgRAAgZQAAgYASgRQAOgPAUgCIAHgBQAZAAARASQASARAAAYQAAAZgSARQgRASgZAAIgHgBg");

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("Ag9A+IAAh7IB7AAIAAB7g");
	this.shape_8.setTransform(-0.1,-0.1);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgeA+IAAh7IA9AAIAAB7g");
	this.shape_9.setTransform(-3.2,-0.1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AgeAdIAAg5IA9AAIAAA5g");
	this.shape_10.setTransform(-3.2,0.5);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFEFE").s().p("AgeA8IAAh3IACAAQAZAAAQASQASARAAAYQAAAZgSARQgQASgZAAIgCAAg");
	this.shape_11.setTransform(2.9,0);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFEFE").s().p("AgCA8IgFgBQgUgCgOgPQgSgRAAgZQAAgYASgRQAOgPAUgCIAFgBIACAAQAZAAARASQASARAAAYQAAAZgSARQgRASgZAAIgCAAg");

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFEFE").s().p("AAcA8IgGgBQgUgCgNgPQgSgRAAgZQAAgYASgRQANgPAUgCIAGgBIACAAIAAB3IgCAAg");
	this.shape_13.setTransform(-3,0);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFEFE").s().p("AgdAdQABgYARgPQANgPAUgCIAGgBIACAAIAAA5g");
	this.shape_14.setTransform(-3,-3.1);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[]},11).toE({state:[{t:this.shape_1}]},10).toE({state:[]},6).toE({state:[{t:this.shape_2}]},20).toE({state:[{t:this.shape_4},{t:this.shape_3}]},10).toE({state:[{t:this.shape_5}]},5).toE({state:[]},6).toE({state:[{t:this.shape_6}]},13).toE({state:[{t:this.shape_7}]},15).toE({state:[{t:this.shape_8}]},117).toE({state:[{t:this.shape_9}]},115).toE({state:[{t:this.shape_10}]},13).toE({state:[{t:this.shape_11}]},6).toE({state:[{t:this.shape_12}]},8).toE({state:[{t:this.shape_13}]},130).toE({state:[{t:this.shape_14}]},70).toE({state:[]},28).waitE(137));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,-0.9,12,7);

(lib.surface6 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_23();
	this.instance.parent = this;
	this.instance.setTransform(-28,-10);

	this.instance_1 = new lib.bitmap_sence4_22();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1,0);

	this.instance_2 = new lib.bitmap_sence4_21();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-28,-14);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_1,p:{y:0}},{t:this.instance,p:{y:-10}}]},30).toE({state:[{t:this.instance_1,p:{y:-15}},{t:this.instance,p:{y:-5}}]},2).toE({state:[{t:this.instance_2}]},2).toE({state:[{t:this.instance_1,p:{y:-15}},{t:this.instance,p:{y:-5}}]},91).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{y:-15}},{t:this.instance,p:{y:-5}}]},109).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{y:-15}},{t:this.instance,p:{y:-5}}]},235).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{y:-15}},{t:this.instance,p:{y:-5}}]},111).toE({state:[{t:this.instance_1,p:{y:0}},{t:this.instance,p:{y:-10}}]},3).toE({state:[]},3).waitE(124));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.surface5 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_20();
	this.instance.parent = this;
	this.instance.setTransform(0,-45,0.71,0.71);

	this.instance_1 = new lib.bitmap_sence4_18();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-112,-66,1.37,1.37);

	this.instance_2 = new lib.bitmap_sence4_19();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-52,-55);

	this.instance_3 = new lib.bitmap_sence4_17();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-101,-52);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance,p:{x:0,scaleX:0.71,scaleY:0.71,y:-45}}]},22).toE({state:[{t:this.instance_2,p:{x:-52,y:-55}},{t:this.instance,p:{x:39,scaleX:0.71,scaleY:0.71,y:-45}},{t:this.instance_1,p:{scaleX:1.37,scaleY:1.37,x:-112,y:-66}}]},2).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-106,y:-57}},{t:this.instance_2,p:{x:-31,y:-61}},{t:this.instance,p:{x:57,scaleX:1,scaleY:1,y:-42}}]},2).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-106,y:-57}},{t:this.instance_2,p:{x:-31,y:-61}},{t:this.instance,p:{x:57,scaleX:1,scaleY:1,y:-42}}]},578).toE({state:[{t:this.instance_2,p:{x:-52,y:-55}},{t:this.instance,p:{x:39,scaleX:0.71,scaleY:0.71,y:-45}},{t:this.instance_1,p:{scaleX:1.37,scaleY:1.37,x:-112,y:-66}}]},2).toE({state:[{t:this.instance,p:{x:0,scaleX:0.71,scaleY:0.71,y:-45}}]},2).toE({state:[]},2).waitE(108));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.surface4 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_15();
	this.instance.parent = this;
	this.instance.setTransform(-57,-22);

	this.instance_1 = new lib.bitmap_sence4_14();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-51,-16);

	this.instance_2 = new lib.bitmap_sence4_16();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-51,-27);
	this.instance_2._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_1,p:{x:-51}},{t:this.instance,p:{x:-57,y:-22}}]},15).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},54).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},60).toE({state:[{t:this.instance_2}]},5).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},160).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},101).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},67).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-51}},{t:this.instance,p:{x:-57,y:-22}}]},145).toE({state:[{t:this.instance_1,p:{x:-62}},{t:this.instance,p:{x:-54,y:-13}}]},3).toE({state:[]},3).waitE(86));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(21).toE({_off:false},0).toE({_off:true},54).waitE(4).toE({_off:false},0).toE({_off:true},60).waitE(5).toE({_off:false},0).toE({_off:true},160).waitE(4).toE({_off:false},0).toE({_off:true},101).waitE(3).toE({_off:false},0).toE({_off:true},67).waitE(4).toE({_off:false},0).toE({_off:true},145).waitE(92));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.surface3 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AtfStMAAAglZIa/AAMAAAAlZg");
	var mask_graphics_719 = new cjs.Graphics().p("AtfStMAAAglZIa/AAMAAAAlZg");

	this.timeline.addTween(TTF(cjs.Tween.get(mask)).toE({graphics:mask_graphics_0,x:0.5,y:-5.7}).waitE(719).toE({graphics:mask_graphics_719,x:0.5,y:-5.7}).waitE(1));

	// 圖層_1
	this.instance = new lib.dot_with11("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(157,-59);
	this.instance._off = true;

	this.instance_1 = new lib.surface3_with_2("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(12,14);

	this.instance_2 = new lib.surface3_with_1("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(12,14);
	this.instance_2._off = true;

	this.instance_3 = new lib.dot_with10("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(157,-59);

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2,this.instance_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},99).toE({state:[{t:this.instance_1}]},28).toE({state:[{t:this.instance_2}]},434).toE({state:[{t:this.instance_3}]},47).toE({state:[]},1).waitE(111));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(99).toE({_off:false},0).toE({_off:true,x:12,y:14},28).waitE(593));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(561).toE({_off:false},0).toE({_off:true,x:157,y:-59},47).waitE(112));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.surface3_with_2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_13();
	this.instance.parent = this;
	this.instance.setTransform(-70,-86);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70,-86,140,172);


(lib.surface3_with_1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_13();
	this.instance.parent = this;
	this.instance.setTransform(-70,-86);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70,-86,140,172);

(lib.surface2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_7();
	this.instance.parent = this;
	this.instance.setTransform(-169,-77,1.4,1.4);

	this.instance_1 = new lib.bitmap_sence4_8();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-22,-52);

	this.instance_2 = new lib.bitmap_sence4_6();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-137,-64);

	this.instance_3 = new lib.bitmap_sence4_5();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-109,-54);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_2,p:{x:-137,y:-64}},{t:this.instance_1,p:{x:-22,y:-52}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-169,y:-77}}]},9).toE({state:[{t:this.instance_2,p:{x:-109,y:-50}},{t:this.instance_1,p:{x:-35,y:-47}}]},2).toE({state:[{t:this.instance,p:{scaleX:1,scaleY:1,x:-120,y:-60}},{t:this.instance_2,p:{x:-116,y:-58}}]},2).toE({state:[{t:this.instance_2,p:{x:-137,y:-64}},{t:this.instance_1,p:{x:-22,y:-52}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-169,y:-77}}]},2).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_2,p:{x:-121,y:-56}},{t:this.instance_1,p:{x:-23,y:-45}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-116,y:-55}}]},279).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.instance_2,p:{x:-121,y:-56}},{t:this.instance_1,p:{x:-23,y:-45}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-116,y:-55}}]},134).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.instance_2,p:{x:-121,y:-56}},{t:this.instance_1,p:{x:-23,y:-45}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-116,y:-55}}]},73).toE({state:[{t:this.instance_2,p:{x:-137,y:-64}},{t:this.instance_1,p:{x:-22,y:-52}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-169,y:-77}}]},4).toE({state:[{t:this.instance_2,p:{x:-109,y:-50}},{t:this.instance_1,p:{x:-35,y:-47}}]},3).toE({state:[]},2).waitE(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.surface1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgiAEIAogYIAdASIgoAXg");
	this.shape.setTransform(-0.6,-0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AhEAIIBQgwIA4AjIhOAug");
	this.shape_1.setTransform(-0.6,-0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AiGAQICfhgIBvBFIidBcg");
	this.shape_2.setTransform(-0.6,-0.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ai+gLIDEhiIC5BvIi6Bsg");
	this.shape_3.setTransform(0,1.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("Ak2hXIDQhaIGeD7IjEBng");
	this.shape_4.setTransform(-0.5,1.3);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AmiiWIDLhcIJ5GAIjKBkg");
	this.shape_5.setTransform(-0.9,0.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("ApQg+IHajjILHFoInXDbg");
	this.shape_6.setTransform(2,-1.5);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("ArQgCILUlaILNFnIrXFSg");
	this.shape_7.setTransform(1.4,-1.1);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AtkBFIP1nkILUFnIv6HYg");
	this.shape_8.setTransform(0,-0.5);

	this.instance = new lib.bitmap_sence4_4();
	this.instance.parent = this;
	this.instance.setTransform(-88,-42);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AtiA7IP8nqILJFuIwXHxg");
	this.shape_9.setTransform(-0.3,0);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AsuAmIOVm5ILIFuIuhG5g");
	this.shape_10.setTransform(4.9,-2.8);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("ArpAKIMLl3ILIFtIr/Fug");
	this.shape_11.setTransform(11.7,-6.6);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("Ao5hZIGsjOILHFtInaDig");
	this.shape_12.setTransform(29.3,-13.6);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AmoiWICKhDILHFtIiQBGg");
	this.shape_13.setTransform(43.8,-21.5);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},55).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},2).toE({state:[{t:this.shape_4}]},2).toE({state:[{t:this.shape_5}]},2).toE({state:[{t:this.shape_6}]},2).toE({state:[{t:this.shape_7}]},2).toE({state:[{t:this.shape_8}]},2).toE({state:[{t:this.instance}]},2).toE({state:[{t:this.shape_9}]},446).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[]},2).waitE(191));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.pen = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgGAHQgEgDAAgEQAAgDAEgDQADgDADAAQAEAAADADQAEADAAADQAAAEgEADQgDADgEAAQgDAAgDgDg");
	this.shape.setTransform(0,-0.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgMAMQgEgFAAgHQAAgGAEgFQAFgFAHAAQAIAAAFAFQAEAFAAAGQAAAHgEAFQgFAFgIAAQgHAAgFgFg");
	this.shape_1.setTransform(0,-0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgmAlQgOgQAAgWQAAgUAOgPQAQgPAWAAQAXAAAQAPQAOAPAAAUQAAAWgOAQQgQAPgXAAQgWAAgQgPg");
	this.shape_2.setTransform(0,-0.6);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AA9AnIAHgQIA3AcIgIAPgAgbAaQgLgLAAgQQAAgOALgLQALgLAQAAQAQAAALALQALALAAAOQAAAQgLALQgLALgQAAQgQAAgLgLgAh6gyIAIgQIA2AcIgHAPg");
	this.shape_3.setTransform(0.1,-0.6);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AA8AmIAHgQIB+A/IgIAQgAgNAKQgFgFgBgHQABgHAFgEQAFgGAIAAQAGAAAFAGQAFAEAAAHQAAAHgFAFQgFAFgGAAQgIAAgFgFgAi/hWIAHgOIB7A8IgHAQg");
	this.shape_4.setTransform(0.2,-0.4);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AA+AnIAHgQIDrBzIgJARgAgFAFQgCgCAAgDQAAgEACgCQADgDACABQAEgBADADQACACAAAEQAAADgCACQgDACgEAAQgCAAgDgCgAkviPIAJgLIDrB0IgHAPg");
	this.shape_5.setTransform(0,-0.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AA+AmIAHgQIFjCyIgMARgAmnjNIAHgLIFlCwIgHAQg");
	this.shape_6.setTransform(0,-0.4);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AA2ApIASgkIFjCyIgRAmgAmqjSIAGgKQDFAwCvB3IgTAjQjLhCich+g");
	this.shape_7.setTransform(0.3,0);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgTATQkBhsidh+IAHgLQDFAxDxCNIGmDNIgjA6g");
	this.shape_8.setTransform(0.9,0.6);

	this.instance = new lib.bitmap_sence4_1();
	this.instance.parent = this;
	this.instance.setTransform(-42,-22);

	this.instance_1 = new lib.bitmap_sence4_3();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1,-20);

	this.instance_2 = new lib.bitmap_sence4_2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42,-26);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},56).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},2).toE({state:[{t:this.shape_4}]},2).toE({state:[{t:this.shape_5}]},2).toE({state:[{t:this.shape_6}]},2).toE({state:[{t:this.shape_7}]},2).toE({state:[{t:this.shape_8}]},2).toE({state:[{t:this.instance}]},2).toE({state:[{t:this.instance_2},{t:this.instance_1,p:{y:-20}}]},283).toE({state:[{t:this.instance}]},4).toE({state:[{t:this.instance_2},{t:this.instance_1,p:{y:-20}}]},188).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.instance_2},{t:this.instance_1,p:{y:-20}}]},10).toE({state:[{t:this.instance_1,p:{y:-10}}]},4).toE({state:[]},3).waitE(151));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.pc_main = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_12();
	this.instance.parent = this;
	this.instance.setTransform(92,-142);

	this.instance_1 = new lib.bitmap_sence4_10();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-140,-224);

	this.instance_2 = new lib.bitmap_sence4_11();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-60,-132);

	this.instance_3 = new lib.bitmap_sence4_9();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-140,-187);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_1,p:{y:-224}},{t:this.instance,p:{y:-142}}]},7).toE({state:[{t:this.instance_1,p:{y:-187}},{t:this.instance_2,p:{y:-132}},{t:this.instance,p:{y:-225}}]},3).toE({state:[{t:this.instance_1,p:{y:-196}},{t:this.instance_2,p:{y:-187}},{t:this.instance,p:{y:-165}}]},2).toE({state:[{t:this.instance_1,p:{y:-154}},{t:this.instance_2,p:{y:-229}},{t:this.instance,p:{y:-136}}]},2).toE({state:[{t:this.instance_1,p:{y:-176}},{t:this.instance_2,p:{y:-189}},{t:this.instance,p:{y:-168}}]},2).toE({state:[{t:this.instance_1,p:{y:-244}},{t:this.instance_2,p:{y:-140}},{t:this.instance,p:{y:-208}}]},2).toE({state:[{t:this.instance_1,p:{y:-187}},{t:this.instance_2,p:{y:-132}},{t:this.instance,p:{y:-225}}]},2).toE({state:[{t:this.instance_1,p:{y:-142}},{t:this.instance_2,p:{y:-178}},{t:this.instance,p:{y:-103}}]},2).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_1,p:{y:-196}},{t:this.instance_2,p:{y:-187}},{t:this.instance,p:{y:-165}}]},33).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_1,p:{y:-196}},{t:this.instance_2,p:{y:-187}},{t:this.instance,p:{y:-165}}]},207).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.instance_1,p:{y:-187}},{t:this.instance_2,p:{y:-132}},{t:this.instance,p:{y:-225}}]},363).toE({state:[{t:this.instance_1,p:{y:-196}},{t:this.instance_2,p:{y:-187}},{t:this.instance,p:{y:-165}}]},2).toE({state:[{t:this.instance_1,p:{y:-154}},{t:this.instance_2,p:{y:-229}},{t:this.instance,p:{y:-136}}]},2).toE({state:[{t:this.instance_1,p:{y:-176}},{t:this.instance_2,p:{y:-189}},{t:this.instance,p:{y:-168}}]},2).toE({state:[{t:this.instance_1,p:{y:-244}},{t:this.instance_2,p:{y:-140}},{t:this.instance,p:{y:-208}}]},2).toE({state:[{t:this.instance_1,p:{y:-187}},{t:this.instance_2,p:{y:-132}},{t:this.instance,p:{y:-225}}]},2).toE({state:[{t:this.instance_1,p:{y:-142}},{t:this.instance_2,p:{y:-178}},{t:this.instance,p:{y:-103}}]},2).toE({state:[{t:this.instance_1,p:{y:-187}},{t:this.instance_2,p:{y:-132}},{t:this.instance,p:{y:-225}}]},2).toE({state:[{t:this.instance_1,p:{y:-196}},{t:this.instance_2,p:{y:-187}},{t:this.instance,p:{y:-165}}]},2).toE({state:[{t:this.instance_1,p:{y:-154}},{t:this.instance,p:{y:-136}}]},2).toE({state:[{t:this.instance_1,p:{y:-176}},{t:this.instance,p:{y:-168}}]},2).toE({state:[{t:this.instance_1,p:{y:-244}},{t:this.instance,p:{y:-208}}]},2).toE({state:[{t:this.instance,p:{y:-225}}]},2).toE({state:[{t:this.instance,p:{y:-142}}]},2).toE({state:[]},2).waitE(59));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.rect_red = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// flash0.ai
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6647C").s().p("AkAEBIAAoCIIBAAIAAICg");
	this.shape.setTransform(-0.3,-33.5,0.43,0.43,45,0,0,0,-0.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E6647C").s().p("AkAEBIAAoCIIBAAIAAICg");
	this.shape_1.setTransform(-0.3,-33.5,0.43,0.43,45,0,0,0,-0.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#E6647C").s().p("AkAEBIAAoCIICAAIAAICg");
	this.shape_2.setTransform(33.2,0.1,0.43,0.43,45,0,0,0,-0.2);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#E6647C").s().p("AkAECIAAoCIICAAIAAICg");
	this.shape_3.setTransform(16.3,17,0.43,0.43,45);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#E6647C").s().p("AkAECIAAoDIICAAIAAIDg");
	this.shape_4.setTransform(-0.5,33.8,0.43,0.43,45,0,0,0,-0.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#E6647C").s().p("AkAECIAAoDIIBAAIAAIDg");
	this.shape_5.setTransform(-17.3,17,0.43,0.43,45,0,0,0,-0.2);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#E6647C").s().p("AkAECIAAoDIIBAAIAAIDg");
	this.shape_6.setTransform(-34.1,0.1,0.43,0.43,45,0,0,-0.1,-0.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#E6647C").s().p("AkAECIAAoCIIBAAIAAICg");
	this.shape_7.setTransform(-0.4,0.1,0.43,0.43,45,0,0,-0.1,-0.2);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#E6647C").s().p("AkAECIAAoCIIBAAIAAICg");
	this.shape_8.setTransform(-17.2,-16.7,0.43,0.43,45,0,0,-0.1,-0.2);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#E6647C").s().p("AiKFjIArgsIigihIg+A+IjBjBIDBjAIARASICRiRIgSgRIDAjBIC6C6IApgpICcCcIiTCUIALALIBZhYICcCbIiPCPIAaAaIjPDQIgagaIiQCPg");
	this.shape_9.setTransform(-2.3,-4.9);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape,p:{x:-0.3,y:-33.5,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}}]}).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_1,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,y:-39.2,regX:0}},{t:this.shape,p:{x:19.3,y:-19.6,regY:-0.1,scaleX:0.503,scaleY:0.503,regX:0}},{t:this.shape_2,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,x:39,y:0,regX:0}},{t:this.shape_8,p:{regY:-0.1,scaleX:0.503,scaleY:0.503,x:-20.1,y:-19.5,regX:-0.1}},{t:this.shape_7,p:{regX:-0.2,regY:-0.1,scaleX:0.503,scaleY:0.503}},{t:this.shape_3,p:{scaleX:0.503,scaleY:0.503,x:19.2,y:19.8,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.2,scaleX:0.503,scaleY:0.503,x:-39.8,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.503,scaleY:0.503,x:-20.1,y:19.9,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.503,scaleY:0.503,x:-0.4,y:39.5,regX:0,regY:-0.2}}]},2).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},4).toE({state:[{t:this.shape_9}]},59).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},5).toE({state:[{t:this.shape_9}]},62).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},6).toE({state:[{t:this.shape_9}]},142).toE({state:[{t:this.shape_2,p:{regY:-0.2,scaleX:1.41,scaleY:1.41,x:-0.2,y:0.5,regX:0}}]},6).toE({state:[{t:this.shape_1,p:{regY:-0.3,scaleX:0.46,scaleY:0.46,y:-33.5,regX:-0.2}},{t:this.shape,p:{x:16.5,y:-16.7,regY:-0.1,scaleX:0.46,scaleY:0.46,regX:0}},{t:this.shape_2,p:{regY:-0.1,scaleX:0.46,scaleY:0.46,x:33.2,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.1,scaleX:0.46,scaleY:0.46,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.2,regY:-0.1,scaleX:0.46,scaleY:0.46}},{t:this.shape_3,p:{scaleX:0.46,scaleY:0.46,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.46,scaleY:0.46,x:-34,regX:-0.2}},{t:this.shape_5,p:{scaleX:0.46,scaleY:0.46,x:-17.2,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.46,scaleY:0.46,x:-0.5,y:33.8,regX:-0.1,regY:-0.2}}]},158).toE({state:[{t:this.shape_1,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,y:-33.5,regX:-0.1}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.3,scaleX:0.44,scaleY:0.44,regX:-0.1}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.44,scaleY:0.44,x:33.2,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,x:-17.2,y:-16.7,regX:-0.2}},{t:this.shape_7,p:{regX:-0.1,regY:-0.3,scaleX:0.44,scaleY:0.44}},{t:this.shape_3,p:{scaleX:0.44,scaleY:0.44,x:16.4,y:17,regY:-0.1,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.44,scaleY:0.44,x:-34,regX:-0.2}},{t:this.shape_5,p:{scaleX:0.44,scaleY:0.44,x:-17.3,y:17,regX:-0.1,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.44,scaleY:0.44,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},4).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-17.3,y:17,regX:0,regY:-0.2}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_6,p:{regY:-0.3,scaleX:0.43,scaleY:0.43,x:-34.1,regX:-0.1}},{t:this.shape_5,p:{scaleX:0.22,scaleY:0.22,x:-17.3,y:17,regX:-0.3,regY:-0.1}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},15).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:33.2,y:0.1,regX:0}},{t:this.shape_8,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,x:-17.2,y:-16.7,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_2,p:{regY:-0.2,scaleX:0.22,scaleY:0.22,x:33.3,y:0,regX:-0.1}},{t:this.shape_8,p:{regY:-0.4,scaleX:0.22,scaleY:0.22,x:-17.2,y:-16.7,regX:-0.2}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},51).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.43,scaleY:0.43,y:-33.5,regX:0}},{t:this.shape,p:{x:16.4,y:-16.7,regY:-0.2,scaleX:0.43,scaleY:0.43,regX:0}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_1,p:{regY:-0.2,scaleX:0.22,scaleY:0.22,y:-33.5,regX:-0.2}},{t:this.shape,p:{x:16.5,y:-16.7,regY:-0.2,scaleX:0.22,scaleY:0.22,regX:-0.1}},{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},37).toE({state:[{t:this.shape_7,p:{regX:-0.1,regY:-0.2,scaleX:0.43,scaleY:0.43}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_7,p:{regX:-0.3,regY:-0.3,scaleX:0.22,scaleY:0.22}},{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},31).toE({state:[{t:this.shape_3,p:{scaleX:0.43,scaleY:0.43,x:16.3,y:17,regY:0,regX:0}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_3,p:{scaleX:0.22,scaleY:0.22,x:16.4,y:16.9,regY:-0.3,regX:-0.3}},{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},6).toE({state:[{t:this.shape_5,p:{scaleX:0.43,scaleY:0.43,x:-34.1,y:0.1,regX:-0.1,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_5,p:{scaleX:0.22,scaleY:0.22,x:-34.1,y:0.1,regX:-0.2,regY:-0.3}},{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:-0.3,regY:-0.3}}]},11).toE({state:[{t:this.shape_4,p:{scaleX:0.43,scaleY:0.43,x:-0.5,y:33.8,regX:0,regY:-0.2}}]},3).toE({state:[{t:this.shape_4,p:{scaleX:0.22,scaleY:0.22,x:-0.4,y:33.8,regX:-0.1,regY:-0.3}}]},29).toE({state:[]},3).waitE(54));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16,-49.1,31.3,31.3);

(lib.phone_front = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence1_bitmap9();
	this.instance.parent = this;
	this.instance.setTransform(-299,-318);

	this.instance_1 = new lib.sence1_bitmap7();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-93,-163,0.359,0.359);

	this.instance_2 = new lib.sence1_bitmap10();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-94,-178);

	this.instance_3 = new lib.sence1_bitmap11();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-105,-163);

	this.instance_4 = new lib.sence1_bitmap12();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-126,-209);

	this.instance_5 = new lib.sence1_bitmap13();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-126,-209);

	this.instance_6 = new lib.sence1_bitmap14();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-94,0);

	this.instance_7 = new lib.sence1_bitmap15();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-126,-209);

	this.instance_8 = new lib.sence1_bitmap16();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-144,-247);

	this.instance_9 = new lib.sence1_bitmap17();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-94,-163);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},72).toE({state:[{t:this.instance_1}]},6).toE({state:[{t:this.instance_2}]},162).toE({state:[{t:this.instance_1}]},8).toE({state:[{t:this.instance_3}]},293).toE({state:[{t:this.instance_1}]},6).toE({state:[{t:this.instance_4}]},101).toE({state:[{t:this.instance_5}]},4).toE({state:[{t:this.instance_6}]},4).toE({state:[{t:this.instance_7}]},5).toE({state:[{t:this.instance_8}]},4).toE({state:[{t:this.instance_9}]},3).toE({state:[]},3).waitE(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.phone_back = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.sence1_bitmap1();
	this.instance.parent = this;
	this.instance.setTransform(-455,-168);

	this.instance_1 = new lib.sence1_bitmap2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-455,-56);

	this.instance_2 = new lib.sence1_bitmap3();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-710,-306);

	this.instance_3 = new lib.sence1_bitmap4();
	this.instance_3.parent = this;
	this.instance_3.setTransform(42,-115);

	this.instance_4 = new lib.sence1_bitmap20();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-214,-352);

	this.instance_5 = new lib.sence1_bitmap5();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-95,-155,0.375,0.375);

	this.instance_6 = new lib.sence1_bitmap6();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-91,-184);

	this.instance_7 = new lib.sence1_bitmap19();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-134,-147);

	this.instance_8 = new lib.sence1_bitmap18();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-125,-147);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},14).toE({state:[{t:this.instance_1}]},4).toE({state:[{t:this.instance_2}]},2).toE({state:[]},3).toE({state:[{t:this.instance_3}]},15).toE({state:[{t:this.instance_4}]},6).toE({state:[{t:this.instance_5}]},3).toE({state:[{t:this.instance_6}]},419).toE({state:[{t:this.instance_5}]},8).toE({state:[{t:this.instance_7}]},147).toE({state:[{t:this.instance_8}]},7).toE({state:[]},6).waitE(86));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.line_dot = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AAAAAIABAB");
	this.shape.setTransform(0.3,0.3);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgOgMIAdAZ");
	this.shape_1.setTransform(1.4,1.3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgrgmIBXBN");
	this.shape_2.setTransform(4.3,3.9);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FFFFFF").ss(1,1,1).p("AhIg/ICRB/");
	this.shape_3.setTransform(7.2,6.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f().s("#FFFFFF").ss(1,1,1).p("AhlhZIDLCz");
	this.shape_4.setTransform(10.2,9);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f().s("#FFFFFF").ss(1,1,1).p("AiChyIEFDl");
	this.shape_5.setTransform(13.1,11.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f().s("#FFFFFF").ss(1,1,1).p("AifiMIE/EZ");
	this.shape_6.setTransform(16,14.2);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f().s("#FFFFFF").ss(1,1,1).p("Ai7imIF3FN");
	this.shape_7.setTransform(18.9,16.8);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f().s("#FFFFFF").ss(1,1,1).p("AjZi/IGzF/");
	this.shape_8.setTransform(21.9,19.3);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f().s("#FFFFFF").ss(1,1,1).p("Aj1jZIHrGz");
	this.shape_9.setTransform(24.8,21.9);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f().s("#FFFFFF").ss(1,1,1).p("AkTjyIInHl");
	this.shape_10.setTransform(27.7,24.5);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f().s("#FFFFFF").ss(1,1,1).p("AkvkMIJfIZ");
	this.shape_11.setTransform(30.6,27.1);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f().s("#FFFFFF").ss(1,1,1).p("Ak4kTIJxIn");
	this.shape_12.setTransform(31.5,27.8);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f().s("#FFFFFF").ss(1,1,1).p("AlBkbIKDI3");
	this.shape_13.setTransform(32.4,28.6);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f().s("#FFFFFF").ss(1,1,1).p("AlJkiIKTJF");
	this.shape_14.setTransform(33.2,29.3);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f().s("#FFFFFF").ss(1,1,1).p("AlSkqIKlJV");
	this.shape_15.setTransform(34.1,30.1);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f().s("#FFFFFF").ss(1,1,1).p("AlakxIK1Jj");
	this.shape_16.setTransform(34.9,30.8);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f().s("#FFFFFF").ss(1,1,1).p("Aljk5ILHJz");
	this.shape_17.setTransform(35.8,31.6);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f().s("#FFFFFF").ss(1,1,1).p("AlrlAILXKB");
	this.shape_18.setTransform(36.6,32.3);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f().s("#FFFFFF").ss(1,1,1).p("Al0lIILpKR");
	this.shape_19.setTransform(37.5,33.1);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f().s("#FFFFFF").ss(1,1,1).p("Al8lPIL5Kf");
	this.shape_20.setTransform(38.3,33.8);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f().s("#FFFFFF").ss(1,1,1).p("AmFlXIMLKv");
	this.shape_21.setTransform(39.2,34.6);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f().s("#FFFFFF").ss(1,1,1).p("AmOleIMdK9");
	this.shape_22.setTransform(40.1,35.3);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f().s("#FFFFFF").ss(1,1,1).p("AmWlmIMtLN");
	this.shape_23.setTransform(40.9,36.1);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f().s("#FFFFFF").ss(1,1,1).p("AmfltIM/Lb");
	this.shape_24.setTransform(41.8,36.8);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f().s("#FFFFFF").ss(1,1,1).p("Amnl1INPLr");
	this.shape_25.setTransform(42.6,37.6);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f().s("#FFFFFF").ss(1,1,1).p("Amwl8INhL5");
	this.shape_26.setTransform(43.5,38.3);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f().s("#FFFFFF").ss(1,1,1).p("Am4mEINxMJ");
	this.shape_27.setTransform(44.3,39.1);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnBmLIODMX");
	this.shape_28.setTransform(45.2,39.8);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnKmTIOVMn");
	this.shape_29.setTransform(46.1,40.6);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnSmaIOlM1");
	this.shape_30.setTransform(46.9,41.3);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnUmcIOpM5");
	this.shape_31.setTransform(47.2,41.5);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnXmfIOvM/");
	this.shape_32.setTransform(47.4,41.8);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnZmhIOzND");
	this.shape_33.setTransform(47.6,42);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f().s("#FFFFFF").ss(1,1,1).p("AncmjIO5NH");
	this.shape_34.setTransform(47.9,42.2);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnemlIO9NL");
	this.shape_35.setTransform(48.1,42.4);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnhmnIPDNP");
	this.shape_36.setTransform(48.4,42.6);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnjmpIPHNT");
	this.shape_37.setTransform(48.6,42.8);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnmmrIPNNX");
	this.shape_38.setTransform(48.9,43);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnomtIPRNb");
	this.shape_39.setTransform(49.1,43.2);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f().s("#FFFFFF").ss(1,1,1).p("AnrmvIPXNf");
	this.shape_40.setTransform(49.4,43.4);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f().s("#FFFFFF").ss(1,1,1).p("AntmxIPbNj");
	this.shape_41.setTransform(49.6,43.7);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f().s("#FFFFFF").ss(1,1,1).p("Anvm0IPfNp");
	this.shape_42.setTransform(49.8,43.9);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f().s("#FFFFFF").ss(1,1,1).p("Anym2IPlNt");
	this.shape_43.setTransform(50.1,44.1);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f().s("#FFFFFF").ss(1,1,1).p("An0m4IPpNx");
	this.shape_44.setTransform(50.3,44.3);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f().s("#FFFFFF").ss(1,1,1).p("An3m6IPvN1");
	this.shape_45.setTransform(50.6,44.5);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f().s("#FFFFFF").ss(1,1,1).p("An5m8IPzN5");
	this.shape_46.setTransform(50.8,44.7);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f().s("#FFFFFF").ss(1,1,1).p("An8m+IP5N9");
	this.shape_47.setTransform(51.1,44.9);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f().s("#FFFFFF").ss(1,1,1).p("An+nAIP9OB");
	this.shape_48.setTransform(51.3,45.1);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoBnCIQDOF");
	this.shape_49.setTransform(51.6,45.3);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoDnFIQHOL");
	this.shape_50.setTransform(51.8,45.6);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoFnHIQLOP");
	this.shape_51.setTransform(52,45.8);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoInJIQROT");
	this.shape_52.setTransform(52.3,46);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoKnLIQVOX");
	this.shape_53.setTransform(52.5,46.2);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoNnNIQbOb");
	this.shape_54.setTransform(52.8,46.4);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoPnPIQfOf");
	this.shape_55.setTransform(53,46.6);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoSnRIQlOj");
	this.shape_56.setTransform(53.3,46.8);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoUnTIQpOn");
	this.shape_57.setTransform(53.5,47);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoWnVIQtOr");
	this.shape_58.setTransform(53.7,47.2);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f().s("#FFFFFF").ss(1,1,1).p("AoZnYIQzOx");
	this.shape_59.setTransform(54,47.5);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f().s("#FFFFFF").ss(1,1,1).p("AobnZIQ3Oz");
	this.shape_60.setTransform(54.2,47.7);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},2).toE({state:[]},12).toE({state:[{t:this.shape}]},4).toE({state:[]},13).toE({state:[{t:this.shape}]},5).toE({state:[{t:this.shape}]},23).toE({state:[{t:this.shape_1}]},1).toE({state:[{t:this.shape_2}]},1).toE({state:[{t:this.shape_3}]},1).toE({state:[{t:this.shape_4}]},1).toE({state:[{t:this.shape_5}]},1).toE({state:[{t:this.shape_6}]},1).toE({state:[{t:this.shape_7}]},1).toE({state:[{t:this.shape_8}]},1).toE({state:[{t:this.shape_9}]},1).toE({state:[{t:this.shape_10}]},1).toE({state:[{t:this.shape_11}]},1).toE({state:[{t:this.shape_12}]},1).toE({state:[{t:this.shape_13}]},1).toE({state:[{t:this.shape_14}]},1).toE({state:[{t:this.shape_15}]},1).toE({state:[{t:this.shape_16}]},1).toE({state:[{t:this.shape_17}]},1).toE({state:[{t:this.shape_18}]},1).toE({state:[{t:this.shape_19}]},1).toE({state:[{t:this.shape_20}]},1).toE({state:[{t:this.shape_21}]},1).toE({state:[{t:this.shape_22}]},1).toE({state:[{t:this.shape_23}]},1).toE({state:[{t:this.shape_24}]},1).toE({state:[{t:this.shape_25}]},1).toE({state:[{t:this.shape_26}]},1).toE({state:[{t:this.shape_27}]},1).toE({state:[{t:this.shape_28}]},1).toE({state:[{t:this.shape_29}]},1).toE({state:[{t:this.shape_30}]},1).toE({state:[{t:this.shape_31}]},1).toE({state:[{t:this.shape_32}]},1).toE({state:[{t:this.shape_33}]},1).toE({state:[{t:this.shape_34}]},1).toE({state:[{t:this.shape_35}]},1).toE({state:[{t:this.shape_36}]},1).toE({state:[{t:this.shape_37}]},1).toE({state:[{t:this.shape_38}]},1).toE({state:[{t:this.shape_39}]},1).toE({state:[{t:this.shape_40}]},1).toE({state:[{t:this.shape_41}]},1).toE({state:[{t:this.shape_42}]},1).toE({state:[{t:this.shape_43}]},1).toE({state:[{t:this.shape_44}]},1).toE({state:[{t:this.shape_45}]},1).toE({state:[{t:this.shape_46}]},1).toE({state:[{t:this.shape_47}]},1).toE({state:[{t:this.shape_48}]},1).toE({state:[{t:this.shape_49}]},1).toE({state:[{t:this.shape_50}]},1).toE({state:[{t:this.shape_51}]},1).toE({state:[{t:this.shape_52}]},1).toE({state:[{t:this.shape_53}]},1).toE({state:[{t:this.shape_54}]},1).toE({state:[{t:this.shape_55}]},1).toE({state:[{t:this.shape_56}]},1).toE({state:[{t:this.shape_57}]},1).toE({state:[{t:this.shape_58}]},1).toE({state:[{t:this.shape_59}]},1).toE({state:[{t:this.shape_60}]},1).toE({state:[{t:this.shape_60}]},1).toE({state:[{t:this.shape_60}]},481).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.laptop = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.laptop1();
	this.instance.parent = this;
	this.instance.setTransform(-374,-145,1.64,1.64);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgDhTIAHAiIgHCFg");
	this.shape.setTransform(-183.2,-119.6);

	this.instance_1 = new lib.laptop3();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-164,-3,1.27,1.27);

	this.instance_2 = new lib.laptop2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-279,-6);

	this.instance_3 = new lib.laptop_original();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-184,-203);
	this.instance_3._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1.64,scaleY:1.64,x:-374,y:-145}}]},30).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-339,y:-10}},{t:this.instance_1,p:{scaleX:1.27,scaleY:1.27,x:-164,y:-3}}]},3).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-132,y:-165}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-200,y:54}},{t:this.instance_2,p:{x:-279,y:-6}}]},3).toE({state:[{t:this.instance_3}]},6).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-173,y:-210}},{t:this.instance_2,p:{x:-226,y:-101}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:44}}]},214).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-173,y:-210}},{t:this.instance_2,p:{x:-226,y:-101}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:44}}]},74).toE({state:[{t:this.instance_3}]},6).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-173,y:-210}},{t:this.instance_2,p:{x:-226,y:-101}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:44}}]},31).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-173,y:-210}},{t:this.instance_2,p:{x:-226,y:-101}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:44}}]},133).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-132,y:-165}},{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-200,y:54}},{t:this.instance_2,p:{x:-279,y:-6}}]},156).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1,scaleY:1,x:-339,y:-10}},{t:this.instance_1,p:{scaleX:1.27,scaleY:1.27,x:-164,y:-3}}]},3).toE({state:[{t:this.shape},{t:this.instance,p:{scaleX:1.64,scaleY:1.64,x:-374,y:-145}}]},3).toE({state:[]},3).waitE(41));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(42).toE({_off:false},0).toE({_off:true},214).waitE(5).toE({_off:false},0).toE({_off:true},74).waitE(6).toE({_off:false},0).toE({_off:true},31).waitE(5).toE({_off:false},0).toE({_off:true},133).waitE(4).toE({_off:false},0).toE({_off:true},156).waitE(50));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.ice_cude = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.Ice2();
	this.instance.parent = this;
	this.instance.setTransform(-2,-15,0.07,0.07);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(2).toE({scaleX:0.1,scaleY:0.1,x:-6,y:-19},0).waitE(2).toE({scaleX:0.16,scaleY:0.16,x:-14,y:-26},0).waitE(2).toE({scaleX:0.18,scaleY:0.18,x:-17,y:-28},0).waitE(2).toE({scaleX:0.23,scaleY:0.23,x:-24,y:-34},0).waitE(2).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(2).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(150).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(4).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(143).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(4).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(74).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(4).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(65).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(4).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(41).toE({scaleX:0.35,scaleY:0.35,x:-40,y:-48},0).waitE(5).toE({scaleX:0.24,scaleY:0.24,x:-25,y:-37},0).waitE(49).toE({scaleX:0.18,scaleY:0.18,x:-17,y:-29},0).waitE(20).toE({scaleX:0.1,scaleY:0.1,x:-6,y:-19},0).waitE(21).toE({scaleX:0.04,scaleY:0.04,x:2,y:-12},0).toE({_off:true},26).waitE(98));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2,-15,19.1,17.2);

(lib.drink2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.single_phone_bitmap16();
	this.instance.parent = this;
	this.instance.setTransform(-141,-60);
	this.instance._off = true;

	this.instance_1 = new lib.single_phone_bitmap5();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-71,-57);

	this.instance_2 = new lib.single_phone_bitmap4();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-61,-124);

	this.instance_3 = new lib.single_phone_bitmap2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-111.9,54.8,0.8,0.8,-31);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},19).toE({state:[{t:this.instance}]},8).toE({state:[{t:this.instance_2,p:{x:-61,y:-124}},{t:this.instance_1}]},460).toE({state:[{t:this.instance}]},6).toE({state:[{t:this.instance_2,p:{x:-61,y:-124}},{t:this.instance_1}]},48).toE({state:[{t:this.instance}]},6).toE({state:[{t:this.instance_2,p:{x:-61,y:-124}},{t:this.instance_1}]},44).toE({state:[{t:this.instance}]},6).toE({state:[{t:this.instance_2,p:{x:-61,y:-124}},{t:this.instance_1}]},42).toE({state:[{t:this.instance_2,p:{x:-101,y:-102}},{t:this.instance_3}]},5).toE({state:[]},4).waitE(72));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(19).toE({_off:false},0).waitE(8).toE({scaleX:0.37,scaleY:0.37,x:-68,y:-123},0).toE({_off:true},460).waitE(6).toE({_off:false},0).toE({_off:true},48).waitE(6).toE({_off:false},0).toE({_off:true},44).waitE(6).toE({_off:false},0).toE({_off:true},42).waitE(81));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.drink1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.single_phone_bitmap3();
	this.instance.parent = this;
	this.instance.setTransform(-130,44);

	this.instance_1 = new lib.single_phone_bitmap1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-56,-216);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("ABNMHQnviLi4hBQhHgagZgOQg3gggOhdQgDhWgEAAQgDAABSkdIAThDQBmligEAAIKmjDQKcjAAHgDQgDAFjOJ8QjYKbgwBlQgyBrhbAcQgeAKgbAAQgOAAgNgDgAMHsJIAAABIAAgBg");
	this.shape.setTransform(7.5,131.6);

	this.instance_2 = new lib.single_phone_bitmap2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-181,-110,1.76,1.76);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A1dUJQgDgBD9stQD8sugBgBMAi5gO0IgBAEIAAAKQACApAMCvQAMCqi7LsQg8DxhGEAQg7DZgCgBQgBAAykFnQykFlgEAAIAAAAg");
	this.shape_1.setTransform(69.8,-1.9);

	this.instance_3 = new lib.single_phone_bitmap15();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-90,-175,0.36,0.36);
	this.instance_3._off = true;

	this.instance_4 = new lib.single_phone_bitmap7();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-95,-161);

	this.instance_5 = new lib.single_phone_bitmap6();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-51,-188);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_1,p:{x:-56,y:-216}},{t:this.instance,p:{x:-130,y:44}}]},10).toE({state:[{t:this.instance_1,p:{x:-130,y:-216}},{t:this.instance_2,p:{scaleX:1.76,scaleY:1.76,x:-181,y:-110}},{t:this.shape}]},3).toE({state:[{t:this.instance,p:{x:-90,y:44}},{t:this.shape_1}]},3).toE({state:[{t:this.instance_3}]},3).toE({state:[{t:this.instance_5},{t:this.instance_4}]},285).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.instance_5},{t:this.instance_4}]},27).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.instance_5},{t:this.instance_4}]},93).toE({state:[{t:this.instance_3}]},5).toE({state:[{t:this.instance_5},{t:this.instance_4}]},132).toE({state:[{t:this.instance_3}]},4).toE({state:[{t:this.instance_1,p:{x:-90,y:-161}},{t:this.instance,p:{x:-90,y:27}},{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-74,y:-77}}]},42).toE({state:[{t:this.instance_3}]},3).toE({state:[{t:this.instance_1,p:{x:-90,y:-161}},{t:this.instance,p:{x:-90,y:27}},{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-74,y:-77}}]},23).toE({state:[{t:this.instance_1,p:{x:-44,y:-201}},{t:this.instance,p:{x:-31,y:27}},{t:this.instance_2,p:{scaleX:1.68,scaleY:1.68,x:-135,y:-129}}]},3).toE({state:[{t:this.instance_2,p:{scaleX:0.96,scaleY:0.96,x:-25,y:-58}}]},2).toE({state:[]},2).waitE(71));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(19).toE({_off:false},0).toE({_off:true},285).waitE(5).toE({_off:false},0).toE({_off:true},27).waitE(4).toE({_off:false},0).toE({_off:true},93).waitE(5).toE({_off:false},0).toE({_off:true},132).waitE(4).toE({_off:false},0).toE({_off:true},42).waitE(3).toE({_off:false},0).toE({_off:true},23).waitE(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.drink = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_2
	this.instance = new lib.orange_slide();
	this.instance.parent = this;
	this.instance.setTransform(-31.4,113.2);
	this.instance._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(48).toE({_off:false},0).toE({rotation:-16,y:99},671).waitE(1));

	// 圖層_5
	this.instance_1 = new lib.drink2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(143,-4.8);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).toE({rotation:-15,y:-20},719).waitE(1));

	// 圖層_4
	this.instance_2 = new lib.drink1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-62.8,0);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).toE({rotation:11,x:-62.7,y:15.3},719).waitE(1));

	// 圖層_3
	this.instance_3 = new lib.orange_slide();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-151,70.7,1.13,1.13,71,0,0,0.1,0.2);
	this.instance_3._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(108).toE({_off:false},0).toE({regY:0.3,rotation:82,x:-151.1,y:86.9},611).waitE(1));

	// 圖層_1
	this.instance_4 = new lib.ice_cude();
	this.instance_4.parent = this;
	this.instance_4.setTransform(180.3,-0.4);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_4)).toE({rotation:-10,x:162,y:10.5},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(178.3,-15.4,19.1,17.2);

(lib.dot_with19 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgNQAAgMAJgJQAJgIAMAAQANAAAJAIQAIAJAAAMQAAANgIAJQgJAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAIgNAAQgMAAgJgIgAh0hJQgIgJAAgMQAAgNAIgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgJQAJgIANAAQAMAAAJAIQAIAJAAANQAAAMgIAJQgJAJgMAAQgNAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with18 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgNQAAgMAJgJQAJgIAMAAQANAAAJAIQAIAJAAAMQAAANgIAJQgJAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAIgNAAQgMAAgJgIgAh0hJQgIgJAAgMQAAgNAIgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgJQAJgIANAAQAMAAAJAIQAIAJAAANQAAAMgIAJQgJAJgMAAQgNAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with13 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAIQgJAJgMAAQgNAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgNQAAgMAJgJQAIgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgIgIg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with12 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAIQgJAJgMAAQgNAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgNQAAgMAJgJQAIgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgIgIg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);

(lib.dot_with11 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_13();
	this.instance.parent = this;
	this.instance.setTransform(-70,-86);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70,-86,140,172);


(lib.dot_with10 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.bitmap_sence4_13();
	this.instance.parent = this;
	this.instance.setTransform(-70,-86);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70,-86,140,172);

(lib.dot_with9 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgNQAAgMAJgJQAJgIAMAAQANAAAIAIQAJAJAAAMQAAANgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAIgNAAQgMAAgJgIgAh0hJQgIgJAAgMQAAgNAIgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJANAAQAMAAAJAJQAIAIAAANQAAAMgIAJQgJAJgMAAQgNAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with8 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgNQAAgMAJgJQAJgIAMAAQANAAAIAIQAJAJAAAMQAAANgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAIgNAAQgMAAgJgIgAh0hJQgIgJAAgMQAAgNAIgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJANAAQAMAAAJAJQAIAIAAANQAAAMgIAJQgJAJgMAAQgNAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with7 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAIQgJAJgNAAQgMAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgMQAAgNAJgJQAIgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgIgIg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with6 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAIQgJAJgNAAQgMAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgMQAAgNAJgJQAIgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgIgIg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with5 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAIAIQAJAJAAANQAAAMgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAh0hJQgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJAMAAQANAAAJAJQAIAIAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);


(lib.dot_with4 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AEJE0QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAIAIQAJAJAAANQAAAMgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAh0hJQgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJAMAAQANAAAJAJQAIAIAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJg");

	this.timeline.addTween(TTF(cjs.Tween.get(this.shape)).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.6,-31.6,63.3,63.3);

(lib.circle3 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// flash0.ai
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFC351").s().p("AgnACIAAgCIBPguIAAAAIAABcIgBABg");
	this.shape.setTransform(-15.6,-0.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFC351").s().p("AAACSIgCgEIAAhYIABgFIBRAwIAAABIABAAIAAABIAAABIhRAugABRBiIAAgBIABAAIAAABgAhRAAIAAgCIBQguIAAABIAABdgAgCgzIAAhdIABgBIBQAvIAAACIhQAug");
	this.shape_1.setTransform(-11.4,-0.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFC351").s().p("AhUCRIAAhbIABgFIBTAwIAAABIAAAAIAAABIhRAvgAAABiIAAgBIBSgvIACABIAABZIgIABgABSAvIAAhdIBRAuIAAABIhRAvgAiiAAIABgDIBOgtIABABIAABdgAAAhgIAAgDIBRguIADACIAABeIAAAAIAAABIABgBIgCABgAhUgzIAAhdIABgBIBTAwIhTAvgAhbiPIACAAIgCABIAAgBg");
	this.shape_2.setTransform(-3.3,-0.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFC351").s().p("AABDGIAAgCIBUgwIAABgIgBACgAhTD0IAAi8IACgFIBRAwIAAAAIABAAIAAACIhTAxIBTAwIhRAvgAinDEIAAhfIBUAwIhSAvgABWCUIBSgwIABABIAABZIgEADgAABBjIAAAAIBTgwIABABIAABggAilBjIAAAAIgFADgACnBiIAAhfIBUAwIAAAAIhSAwgAj5AyIAAgCIBUgwIhUgwIBTgvIACAAIAADAIgBACgABTAxIAAheIBTAvIhSAwgAikAAIBTguIAAAAIAABegACnheIAAAAIAAgBIABAAIBTAwIAAACIhUAwgAj6gwIABAAIAAACIgBABgAABheIAAgDIBUgwIAABiIAAgBIAAABIABAAIgBABgAhTgxIAAjAIACgBIBRAvIAAACIABAAIAAABIhTAwIBTAxIhSAvgABWiRIBSgvIABAAIAABfgAinhhIAAhfIABAAIBTAwIhTAvgAABjCIBTgvIABABIAABfgACnjDIAAgDIAFADIgDABgAinjCIACAAIgBAAgAhSj0IABgBIAAABIAAAAg");
	this.shape_3.setTransform(-3.4,-0.6);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFC351").s().p("ABSFWIAAhgIBTAwIhSAwgAijEkIBRgvIAAABIAABegACmDIIACgDIBSAvIAAABIhUAxgAj3DzIBQguIACAAIAABegAAADFIAAgCIBUgxIAABgIgBACgAhUDzIAAi9IACgFIBSAwIAAABIAAAAIAAABIhTAxIBTAxIhSAvgAioDDIAAhgIBUAwIhTAwgABVCSIBSgwIABABIAABfgAAABiIAAgBIBTgvIABABIAABfgAimBhIAAAAIgFADgAD7AyIAAgDIBTgvIABBgIgBACIABAAIgBAAgACmBhIAAhgIBUAxIhSAwgAj6AwIAAgCIBUgvIhUgxIBTgvIACAAIAADBIgBABgAlOBgIAAhgIBUAwIhRAwgABSAvIAAhdIBTAuIhSAwgAilAAIBTgwIAAABIAABdgACmhgIAAABIABgCIAAAAIBTAxIAAACIhUAvgAD7gwIBSgwIABBggAlKhgIBQAuIAAADIhSAvgAAAhgIAAgDIBUgwIAABiIABAAIgBABIABgBIgBABgAhUgzIAAjAIACgBIBSAvIAAACIAAAAIAAABIhTAxIBTAwIhSAvgABViSIBSgwIABAAIAABfgAiohjIAAhfIABAAIBTAwIhTAvgAAAjEIBTgvIABABIAABfgACmjFIAAhcIBRAwIhPAtgAj5jzIBUgxIAABgIgCAAgABSj1IAAhfIBTAwIhSAwgAilklIBTgwIAAAAIAABfIAAABg");
	this.shape_4.setTransform(-3.3,-0.4);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFC351").s().p("AhVGzIAAhcIACgBIBSAwIAAABIABAAIAAABIhQAuIgFgDgAAAGHIBRgwIACABIAABZIgGADgAj7FVIBUgxIhUgwIBSgwIACABIAAC/IhUgvgAClEmIBQAvIhQAtgABRFVIAAhfIBTAwIhTAvgAhTFUIhTgvIBTgwIAAABIAABegAClDIIACgDIBSAvIAAACIhUAwgAlPEmIAAhhIAAgCIBUAxIAAACIhUAwgAD6D0IBSgwIACABIAABdIgCACgAAADEIAAgCIBTgwIAABgIgBACgAhVDzIAAi9IACgFIBSAwIAAAAIABAAIAAACIhVAxIBVAwIhTAwgAFMDCIAAhfIBTAwIhSAwgAipDCIAAhfIBTAwIhSAwgABUCSIBSgwIABABIAABfgAmgCRIBSgvIABAAIAABfgAAABhIAAAAIBRgwIACABIAABggAinBhIAAAAIgFADgAD6AxIAAgCIBTgvIhTgxIBSgwIACABIAAC/IgBACIABAAIgBABgAClBgIAAhfIBUAwIhTAwgAj7AwIAAgCIBUgvIhUgxIBSgvIACAAIAADAIAAACgAlPBfIAAhfIBUAwIhTAwgABRAvIAAheIBTAvIhTAwgAFOAAIBSguIAAABIABABIAABbgAimgBIBTgvIAAAAIAABegAmbgqIBKAqIhNAsIADhWgAClhgIgBABIABgCIAAAAIBUAwIAAACIhUAwgAlPhhIABgBIBTAwIAAACIhUAwgAAAhgIAAgDIBTgwIAABiIAAAAIAAAAIABAAIgCABgAhVgzIAAjAIACgBIBSAvIAAACIABAAIAAABIhVAwIBVAxIhTAvgAFMhiIAAhfIBRAuIAAADIhQAugABUiTIBSgvIABAAIAABfgAiphjIAAhfIABAAIBSAwIhSAvgAlOhjIhJgqIABgLIBIgqIABAAIAABfgAAAjEIBRgvIACABIAABfgAD6jzIAAgCIBNgtIAHAEIAABaIABgBIAAABIgCABgACljFIAAhfIBUAxIhTAvgAj7jzIAAgCIBUgxIhSgvIBSgvIAADAIgBAAgAlPjFIAAhfIBUAxIhTAvgABRj1IAAhfIBTAwIhTAvgAimklIBTgwIAAAAIAABfIAAAAgAClmFIgCABIABgCIABgBIBUAxIAAACIhUAwgAlPkkIAJgFIgJAFgAD6lWIAAAAIAAAAIAAAAgAAAmGIAAgCIBMgtIAHAEIAABaIAAAAIAAABIgBAAgAhVlXIAAhcIAEgCIBRAvIhTAwg");
	this.shape_5.setTransform(-3.2,-0.4);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFC351").s().p("AgXHfIBOgtIAAArQgYADgaAAgAhxHRIAAiAIACgBIBSAwIAAABIABAAIAAABIhUAwIBKAsQgjgDgogKgAA4GyIBSgvIABAAIAABKIgZAGgAjFGzIAAgwIABAAIBTAvIgkAUQgWgHgagMgAgcGBIBSgwIABABIAABggACJGAIAAhfIBUAwIhSAwgAkXFRIAAgCIBUgwIhUgxIBTgvIACAAIAADBIgCABgADeFRIAAgCIBUgwIhUgxIBSgvIACAAIAAC2IgJAIgAlrEzIAAgSIBUAwIgjAUQgbgXgWgbgAA1FQIAAhgIBTAwIhSAwgAhvFPIhTgwIBTgwIAAABIAABfgAEzEfIBSgwIABABIAAAuQgNASgOAPgAmEESIAYAOIgKAFgACJDCIACgDIBSAvIAAACIhUAxgAlrC/IAAgBIBUAwIAAACIhUAxgAgcC/IAAgCIBTgxIAABgIgBACgAGEDtIAAjAIABgBIgBAAIABgBIBRAwIAAABIABAAIAAACIhTAwIA+AkIgPAhIguAbgAhxDtIAAi9IACgFIBSAwIAAABIABAAIAAABIhUAxIBUAxIhTAvgAEwC9IAAhgIBTAwIhSAwgAjFC9IAAhgIBUAwIhTAwgAA4CMIBSgwIABABIAABfgAm8CLIBSgvIABAAIAABggAnFCPIAIgEIAAAagAgcBcIAAgBIBSgvIABABIAABfgAnICFQgKgkgFgpIAYgOIACACIAABfgAjDBbIAAAAIgFADgADeAsIAAgDIBUgvIhUgwIBSgxIACABIAADAIgBACIABAAIgBAAgAHXBbIABAAIAAABgACJBbIAAhfIBUAwIhSAwgAkXAqIAAgCIBUgvIhUgxIBTgvIACAAIAADBIgBABgAlrBaIAAhfIBUAvIhTAxgAA1ApIAAhdIBTAvIhSAvgAEzgGIBSgvIABABIAABdgAm/AoIAAhcIAAgBIBTAvIhTAvgAjCgGIBTgwIAAABIAABdgACJhmIAAABIABgCIAAAAIBTAxIAAACIhUAwgAlrhnIABgBIBTAwIAAADIhUAwgAgchmIAAgDIBTgwIAABiIAAAAIAAABIABgBIgBABgAGEg4IAAjAIABgBIAmAVQANAYAHATIg7AiIBUAxIAAAAIgBgBIAAABIhSAwgAnWhEQAGgmAOgsIAFgDIAABhIgCACgAhxg5IAAjAIACgBIBSAvIAAACIABAAIAAABIhUAxIBUAwIhTAvgAEwhoIAAhfIBTAwIhSAvgAA4iYIBSgwIABAAIAABfgAjFhpIAAhfIABAAIBTAwIhTAvgAlqhpIhSgvIBSgwIABAAIAABfgAgcjKIBSgvIABABIAABfgAnBibIAEgKIAAAMgADej5IAAgCIBUgxIhUgwIBCgmIASANIAACrIABgBIAAABIgCABgACJjLIAAheIBUAwIhSAvgAkXj5IAAgCIBUgxIhUgwIBTgwIACABIAADBIgCAAgAlrjLIAAheIBUAwIhTAvgAA1j7IAAhfIBTAwIhSAwgAEzkrIAwgcQAYAbALAPIAAAigAjCkrIBTgwIAAAAIAABfIAAABgAlwktIAEADIgLAGgACJmLIgBABIAAgCIACAAIBTAwIAAACIhUAxgAlrkyQAZgfAggbIAbAQIAAACIhUAxgAgcmMIAAgCIBTgxIAABiIABAAIgBABIAAAAgAhxldIAAh0QAXgFAegEIg0AdIBUAxIhTAwgAjFmOIAAglQAegOAfgJIAXANIhTAvgAA4m+IAqgYQATAEAWAGIAAA+gAAAnfIAFAAQAeAAAUADIAAAdg");
	this.shape_6.setTransform(-0.4,0.2);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFC351").s().p("AlJFKQiJiIAAjCQAAjACJiJQCJiJDAAAQDCAACICJQCJCJAADAQAADCiJCIQiICJjCAAQjAAAiJiJg");
	this.shape_7._off = true;

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFC351").s().p("AhWHuIgGgBIAMhFQi6gjhuicQhuieAhi+QAii+CehwQCchsC6AeIgMBFIAGABQC/AiBuCeQBwCfgiC9QgiC/ieBvQh6BViMAAQgqAAgsgIg");
	this.shape_8.setTransform(0,9.4);
	this.shape_8._off = true;

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFC351").s().p("AAqHpIAAsqIAZgBQCoAAB3B3QB4B3AACnQAACph4B2Qh3B4ioAAIgZgBgAlaD7Qh+h/gBizQABi0B+iAQB2h1CjgJIAANjQijgKh2h1g");
	this.shape_9.setTransform(0,-2.3);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFC351").s().p("ACJGXIAAqAIATAAQCGAABdBdQBfBfAACEQAACFhfBdQhdBfiGAAIgTgBgAl1DHQhohoAAiTQAAiTBohpQBhhgCFgHIAALGQiFgHhhhhg");
	this.shape_10.setTransform(0.9,-2.6);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFC351").s().p("ADzFWIAAnZIAPgBQBiAABGBGQBGBFAABiQAABihGBGQhGBGhiAAIgPgBgAmVC5QhahaAAiAQAAiABahbQBVhUBzgGIAAJqQhzgHhVhUg");
	this.shape_11.setTransform(-2.2,-4.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFC351").s().p("AGQD4IAAkbIAJgBQA7AAApApQAqAqAAA7QAAA7gqAqQgpAqg7AAIgJgBgAnnB5Qg/hAAAhZQAAhaA/g/QA7g7BRgEIAAGwQhRgFg7g6g");
	this.shape_12.setTransform(-1.6,-4.6);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFC351").s().p("AIACzIAAitIAGgBQAkAAAZAaQAaAaAAAkQAAAkgaAZQgZAagkAAIgGgBgAo1AxQgngoAAg2QAAg4AngnQAlglAygCIAAELQgygDglgkg");
	this.shape_13.setTransform(-2.7,-3.2);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFC351").s().p("AJnCJIAAhiIADAAQAUAAAOAOQAOAPAAAUQAAAUgOAOQgOAPgUAAIgDAAgAqBAKQgZgYAAgkQAAgkAZgZQAYgXAggCIAACrQgggCgYgXg");
	this.shape_14.setTransform(-3.2,-2.8);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},54).toE({state:[{t:this.shape_4}]},3).toE({state:[{t:this.shape_5}]},2).toE({state:[{t:this.shape_6}]},2).toE({state:[{t:this.shape_7}]},2).toE({state:[{t:this.shape_8}]},50).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},24).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},91).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},34).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},97).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},43).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_7}]},112).toE({state:[{t:this.shape_9}]},4).toE({state:[{t:this.shape_10}]},3).toE({state:[{t:this.shape_11}]},3).toE({state:[{t:this.shape_12}]},3).toE({state:[{t:this.shape_13}]},3).toE({state:[{t:this.shape_14}]},3).toE({state:[]},2).waitE(146));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_7)).waitE(69).toE({_off:false},0).toE({_off:true},50).waitE(6).toE({_off:false},0).toE({_off:true},24).waitE(6).toE({_off:false},0).toE({_off:true},91).waitE(5).toE({_off:false},0).toE({_off:true},34).waitE(6).toE({_off:false},0).toE({_off:true},97).waitE(5).toE({_off:false},0).toE({_off:true},43).waitE(5).toE({_off:false},0).waitE(112).toE({_off:true},4).waitE(163));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_8)).waitE(119).toE({_off:false},0).toE({_off:true},6).waitE(24).toE({_off:false},0).toE({_off:true},6).waitE(91).toE({_off:false},0).toE({_off:true},5).waitE(34).toE({_off:false},0).toE({_off:true},6).waitE(97).toE({_off:false},0).toE({_off:true},5).waitE(43).toE({_off:false},0).toE({_off:true},5).waitE(279));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-19.6,-5.3,8,9.5);

(lib.circle2 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AltlCIATgUIAZgXIKuKwIgpAqg");
	this.shape.setTransform(0.2,-0.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AlilCQAZgSAcgOIKQKQQgOAcgSAZg");
	this.shape_1.setTransform(7.8,-7.8);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AlEkEQAHghANgfIJ1J2QgcALglAIg");
	this.shape_2.setTransform(-14.9,15);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AkFkEQAugDAoAEIGzGzQAEAtgDApg");
	this.shape_3.setTransform(22.6,-22.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AC1EIIm8m8QgDgqADgrIIRIRQgVACgWAAQgVAAgVgCg");
	this.shape_4.setTransform(-22.2,22.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AieieQBxAjBUBVQBUBTAkByg");
	this.shape_5.setTransform(30.7,-30.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgqAqQhXhXgkh4IFLFLQh4gjhYhZg");
	this.shape_6.setTransform(-30.2,30.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AlDkvQAdgLAlgIIJFJEQgIAhgMAgg");
	this.shape_7.setTransform(15.4,-15.3);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AljkvQARgeAPgWIKnKnQgbATgZANg");
	this.shape_8.setTransform(-7.4,7.5);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}}]}).toE({state:[]},3).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}}]},3).toE({state:[{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},3).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},3).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}}]},3).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}}]},3).toE({state:[]},3).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}}]},20).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}}]},5).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}}]},4).toE({state:[]},5).toE({state:[{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}}]},42).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},4).toE({state:[{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},5).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},11).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},7).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},15).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},2).toE({state:[{t:this.shape_6,p:{scaleX:1.5,scaleY:1.5,x:-45.3,y:45.4}},{t:this.shape_4,p:{scaleX:1.5,scaleY:1.5,x:-33.2,y:33.4}},{t:this.shape_2,p:{scaleX:1.5,scaleY:1.5,x:-22.4,y:22.5}},{t:this.shape_8,p:{scaleX:1.5,scaleY:1.5,x:-11.1,y:11.2}},{t:this.shape,p:{scaleX:1.5,scaleY:1.5,x:0.3,y:-0.2}},{t:this.shape_1,p:{scaleX:1.5,scaleY:1.5,x:11.8,y:-11.6}},{t:this.shape_7,p:{scaleX:1.5,scaleY:1.5,x:23.1,y:-22.9}},{t:this.shape_3,p:{scaleX:1.5,scaleY:1.5,x:33.9,y:-33.7}},{t:this.shape_5,p:{scaleX:1.5,scaleY:1.5,x:46,y:-45.8}}]},84).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},8).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},38).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},2).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},1).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},1).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},21).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},4).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},18).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},5).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},60).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},5).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},20).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},6).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},23).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},6).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},6).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}}]},20).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}}]},30).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape_8,p:{scaleX:1,scaleY:1,x:-7.4,y:7.5}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}},{t:this.shape_4,p:{scaleX:1,scaleY:1,x:-22.2,y:22.2}}]},26).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},48).toE({state:[{t:this.shape_6,p:{scaleX:1,scaleY:1,x:-30.2,y:30.3}},{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},7).toE({state:[{t:this.shape_2,p:{scaleX:1,scaleY:1,x:-14.9,y:15}},{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_3,p:{scaleX:1,scaleY:1,x:22.6,y:-22.5}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},7).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_1,p:{scaleX:1,scaleY:1,x:7.8,y:-7.8}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}},{t:this.shape_5,p:{scaleX:1,scaleY:1,x:30.7,y:-30.6}}]},6).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}},{t:this.shape_7,p:{scaleX:1,scaleY:1,x:15.4,y:-15.3}}]},7).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}}]},5).toE({state:[{t:this.shape,p:{scaleX:1,scaleY:1,x:0.2,y:-0.1}}]},5).toE({state:[]},6).waitE(85));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-36.3,-36.7,73.1,73.1);

(lib.circle_blue = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#29BCD0").s().p("AgRASQgIgIABgKQgBgKAIgHQAHgIAKABQAKgBAIAIQAHAHAAAKQAAAKgHAIQgIAHgKAAQgKAAgHgHg");
	this.shape.setTransform(-0.1,-0.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#29BCD0").s().p("AAMBpIAAAAIAAhJIgGADQgNAIgTABIgNAAIgCgYQgXgDgSgQQgRgPgFgWIBEgEIgBAAQgCgHABgHQgDghAVgYQAMgMAOgHIAKgEIAABiQAHgCAHAAQAVgBASAIIADAfQAKADAJAIQAJAIAGAJIhJADQALARABAVQABAggVAYIgKAKg");
	this.shape_1.setTransform(-1.5,2.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#29BCD0").s().p("ADHDJIAAABIh7iHIgEAOQgOAnggAgQgNANgNAKIgrgpQguAgg8AAQg8AAgvghIB7h6IgDADQgPgKgNgNQg6g5AAhRQAAgpAQgkQAGgOAIgMICjC1QAKgOANgNQAkglAugOIA6AzQAagIAfAAQAcAAAZAHIiBB+QAwANAlAmQA5A5AABQQAAARgCARg");
	this.shape_2.setTransform(-0.9,1.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#29BCD0").s().p("AAbE9QhMA0hhAAQhkAAhNg2IDLjIIgGAFQgXgRgXgWQhehdABiEQAAhfAvhLIBHBDQATgdAagaQA7g7BLgWIBcBSQArgMAxAAQAtAAApALIjQDNQBNAVA8A8QBcBbAACCQABAcgFAbIhahQQgQBehIBHQgVAWgYARg");
	this.shape_3.setTransform(-1.4,0.3);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#29BCD0").s().p("AAiDZQhfBCh6gBQh8AAhghDIIJoDQBgAaBLBLQB0BzAAChQgBAjgFAiIhwhkQgUB2haBZQgbAbgeAVg");
	this.shape_4.setTransform(8.9,5.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#29BCD0").s().p("AjnEEQhyhzAAihQAAhzA6hbIBWBSQAWgjAgggQBJhJBbgaIBxBkQA0gPA8AAQA3AAAxANIoJIDQgdgUgbgbg");
	this.shape_5.setTransform(-8.2,-9.3);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#29BCD0").s().p("AB3ELQhfBBh5AAQiiAAhzhzQhzhzAAihQAAhzA6hbIBWBSQAXgjAgggQBJhJBbgaIBxBkQA0gPA7AAQCiAABzByQBzBzAAChQAAAjgGAiIhwhkQgUB2haBZQgbAbgdAVg");
	this.shape_6.setTransform(1.4,-2.6);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#29BCD0").s().p("AkpEDQhyhyAAihQAAhzA6hcIBWBTIAFgJIhDhDQAWgeAcgcQBJhJBbgaIAdAaQAzgOA4AAQCiAAByByQBzBzAAChQAAAjgFAiIgZgXQgVB0hYBXQgbAbgdAVIhXhTIBDBCQhgBBh5AAQiiAAhzhzg");
	this.shape_7.setTransform(0.3,-0.2);
	this.shape_7._off = true;

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#29BCD0").s().p("AkUEUQhyhygBiiQABihByhzQBzhyChgBQCiABByByQB0BzgBChQABCih0ByQhyB0iigBQihABhzh0g");
	this.shape_8._off = true;

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#29BCD0").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdIEZAAQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcg");
	this.shape_9.setTransform(0,0.3);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#29BCD0").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQCMDUCNjUQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiDhxh6Bxg");
	this.shape_10.setTransform(0,0.3);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#29BCD0").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQB8ILCdoLQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiIoVh1IVg");
	this.shape_11.setTransform(0,0.3);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#29BCD0").s().p("AAeAJIAAg0QA2g/A5kGQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQgwkrgxg9gAkUESQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQA2EdA6AyQAFAEAFADIAAAfQgFAFgFAHQgwBIgyEYQhTgchDhDg");
	this.shape_12.setTransform(0,0.3);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#29BCD0").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQgiFcAiFjQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQBGlQhGlYg");

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#29BCD0").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQkvFKEvF1Qg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQEFlIkFlgg");

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#29BCD0").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQmRFbGRFkQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQFqlMlqlcg");

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},3).toE({state:[{t:this.shape_5},{t:this.shape_4}]},3).toE({state:[{t:this.shape_6}]},3).toE({state:[{t:this.shape_7}]},3).toE({state:[{t:this.shape_8}]},3).toE({state:[{t:this.shape_7}]},44).toE({state:[{t:this.shape_8}]},5).toE({state:[{t:this.shape_7}]},226).toE({state:[{t:this.shape_8}]},6).toE({state:[{t:this.shape_7}]},110).toE({state:[{t:this.shape_8}]},5).toE({state:[{t:this.shape_7}]},161).toE({state:[{t:this.shape_8}]},5).toE({state:[{t:this.shape_9}]},26).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[{t:this.shape_14}]},2).toE({state:[{t:this.shape_15}]},2).toE({state:[]},2).waitE(92));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_7)).waitE(21).toE({_off:false},0).toE({_off:true},3).waitE(44).toE({_off:false},0).toE({_off:true},5).waitE(226).toE({_off:false},0).toE({_off:true},6).waitE(110).toE({_off:false},0).toE({_off:true},5).waitE(161).toE({_off:false},0).toE({_off:true},5).waitE(134));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_8)).waitE(24).toE({_off:false},0).toE({_off:true},44).waitE(5).toE({_off:false},0).toE({_off:true},226).waitE(6).toE({_off:false},0).toE({_off:true},110).waitE(5).toE({_off:false},0).toE({_off:true},161).waitE(5).toE({_off:false},0).toE({_off:true},26).waitE(108));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.6,-2.6,5.1,5.1);

(lib.circle1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#6552AB").s().p("An+KIIAA0OQCMhDCnAAQEnAADSDRQDRDRAAEnQAAEojRDRQjSDRknAAQinAAiMhCg");
	this.shape.setTransform(76.3,41.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(101,82,171,0.498)").s().p("An+KIIAA0OQCMhDCnAAQEnAADSDRQDRDRAAEnQAAEojRDRQjSDRknAAQinAAiMhCg");
	this.shape_1.setTransform(76.3,41.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#6552AB").s().p("AB+GjQg+ghg2g2QiIiKAAjCQAAjCCIiKQA2g1A+ghIABAAIAANFIgBAAg");
	this.shape_2.setTransform(12.8,63.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#6552AB").s().p("ACsI6IgDgCQhUgshHhIQi6i8AAkIQAAkJC6i7QBHhHBUgsIADgCIABAAIAARzIgBAAg");
	this.shape_3.setTransform(8.3,93.7);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(255,255,255,0.498)").s().p("ABsFnIgCgBQg0gcgtgtQh1h3AAimQAAimB1h2QAtgtA0gcIACgBIABAAIAALNIgBAAg");
	this.shape_4.setTransform(14.1,58.9);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#6552AB").s().p("AlWGjIAAtFQBhgzB3AAQDBAACKCJQCKCKAADCQAADCiKCKQiKCKjBAAQh3AAhhgzg");
	this.shape_5.setTransform(59.8,40.9);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#6552AB").s().p("AjtNNIgBgBQg1gcgtgtQh2h3AAimQAAinB2h2QAtgtA1gcIABgBIABAAIAALOIgBAAgAjmAsIAAtFQBhgzB3AAQDBAACKCJQCJCKAADDQAADCiJCKQiKCJjBAAQh3AAhhgzg");
	this.shape_6.setTransform(48.6,78.4);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("rgba(101,82,171,0.498)").s().p("AlWGjIAAtFQBhgzB3AAQDBAACKCJQCKCKAADCQAADCiKCKQiKCKjBAAQh3AAhhgzg");
	this.shape_7.setTransform(59.8,40.9);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#6552AB").s().p("ABsFnIgCgBQg0gcgtgtQh1h3AAimQAAimB1h2QAtgtA0gcIACgBIABAAIAALNIgBAAg");
	this.shape_8.setTransform(14.1,127);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#6552AB").s().p("AjYKyIgBgBIAAl6IgBAAIgDgCIAAjbIgDgBQg5ghgzgxQiJiJAAjDQAAjDCJiJQAzgzA5gfIADgBIAADbIADgCIABgBIAAF6IABgBQBigzB2AAQDCAACKCJQCKCJAADDQAADDiKCKQiKCJjCAAQh2AAhigzg");
	this.shape_9.setTransform(47.1,74.1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#6552AB").s().p("AjYGjIgCgBIgGgEQg6gggygxQiJiKAAjDQAAjCCJiKQAygxA6ggIAGgDIACgCQBigzB2AAQDCAACKCJQCKCKAADCQAADDiKCKQiKCJjCAAQh2AAhigzg");
	this.shape_10.setTransform(47.1,63.4);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#6552AB").s().p("AjYGjQg+ghg2g1QiJiKAAjDQAAjCCJiKQA2g1A+ghQBigzB2AAQDCAACKCJQCKCKAADCQAADDiKCKQiKCJjCAAQh2AAhigzg");
	this.shape_11.setTransform(47.1,63.4);
	this.shape_11._off = true;

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#6552AB").s().p("AjYIBIgFgDIAAhWIAEAAIAAhOIgEAAIAAhPQg8ghgzgzQiJiKAAjBQAAjDCJiKQAzgzA8gfIAAClIAEgDIAABOIABAAQBig0B2AAQDCAACKCKQCKCJAADCQAADDiKCKQiKCJjCAAQh2AAhigzg");
	this.shape_12.setTransform(47.1,70.5);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#6552AB").s().p("AlMHDQiJiKAAjCQAAjCCJiKQA2g1A9ggIAAi6IABgBQBigzB2AAQDCAACKCJQCKCKAADDQAADBiKCKQiKCKjCAAQh2AAhigzIgBgBIAAC6Qg9ghg2g1g");
	this.shape_13.setTransform(47.1,70.1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#6552AB").s().p("AlMHbQiJiKAAjDQAAjCCJiJQAzgzA8ggIAAiGIAFgEIAFgCIAAhgQBfgxB0AAQDCAACKCJQCKCKAADDQAADBiKCKQiKCKjCAAQh0AAhfgxIAABgIgFgCIgFgDIAACGQg8gggzgzg");
	this.shape_14.setTransform(47.1,62.6);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#6552AB").s().p("AlTGjIgGgDIAAs+IAGgEQBhgzB3AAQDCAACKCJQCJCKAADCQAADDiJCKQiKCJjCAAQh3AAhhgzg");
	this.shape_15.setTransform(59.4,80.1);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#6552AB").s().p("AB9GjIgBgBQg+ghg1g1QiJiKAAjCQAAjCCJiKQA1g1A+ggIABgBIAEgCIAANJIgEgCg");
	this.shape_16.setTransform(12.9,63.4);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},4).toE({state:[{t:this.shape_1}]},4).toE({state:[]},1).toE({state:[{t:this.shape_2}]},3).toE({state:[]},4).toE({state:[{t:this.shape_3}]},4).toE({state:[]},5).toE({state:[{t:this.shape_5},{t:this.shape_4}]},7).toE({state:[{t:this.shape_6}]},3).toE({state:[{t:this.shape_8},{t:this.shape_7}]},3).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_9}]},9).toE({state:[{t:this.shape_9}]},8).toE({state:[{t:this.shape_10}]},7).toE({state:[{t:this.shape_11}]},75).toE({state:[{t:this.shape_12}]},98).toE({state:[{t:this.shape_11}]},11).toE({state:[{t:this.shape_12}]},13).toE({state:[{t:this.shape_11}]},10).toE({state:[{t:this.shape_12}]},13).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_13}]},78).toE({state:[{t:this.shape_11}]},7).toE({state:[{t:this.shape_14}]},14).toE({state:[{t:this.shape_11}]},7).toE({state:[{t:this.shape_15}]},119).toE({state:[]},5).toE({state:[{t:this.shape_16}]},16).toE({state:[]},3).waitE(184));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_11)).waitE(141).toE({_off:false},0).toE({_off:true},98).waitE(11).toE({_off:false},0).toE({_off:true},13).waitE(10).toE({_off:false},0).toE({_off:true},13).waitE(2).toE({_off:false},0).toE({_off:true},78).waitE(7).toE({_off:false},0).toE({_off:true},14).waitE(7).toE({_off:false},0).toE({_off:true},119).waitE(208));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.circle_red = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6647C").s().p("AgRASQgIgIABgKQgBgKAIgHQAHgIAKABQAKgBAIAIQAHAHAAAKQAAAKgHAIQgIAHgKAAQgKAAgHgHg");
	this.shape.setTransform(-0.1,-0.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E6647C").s().p("AAMBpIAAAAIAAhJIgGADQgNAIgTABIgNAAIgCgYQgXgDgSgQQgRgPgFgWIBEgEIgBAAQgCgHABgHQgDghAVgYQAMgMAOgHIAKgEIAABiQAHgCAHAAQAVgBASAIIADAfQAKADAJAIQAJAIAGAJIhJADQALARABAVQABAggVAYIgKAKg");
	this.shape_1.setTransform(-1.5,2.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#E6647C").s().p("ADHDJIAAABIh7iHIgEAOQgOAnggAgQgNANgNAKIgrgpQguAgg8AAQg8AAgvghIB7h6IgDADQgPgKgNgNQg6g5AAhRQAAgpAQgkQAGgOAIgMICjC1QAKgOANgNQAkglAugOIA6AzQAagIAfAAQAcAAAZAHIiBB+QAwANAlAmQA5A5AABQQAAARgCARg");
	this.shape_2.setTransform(-0.9,1.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#E6647C").s().p("AAbE9QhMA0hhAAQhkAAhNg2IDLjIIgGAFQgXgRgXgWQhehdABiEQAAhfAvhLIBHBDQATgdAagaQA7g7BLgWIBcBSQArgMAxAAQAtAAApALIjQDNQBNAVA8A8QBcBbAACCQABAcgFAbIhahQQgQBehIBHQgVAWgYARg");
	this.shape_3.setTransform(-1.4,0.3);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#E6647C").s().p("ABaEoQheBBh6AAQh9AAhghEIIJoDQBgAaBMBLQBzBzAAChQAAAjgGAiIhwhkQgUB2haBZQgbAbgdAVgAlZC8QhzhzAAihQAAhzA6hbIBWBSQAXgjAgggQBJhJBbgaIBwBkQA1gPA7AAQA3AAAyANIoJIDQgdgUgbgbg");
	this.shape_4.setTransform(3.2,-2.1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#E6647C").s().p("AB3ELQhfBBh5AAQiiAAhzhzQhzhzAAihQAAhzA6hbIBWBSQAXgjAgggQBJhJBbgaIBxBkQA0gPA7AAQCiAABzByQBzBzAAChQAAAjgGAiIhwhkQgUB2haBZQgbAbgdAVg");
	this.shape_5.setTransform(1.4,-2.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#E6647C").s().p("AkpEDQhyhyAAihQAAhzA6hcIBWBTIAFgJIhDhDQAWgeAcgcQBJhJBbgaIAdAaQAzgOA4AAQCiAAByByQBzBzAAChQAAAjgFAiIgZgXQgVB0hYBXQgbAbgdAVIhXhTIBDBCQhgBBh5AAQiiAAhzhzg");
	this.shape_6.setTransform(0.3,-0.2);
	this.shape_6._off = true;

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#E6647C").s().p("AkUEUQhyhygBiiQABihByhzQBzhyChgBQCiABByByQB0BzgBChQABCih0ByQhyB0iigBQihABhzh0g");
	this.shape_7._off = true;

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#E6647C").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdIEZAAQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcg");
	this.shape_8.setTransform(0,0.3);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#E6647C").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQCMDUCNjUQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiDhxh6Bxg");
	this.shape_9.setTransform(0,0.3);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#E6647C").s().p("Ah+FxQhTgchDhDQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQB8ILCdoLQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQiIoVh1IVg");
	this.shape_10.setTransform(0,0.3);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#E6647C").s().p("AAeAJIAAg0QA2g/A5kGQBLAdA8A8QB0B0gBChIAAAKIAAAPQgICRhrBqQhCBDhTAcQgwkrgxg9gAkUESQhqhqgIiRIAAgPIgBgKQABihByh0QA9g8BLgdQA2EdA6AyQAFAEAFADIAAAfQgFAFgFAHQgwBIgyEYQhTgchDhDg");
	this.shape_11.setTransform(0,0.3);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#E6647C").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQgiFcAiFjQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQBGlQhGlYg");

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#E6647C").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQkvFKEvF1Qg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQEFlIkFlgg");

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#E6647C").s().p("AkUEUQhqhpgIiSIAAgOIgBgLQABihByhzQAwgwA3gbQmRFbGRFkQg3gcgwgwgADClUQAsAaAmAmQB0BzgBChIAAALIAAAOQgICShrBpQgmAngsAZQFqlMlqlcg");

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},3).toE({state:[{t:this.shape_4}]},3).toE({state:[{t:this.shape_5}]},3).toE({state:[{t:this.shape_6}]},3).toE({state:[{t:this.shape_7}]},3).toE({state:[{t:this.shape_6}]},44).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_6}]},226).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_6}]},110).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_6}]},161).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},26).toE({state:[{t:this.shape_9}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[{t:this.shape_14}]},2).toE({state:[]},2).waitE(92));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_6)).waitE(21).toE({_off:false},0).toE({_off:true},3).waitE(44).toE({_off:false},0).toE({_off:true},5).waitE(226).toE({_off:false},0).toE({_off:true},6).waitE(110).toE({_off:false},0).toE({_off:true},5).waitE(161).toE({_off:false},0).toE({_off:true},5).waitE(134));
	this.timeline.addTween(TTF(cjs.Tween.get(this.shape_7)).waitE(24).toE({_off:false},0).toE({_off:true},44).waitE(5).toE({_off:false},0).toE({_off:true},226).waitE(6).toE({_off:false},0).toE({_off:true},110).waitE(5).toE({_off:false},0).toE({_off:true},161).waitE(5).toE({_off:false},0).toE({_off:true},26).waitE(108));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.6,-2.6,5.1,5.1);


(lib.triangle_red_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.triangle_red();
	this.instance.parent = this;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({scaleX:1.4,scaleY:1.4,rotation:-85,x:36.4,y:-16.5},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);


(lib.triangle_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.trianlge();
	this.instance.parent = this;
	this.instance.setTransform(17.5,-0.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:60,x:38.4,y:-27},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.1,-9.4,16.4,18.9);

(lib.triangle_blue_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.triangle_blue();
	this.instance.parent = this;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-80,x:-21.5,y:-21.5},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.3,5.9,3.4,3.4);

(lib.rect3_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rect3();
	this.instance.parent = this;
	this.instance.setTransform(0.4,33.5);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:140,x:-74.3,y:-36.9},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.6,-15.6,31.3,31.3);


(lib.rect_blue_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle_blue();
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:80,x:31.2,y:23.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.5,-2.5,5.1,5.1);

(lib.triangle2_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.triangle2();
	this.instance.parent = this;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({scaleX:1.4,scaleY:1.4,rotation:-85,x:36.4,y:-16.5},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);

(lib.rect_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rect1();
	this.instance.parent = this;
	this.instance.setTransform(28.9,65.7);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-30,x:7.7,y:53.3},239).toE({regX:-0.1,regY:0.1,scaleX:1,scaleY:1,rotation:-90,x:-8.4,y:44.1},183).toE({scaleX:1,scaleY:1,rotation:-180,x:-18.9,y:38.1},117).toE({scaleX:1,scaleY:1,rotation:-200,x:-34.7,y:28.7},180).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(27,15.1,3.7,3.4);

(lib.rect2_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rect2();
	this.instance.parent = this;
	this.instance.setTransform(-3.7,3.7);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:180,x:-32.5,y:-25.1},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.9,-4.1,7.8,8.2);

(lib.rect_red_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rect_red();
	this.instance.parent = this;
	this.instance.setTransform(0.4,33.5);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:140,x:-74.3,y:-36.9},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.6,-15.6,31.3,31.3);

(lib.rc_conbine_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.rc_conbine();
	this.instance.parent = this;
	this.instance.setTransform(0,-2.5);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-131,x:21.5,y:-12.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,-3.4,12,7);

(lib.laptop_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.laptop();
	this.instance.parent = this;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-8,x:21,y:-28.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.phone = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.phone_front();
	this.instance.parent = this;
	this.instance.setTransform(39.5,-14.9);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(76).toE({regX:0.4,regY:0.1,rotation:-20,x:39.6,y:-43.4},643).waitE(1));

	// 圖層_2
	this.instance_1 = new lib.phone_back();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42.1,-12.9);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).waitE(51).toE({rotation:-15,x:-56.9,y:-57.7},0).toE({scaleX:1,scaleY:1,rotation:-14.8,y:-57.5},1).toE({scaleX:1,scaleY:1,rotation:0,x:-42.1,y:29.6},667).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.line1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// ll_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AgNAOQgGgGAAgIQAAgHAGgGQAGgGAHAAQAIAAAGAGQAFAGABAHQgBAIgFAGQgGAFgIABQgHgBgGgFg");

	this.instance = new lib.line_dot();
	this.instance.parent = this;
	this.instance.setTransform(-0.5,2.4);
	this.instance._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.instance}]},1).toE({state:[{t:this.instance}]},28).toE({state:[{t:this.instance}]},451).toE({state:[{t:this.instance}]},45).toE({state:[{t:this.instance}]},3).toE({state:[]},42).waitE(150));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1).toE({_off:false},0).waitE(28).toE({y:2.5},0).toE({x:-10.8,y:-7},451).waitE(45).toE({alpha:0},0).waitE(3).toE({alpha:1},0).toE({_off:true},42).waitE(150));

	// ll_2
	this.instance_1 = new lib.line_dot();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.5,21.5);
	this.instance_1._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).waitE(20).toE({_off:false},0).waitE(28).toE({x:-10.8,y:11.9},432).waitE(53).toE({alpha:0},0).waitE(4).toE({alpha:1},0).toE({_off:true},56).waitE(127));

	// ll_3
	this.instance_2 = new lib.line_dot();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.5,40.7);
	this.instance_2._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(41).toE({_off:false},0).waitE(20).toE({x:-10.8,y:31.1},419).waitE(62).toE({alpha:0},0).waitE(4).toE({alpha:1},0).toE({_off:true},32).waitE(142));

	// ll_4
	this.instance_3 = new lib.line_dot();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0.2,60.5);
	this.instance_3._off = true;

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(59).toE({_off:false},0).waitE(9).toE({x:-10.1,y:50.9},412).waitE(66).toE({alpha:0},0).waitE(4).toE({alpha:1},0).toE({_off:true},35).waitE(135));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.9,-1.9,3.9,3.9);


(lib.dot1 = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgUAWQgJgKAAgMQAAgMAJgIQAIgJAMAAQAMAAAJAJQAJAIAAAMQAAAMgJAKQgJAIgMAAQgMAAgIgIg");
	this.shape.setTransform(3,91.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgUAWQgJgKAAgMQAAgMAJgIQAJgJALAAQANAAAIAJQAJAIAAAMQAAAMgJAKQgIAIgNAAQgLAAgJgIg");
	this.shape_1.setTransform(3,91.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgVAVQgIgJAAgMQAAgMAIgIQAJgJAMAAQAMAAAJAJQAJAIAAAMQAAAMgJAJQgJAJgMAAQgMAAgJgJg");
	this.shape_2.setTransform(3,91.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgVAVQgIgIAAgNQAAgLAIgJQAJgJAMAAQAMAAAJAJQAJAJAAALQAAANgJAIQgJAJgMAAQgMAAgJgJg");
	this.shape_3.setTransform(3,91.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgLAJgJQAIgJAMAAQAMAAAJAJQAJAJAAALQAAAMgJAJQgJAJgMAAQgMAAgIgJg");
	this.shape_4.setTransform(5.9,94.3);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgUAVQgJgIAAgNQAAgLAJgJQAIgJAMAAQAMAAAJAJQAJAJAAALQAAANgJAIQgJAJgMAAQgMAAgIgJg");
	this.shape_5.setTransform(8.3,96.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgLAJgJQAJgJALAAQANAAAIAJQAJAJAAALQAAAMgJAJQgIAJgNAAQgLAAgJgJg");
	this.shape_6.setTransform(5.8,94.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgMAJgIQAJgJALAAQANAAAIAJQAJAIAAAMQAAAMgJAJQgIAJgNAAQgLAAgJgJg");
	this.shape_7.setTransform(5.5,94.2);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgUAVQgJgIAAgNQAAgLAJgJQAJgJALAAQANAAAIAJQAJAJAAALQAAANgJAIQgIAJgNAAQgLAAgJgJg");
	this.shape_8.setTransform(5.9,94.5);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgUAWQgJgJAAgNQAAgLAJgJQAIgJAMAAQAMAAAJAJQAJAJAAALQAAANgJAJQgJAIgMAAQgMAAgIgIg");
	this.shape_9.setTransform(12.2,100.5);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AgUAWQgJgJAAgNQAAgLAJgJQAJgJALAAQANAAAIAJQAJAJAAALQAAANgJAJQgIAIgNAAQgLAAgJgIg");
	this.shape_10.setTransform(9.3,97.4);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgMAJgIQAJgJALAAQAMAAAJAJQAJAIAAAMQAAAMgJAJQgJAJgMAAQgLAAgJgJg");
	this.shape_11.setTransform(5.7,93.9);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgMAJgIQAIgJAMAAQAMAAAJAJQAJAIAAAMQAAAMgJAJQgJAJgMAAQgMAAgIgJg");
	this.shape_12.setTransform(6.4,94.7);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AgUAVQgJgJAAgMQAAgMAJgIQAIgJAMAAQAMAAAJAJQAJAIAAAMQAAAMgJAJQgJAJgMAAQgMAAgIgJg");
	this.shape_13.setTransform(8.3,96.6);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AgVAVQgIgJAAgMQAAgMAIgIQAKgJALAAQANAAAIAJQAJAIAAAMQAAAMgJAJQgIAJgNAAQgLAAgKgJg");
	this.shape_14.setTransform(9,97.3);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AEJE0QgIgJAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAJQgJAIgNAAQgMAAgJgIgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkzkIQgIgJAAgMQAAgNAIgJQAJgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgJgIg");
	this.shape_15.setTransform(31.6,120);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("rgba(255,255,255,0.2)").s().p("AEJE0QgIgJAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAJQgJAIgNAAQgMAAgJgIgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkzkIQgIgJAAgMQAAgNAIgJQAJgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgJgIg");
	this.shape_16.setTransform(31.6,120);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("rgba(255,255,255,0.498)").s().p("AEJE0QgIgJAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAJQgJAIgNAAQgMAAgJgIgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkzkIQgIgJAAgMQAAgNAIgJQAJgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgJgIg");
	this.shape_17.setTransform(31.6,120);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:3,y:91.4}},{t:this.shape_1,p:{x:3,y:91.4}},{t:this.shape,p:{x:3,y:91.4}}]}).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_4,p:{x:5.9,y:94.3}}]},1).toE({state:[{t:this.shape_3,p:{x:2.9,y:91.4}},{t:this.shape_6,p:{x:5.8,y:94.3}},{t:this.shape_5,p:{x:8.3,y:96.7}}]},1).toE({state:[{t:this.shape_3,p:{x:2.9,y:91.4}},{t:this.shape_7,p:{x:5.5,y:94.2}},{t:this.shape_4,p:{x:8.8,y:97.3}}]},1).toE({state:[{t:this.shape_3,p:{x:2.9,y:91.4}},{t:this.shape_8,p:{x:5.9,y:94.5}},{t:this.shape_4,p:{x:10.4,y:98.8}}]},1).toE({state:[{t:this.shape_3,p:{x:2.9,y:91.4}},{t:this.shape_1,p:{x:7.2,y:95.5}},{t:this.shape_5,p:{x:11.2,y:99.4}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:5.3,y:93.6}},{t:this.shape_6,p:{x:9,y:97}},{t:this.shape_9,p:{x:12.2,y:100.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:5.7,y:93.9}},{t:this.shape_10,p:{x:9.3,y:97.4}},{t:this.shape_4,p:{x:12.9,y:101.3}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:5.3,y:93.6}},{t:this.shape_6,p:{x:9.6,y:97.7}},{t:this.shape,p:{x:14,y:102.3}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:5.7,y:94.2}},{t:this.shape_6,p:{x:10,y:98.2}},{t:this.shape,p:{x:14.6,y:103.1}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:5.8,y:94.2}},{t:this.shape_10,p:{x:10.1,y:98.4}},{t:this.shape_5,p:{x:15.3,y:103.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:6.4,y:94.7}},{t:this.shape_1,p:{x:11.3,y:99.9}},{t:this.shape_5,p:{x:18.2,y:106.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:6.8,y:95.2}},{t:this.shape_1,p:{x:12.8,y:101.2}},{t:this.shape,p:{x:20.7,y:109}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:7.2,y:95.5}},{t:this.shape_8,p:{x:15.1,y:103.4}},{t:this.shape_5,p:{x:24.2,y:112.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:7.5,y:95.8}},{t:this.shape_6,p:{x:16.2,y:104.5}},{t:this.shape_5,p:{x:26.3,y:114.6}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:7.9,y:96.3}},{t:this.shape_1,p:{x:16.9,y:105.2}},{t:this.shape_4,p:{x:28,y:116.3}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_13},{t:this.shape_10,p:{x:18.1,y:106.4}},{t:this.shape_12,p:{x:30.2,y:118.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:9,y:97.3}},{t:this.shape_1,p:{x:19.2,y:107.5}},{t:this.shape_5,p:{x:31.7,y:120}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:9.5,y:97.8}},{t:this.shape_8,p:{x:20,y:108.3}},{t:this.shape_9,p:{x:33.4,y:121.8}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:9.9,y:98.3}},{t:this.shape_6,p:{x:20.8,y:109.1}},{t:this.shape,p:{x:35.5,y:123.9}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:10.2,y:98.9}},{t:this.shape_1,p:{x:22.3,y:110.6}},{t:this.shape_5,p:{x:37.1,y:125.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:10.7,y:99.1}},{t:this.shape_6,p:{x:22.9,y:111.2}},{t:this.shape_4,p:{x:37.9,y:126.2}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:11.1,y:99.4}},{t:this.shape_7,p:{x:23.4,y:111.7}},{t:this.shape,p:{x:38.5,y:126.8}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:11.4,y:99.8}},{t:this.shape_8,p:{x:24,y:112.4}},{t:this.shape_5,p:{x:39.5,y:127.8}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:11.7,y:100}},{t:this.shape_6,p:{x:24.5,y:113}},{t:this.shape,p:{x:40.3,y:128.6}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:11.8,y:100.2}},{t:this.shape_10,p:{x:25.1,y:113.6}},{t:this.shape_5,p:{x:41.1,y:129.5}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:12.2,y:100.6}},{t:this.shape_8,p:{x:25.9,y:114.2}},{t:this.shape,p:{x:41.9,y:130.2}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:12.5,y:100.8}},{t:this.shape_10,p:{x:26.8,y:115.4}},{t:this.shape_5,p:{x:43.2,y:131.8}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:12.8,y:101.2}},{t:this.shape_1,p:{x:27.7,y:116.1}},{t:this.shape_4,p:{x:44.7,y:133}}]},1).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:13.1,y:101.4}},{t:this.shape_10,p:{x:28.4,y:116.8}},{t:this.shape,p:{x:45.6,y:134}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:13.3,y:101.7}},{t:this.shape_8,p:{x:29,y:117.3}},{t:this.shape,p:{x:46.4,y:134.7}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:13.6,y:101.9}},{t:this.shape_8,p:{x:30,y:118.3}},{t:this.shape_5,p:{x:47.6,y:135.9}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:13.7,y:102.1}},{t:this.shape_10,p:{x:30.7,y:119.1}},{t:this.shape_4,p:{x:48.7,y:137}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:13.9,y:102.2}},{t:this.shape_7,p:{x:31.5,y:119.8}},{t:this.shape,p:{x:49.9,y:138.2}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:14.1,y:102.5}},{t:this.shape_1,p:{x:32.2,y:120.5}},{t:this.shape_9,p:{x:50.9,y:139.2}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:15.2,y:103.5}},{t:this.shape_10,p:{x:33.5,y:121.8}},{t:this.shape_4,p:{x:52.2,y:140.5}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_7,p:{x:15.7,y:104}},{t:this.shape_10,p:{x:33.9,y:122.2}},{t:this.shape_5,p:{x:52.8,y:141.2}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_11,p:{x:16.2,y:104.6}},{t:this.shape_1,p:{x:34.6,y:122.9}},{t:this.shape_9,p:{x:53.5,y:141.9}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:16.6,y:105}},{t:this.shape_10,p:{x:35.1,y:123.5}},{t:this.shape_9,p:{x:54,y:142.4}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:17,y:105.5}},{t:this.shape_10,p:{x:35.7,y:124}},{t:this.shape_5,p:{x:54.6,y:143}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_7,p:{x:17.5,y:106}},{t:this.shape_10,p:{x:36.1,y:124.5}},{t:this.shape_4,p:{x:55,y:143.3}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:18.1,y:106.4}},{t:this.shape_8,p:{x:36.3,y:124.6}},{t:this.shape_5,p:{x:55.3,y:143.5}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.3}},{t:this.shape_11,p:{x:18.4,y:107}},{t:this.shape_1,p:{x:37,y:125.5}},{t:this.shape,p:{x:55.9,y:144.4}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:19.1,y:107.5}},{t:this.shape_8,p:{x:38,y:126.3}},{t:this.shape,p:{x:57.1,y:145.4}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:19.5,y:108}},{t:this.shape_10,p:{x:38.5,y:126.7}},{t:this.shape_4,p:{x:57.7,y:146}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_2,p:{x:20.1,y:108.5}},{t:this.shape_1,p:{x:39.1,y:127.4}},{t:this.shape_9,p:{x:58.2,y:146.5}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:20.9,y:109.3}},{t:this.shape_6,p:{x:39.7,y:128}},{t:this.shape,p:{x:58.8,y:147.2}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:21.3,y:109.6}},{t:this.shape_6,p:{x:40.1,y:128.5}},{t:this.shape_4,p:{x:59.3,y:147.7}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_14,p:{x:21.7,y:110.1}},{t:this.shape_8,p:{x:40.7,y:129.1}},{t:this.shape_4,p:{x:59.7,y:148.1}}]},2).toE({state:[{t:this.shape_3,p:{x:3,y:91.4}},{t:this.shape_12,p:{x:22.1,y:110.5}},{t:this.shape_8,p:{x:41.2,y:129.6}},{t:this.shape_9,p:{x:60.3,y:148.7}}]},2).toE({state:[{t:this.shape_15}]},1).toE({state:[{t:this.shape_16}]},131).toE({state:[{t:this.shape_15}]},8).toE({state:[{t:this.shape_17}]},68).toE({state:[{t:this.shape_15}]},15).toE({state:[{t:this.shape_16}]},219).toE({state:[{t:this.shape_15}]},10).toE({state:[]},63).waitE(135));

	// 圖層_2
	this.instance = new lib.dot_with4("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(31.6,120);
	this.instance._off = true;

	this.instance_1 = new lib.dot_with5("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(49.3,102.3);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("rgba(255,255,255,0.2)").s().p("AEJE0QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAIAIQAJAJAAANQAAAMgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAh0hJQgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJAMAAQANAAAJAJQAIAIAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJg");
	this.shape_18.setTransform(49.3,102.3);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},72).toE({state:[{t:this.instance_1}]},18).toE({state:[{t:this.shape_18}]},108).toE({state:[{t:this.instance_1}]},25).toE({state:[{t:this.shape_18}]},46).toE({state:[{t:this.instance_1}]},33).toE({state:[]},326).waitE(92));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(72).toE({_off:false},0).toE({_off:true,x:49.3,y:102.3},18).waitE(630));

	// 圖層_4
	this.instance_2 = new lib.dot_with6("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(45.4,106.6);
	this.instance_2._off = true;

	this.instance_3 = new lib.dot_with7("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(67,84.7);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("rgba(255,255,255,0.2)").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJAMAAQANAAAJAJQAIAJAAAMQAAANgIAIQgJAJgNAAQgMAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgMQAAgNAJgJQAIgIANAAQAMAAAJAIQAJAJAAANQAAAMgJAJQgJAIgMAAQgNAAgIgIg");
	this.shape_19.setTransform(67,84.7);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_2}]},86).toE({state:[{t:this.instance_3}]},40).toE({state:[{t:this.shape_19}]},161).toE({state:[{t:this.instance_3}]},11).toE({state:[{t:this.shape_19}]},235).toE({state:[{t:this.instance_3}]},10).toE({state:[]},66).waitE(111));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(86).toE({_off:false},0).toE({_off:true,x:67,y:84.7},40).waitE(594));

	// 圖層_5
	this.instance_4 = new lib.dot_with8("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(62.5,89.4);
	this.instance_4._off = true;

	this.instance_5 = new lib.dot_with9("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(84.7,67);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("rgba(255,255,255,0.2)").s().p("AEJE0QgJgJAAgNQAAgMAJgJQAJgIAMAAQANAAAIAIQAJAJAAAMQAAANgJAJQgIAIgNAAQgMAAgJgIgABKB1QgJgJAAgMQAAgNAJgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAIgNAAQgMAAgJgIgAh0hJQgIgJAAgMQAAgNAIgJQAJgIAMAAQANAAAJAIQAIAJAAANQAAAMgIAJQgJAJgNAAQgMAAgJgJgAkzkIQgIgJAAgMQAAgNAIgIQAJgJANAAQAMAAAJAJQAIAIAAANQAAAMgIAJQgJAJgMAAQgNAAgJgJg");
	this.shape_20.setTransform(84.7,67);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_4}]},117).toE({state:[{t:this.instance_5}]},47).toE({state:[{t:this.shape_20}]},369).toE({state:[{t:this.instance_5}]},22).toE({state:[]},89).waitE(76));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_4)).waitE(117).toE({_off:false},0).toE({_off:true,x:84.7,y:67},47).waitE(556));

	// 圖層_6
	this.instance_6 = new lib.dot_with12("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(79.5,72.1);
	this.instance_6._off = true;

	this.instance_7 = new lib.dot_with13("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(102.3,49.3);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("rgba(255,255,255,0.2)").s().p("AEJEzQgIgIAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAIAJAAAMQAAANgIAIQgJAJgMAAQgNAAgJgJgABKB1QgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAh0hJQgIgJAAgNQAAgMAIgJQAJgJANAAQAMAAAJAJQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgJgIgAkykIQgJgJAAgNQAAgMAJgJQAIgIANAAQAMAAAJAIQAJAJAAAMQAAANgJAJQgJAIgMAAQgNAAgIgIg");
	this.shape_21.setTransform(102.3,49.3);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_6}]},153).toE({state:[{t:this.instance_7}]},76).toE({state:[{t:this.shape_21}]},113).toE({state:[{t:this.instance_7}]},15).toE({state:[]},246).waitE(117));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_6)).waitE(153).toE({_off:false},0).toE({_off:true,x:102.3,y:49.3},76).waitE(491));

	// 圖層_7
	this.instance_8 = new lib.dot_with18("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(97.3,54.4);
	this.instance_8._off = true;

	this.instance_9 = new lib.dot_with19("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(120,31.6);

	this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_8}]},212).toE({state:[{t:this.instance_9}]},77).toE({state:[]},346).waitE(85));
	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_8)).waitE(212).toE({_off:false},0).toE({_off:true,x:120,y:31.6},77).waitE(431));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,88.4,6,6);


(lib.circle2_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle2();
	this.instance.parent = this;
	this.instance.setTransform(-0.2,0.2);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-122,x:32.9,y:-18.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-36.5,-36.5,73.1,73.1);


(lib.circle_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle1();
	this.instance.parent = this;
	this.instance.setTransform(47,47,1,1,0,0,0,47,47);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(29).toE({x:-22.9,y:-14.5},690).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;

(lib.circle3_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle3();
	this.instance.parent = this;
	this.instance.setTransform(15.7,0.6);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:60,x:56.2,y:26.6},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-4.7,8.1,9.5);


(lib.dot1_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.dot1();
	this.instance.parent = this;
	this.instance.setTransform(75.8,-12.5,1,1,0,0,0,75.8,75.8);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({x:96.7,y:-18.5},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,6,6);

(lib.circle_red_clip = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_1
	this.instance = new lib.circle_red();
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:80,x:31.2,y:23.7},719).waitE(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.5,-2.5,5.1,5.1);

(lib.kit_set = function(mode,startPosition,loop=false) {
	this.initialize(mode,startPosition,loop,{});

	// 圖層_2
	this.instance = new lib.pen();
	this.instance.parent = this;
	this.instance.setTransform(-244.1,59.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:-11,y:-23.9},719).waitE(1));

	// 圖層_1
	this.instance_1 = new lib.surface6();
	this.instance_1.parent = this;
	this.instance_1.setTransform(207.5,225.4);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).toE({x:203,y:205},67).toE({y:194.9},652).waitE(1));

	// 圖層_8
	this.instance_2 = new lib.surface5();
	this.instance_2.parent = this;
	this.instance_2.setTransform(112,191.5);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).toE({x:107.5,y:156.6},67).toE({y:146.5},652).waitE(1));

	// 圖層_7
	this.instance_3 = new lib.surface4();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0,157.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).toE({x:-4.5,y:101.8},67).toE({y:91.7},652).waitE(1));

	// 圖層_6
	this.instance_4 = new lib.surface3();
	this.instance_4.parent = this;
	this.instance_4.setTransform(24.5,-49.7);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_4)).toE({x:15.8,y:-20.7},719).waitE(1));

	// 圖層_5
	this.instance_5 = new lib.pc_main();
	this.instance_5.parent = this;
	this.instance_5.setTransform(146.5,-32.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_5)).toE({y:-54.2},719).waitE(1));

	// 圖層_4
	this.instance_6 = new lib.surface1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-141.9,-67.1);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_6)).toE({y:-147.1},719).waitE(1));

	// 圖層_3
	this.instance_7 = new lib.surface2();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-129.4,-19.4);

	this.timeline.addTween(TTF(cjs.Tween.get(this.instance_7)).toE({y:-62.9},719).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-61.9,-175.7,173.9,240.4);

	(lib.triangle_orange = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FF8C41").s().p("AgkgpIBJApIhJAqg");

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#FF8C41").s().p("AhWhjICtBjIitBkg");

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#FF8C41").s().p("AiLihIEXChIkXCig");
		this.shape_2._off = true;

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#FF8C41").s().p("Ah4AEIggAAIAAilIEXChIgGAEIAgAAIkRCeg");
		this.shape_3.setTransform(-2.9,0);
		this.shape_3._off = true;

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f("#FF8C41").s().p("Ag7hEIB3BEIh3BFg");

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},197).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},66).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},130).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},18).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},17).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},72).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},7).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_4}]},45).toE({state:[]},2).waitE(141));
		this.timeline.addTween(TTF(cjs.Tween.get(this.shape_2)).waitE(5).toE({_off:false},0).toE({_off:true},197).waitE(3).toE({_off:false},0).toE({_off:true},66).waitE(2).toE({_off:false},0).toE({_off:true},130).waitE(3).toE({_off:false},0).toE({_off:true},18).waitE(3).toE({_off:false},0).toE({_off:true},17).waitE(3).toE({_off:false},0).toE({_off:true},72).waitE(3).toE({_off:false},0).toE({_off:true},7).waitE(3).toE({_off:false},0).toE({_off:true},45).waitE(143));
		this.timeline.addTween(TTF(cjs.Tween.get(this.shape_3)).waitE(202).toE({_off:false},0).toE({_off:true},3).waitE(66).toE({_off:false},0).toE({_off:true},2).waitE(130).toE({_off:false},0).toE({_off:true},3).waitE(18).toE({_off:false},0).toE({_off:true},3).waitE(17).toE({_off:false},0).toE({_off:true},3).waitE(72).toE({_off:false},0).toE({_off:true},3).waitE(7).toE({_off:false},0).toE({_off:true},3).waitE(188));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);


	(lib.text_clip_8 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_47();
		this.instance.parent = this;
		this.instance.setTransform(-29.5,-12.8,0.536,0.536);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-29.5,-12.8,59,25.8);


	(lib.text_clip_7 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_47();
		this.instance.parent = this;
		this.instance.setTransform(-29.4,-12.8,0.536,0.536);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-29.4,-12.8,59,25.8);


	(lib.text_clip_6 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_48();
		this.instance.parent = this;
		this.instance.setTransform(-36.4,-12.5,0.52,0.52);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-36.4,-12.5,72.8,25);


	(lib.text_clip_5 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_48();
		this.instance.parent = this;
		this.instance.setTransform(-36.4,-12.5,0.52,0.52);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-36.4,-12.5,72.8,25);


	(lib.text_clip_4 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_46();
		this.instance.parent = this;
		this.instance.setTransform(-23.6,-13.5,0.563,0.563);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-23.6,-13.5,47.3,27);


	(lib.text_clip_3 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_46();
		this.instance.parent = this;
		this.instance.setTransform(-23.6,-13.5,0.563,0.563);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-23.6,-13.5,47.3,27);


	(lib.text_clip_2 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_49();
		this.instance.parent = this;
		this.instance.setTransform(-30,-12.8,0.536,0.536);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-30,-12.8,60.1,25.8);


	(lib.text_clip_1 = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_49();
		this.instance.parent = this;
		this.instance.setTransform(-30,-12.8,0.536,0.536);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-30,-12.8,60.1,25.8);

	(lib.side_cude_with_radius = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FFFFFF").s().p("AARAwIi6gBQAggrAtgxIACgCIEEBfIg9AAIhcAAg");
		this.shape.setTransform(-20.4,-11.8);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#FFFFFF").s().p("AADBjIi6gBQAggrAtgzQA9hBAzglICxDAIABAEIhhABIhUAAg");
		this.shape_1.setTransform(-19,-16.8);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#FFFFFF").s().p("AADCAIi6gBQAggrAtgzQBchkBJggQAmgQAtgMIAqD+IhhABIhUAAg");
		this.shape_2.setTransform(-19,-19.7);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#FFFFFF").s().p("AhUCQIi7gBQAggrAtgyQBchlBKgfQB2gzC2gLIhXCQQhWCOABABQABAChnAAIhSgBg");
		this.shape_3.setTransform(-10.2,-21.4);

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f("#FFFFFF").s().p("ABMCRIlbgBQAggsAtgyQBchlBKgfQB2gzC2gKIhdCPQhYCJgDAIIgMAAg");
		this.shape_4.setTransform(-8.6,-16.5);

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f("#FFFFFF").s().p("AkPCQQAggsAtgyQBchlBKgfQB2gzC2gKIhdCPQhYCJgDAHIgMABg");
		this.shape_5.setTransform(-10.2,-21.4);

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f("#FFFFFF").s().p("ABMCQIlbgBQAggrAtgyQBchkBKggQB2gzC2gLIhdCQQhYCKgDAGIgMAAg");
		this.shape_6.setTransform(-4.6,-11.3);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f("#FFFFFF").s().p("AkkBuIFaABIANAAQACgGBYiJIBdiRIArBYIigEIImCADIgnhEg");
		this.shape_7.setTransform(-2.8,-8);

		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f("#FFFFFF").s().p("AkzBIIFaABIANAAQACgHBYiJIA5hZIAkg3IAhBEIAoBSIiUEUImAAFIhTiQg");
		this.shape_8.setTransform(-1.3,-4.2);

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f("#FFFFFF").s().p("AjFD2IgQgcIhxjDIFaABIANAAQACgHBYiJIBdiQIBlDPIALAWIiREsg");
		this.shape_9.setTransform(0.6,0.7);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f("#FFFFFF").s().p("AiiEiIhHh5IhxjCIFaABIANAAQACgHBYiJIBdiRIBlDQIAyBoIiRE7g");
		this.shape_10.setTransform(2.6,5.6);

		this.instance = new lib.bitmap_sence5_51();
		this.instance.parent = this;
		this.instance.setTransform(-38,-35,0.105,0.105);

		this.instance_1 = new lib.bitmap_sence5_52();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-30,-26,0.105,0.105);

		this.instance_2 = new lib.bitmap_sence5_42();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-27,-22);

		this.instance_3 = new lib.bitmap_sence5_41();
		this.instance_3.parent = this;
		this.instance_3.setTransform(-34,-4);

		this.instance_4 = new lib.bitmap_sence5_44();
		this.instance_4.parent = this;
		this.instance_4.setTransform(-52,-47);

		this.instance_5 = new lib.bitmap_sence5_43();
		this.instance_5.parent = this;
		this.instance_5.setTransform(-58,-38);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},8).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},2).toE({state:[{t:this.shape_5},{t:this.shape_4}]},2).toE({state:[{t:this.shape_6}]},2).toE({state:[{t:this.shape_7},{t:this.shape_6}]},2).toE({state:[{t:this.shape_8},{t:this.shape_6}]},2).toE({state:[{t:this.shape_9},{t:this.shape_6}]},2).toE({state:[{t:this.shape_10},{t:this.shape_6}]},2).toE({state:[{t:this.instance_1},{t:this.instance}]},2).toE({state:[{t:this.instance_3,p:{x:-34}},{t:this.instance_2,p:{x:-27,y:-22}},{t:this.instance}]},140).toE({state:[{t:this.instance_1},{t:this.instance}]},3).toE({state:[{t:this.instance_3,p:{x:-34}},{t:this.instance_2,p:{x:-27,y:-22}},{t:this.instance}]},194).toE({state:[{t:this.instance_1},{t:this.instance}]},3).toE({state:[{t:this.instance_3,p:{x:-34}},{t:this.instance_2,p:{x:-27,y:-22}},{t:this.instance_5,p:{x:-58}},{t:this.instance_4,p:{x:-52}}]},169).toE({state:[{t:this.instance_3,p:{x:-6}},{t:this.instance_2,p:{x:-55,y:-2}},{t:this.instance_5,p:{x:-17}},{t:this.instance_4,p:{x:-84}}]},4).toE({state:[]},3).waitE(176));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;


	(lib.side_cude = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_35();
		this.instance.parent = this;
		this.instance.setTransform(-9,-3,0.02,0.022);
		this.instance._off = true;

		this.instance_1 = new lib.bitmap_sence5_36();
		this.instance_1.parent = this;
		this.instance_1.setTransform(2,-24,0.03,0.03);

		this.instance_2 = new lib.bitmap_sence5_38();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-10,-30);

		this.instance_3 = new lib.bitmap_sence5_37();
		this.instance_3.parent = this;
		this.instance_3.setTransform(-37,-22);

		this.instance_4 = new lib.bitmap_sence5_40();
		this.instance_4.parent = this;
		this.instance_4.setTransform(6,-31);

		this.instance_5 = new lib.bitmap_sence5_39();
		this.instance_5.parent = this;
		this.instance_5.setTransform(-23,-43);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},18).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.03,scaleY:0.03,x:2,y:-24}}]},2).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.03,scaleY:0.03,x:2,y:-24}}]},2).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.08,scaleY:0.08,x:-11,y:-32}}]},2).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},2).toE({state:[{t:this.instance_3,p:{x:-37,y:-22}},{t:this.instance_2,p:{x:-10,y:-30}},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-17,y:-39}}]},99).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},5).toE({state:[{t:this.instance},{t:this.instance_5,p:{x:-23,y:-43}},{t:this.instance_4,p:{x:6,y:-31}}]},92).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},3).toE({state:[{t:this.instance},{t:this.instance_5,p:{x:-23,y:-43}},{t:this.instance_4,p:{x:6,y:-31}}]},71).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},4).toE({state:[{t:this.instance},{t:this.instance_5,p:{x:-23,y:-43}},{t:this.instance_4,p:{x:6,y:-31}}]},61).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},3).toE({state:[{t:this.instance},{t:this.instance_5,p:{x:-23,y:-43}},{t:this.instance_4,p:{x:6,y:-31}}]},103).toE({state:[{t:this.instance},{t:this.instance_1,p:{scaleX:0.106,scaleY:0.106,x:-18,y:-36}}]},3).toE({state:[{t:this.instance_3,p:{x:-37,y:-22}},{t:this.instance_2,p:{x:-10,y:-30}},{t:this.instance_5,p:{x:-23,y:-43}},{t:this.instance_4,p:{x:13,y:-38}}]},160).toE({state:[{t:this.instance_3,p:{x:-64,y:4}},{t:this.instance_2,p:{x:31,y:-43}},{t:this.instance_5,p:{x:-54,y:-59}},{t:this.instance_4,p:{x:-4,y:-8}}]},4).toE({state:[]},3).waitE(74));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(18).toE({_off:false},0).waitE(3).toE({scaleX:0.04,scaleY:0.04,x:-15,y:-8},0).waitE(3).toE({scaleX:0.08,scaleY:0.08,x:-28,y:-19},0).waitE(3).toE({scaleX:0.11,scaleY:0.11,x:-37,y:-27},0).waitE(8).toE({_off:true},99).waitE(5).toE({_off:false},0).waitE(340).toE({_off:true},160).waitE(81));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;


	(lib.rect_orange = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FF8C41").s().p("AgmApIAAhRIBNAAIAABRg");
		this.shape.setTransform(3.8,-3.6);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#FF8C41").s().p("AhVBXIAAisIACgBICoCpIgEAEg");
		this.shape_1.setTransform(8.4,-8.2);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#FF8C41").s().p("AhVCoIAAlPIACgBICoCoIioCpg");
		this.shape_2.setTransform(8.4,0);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#FF8C41").s().p("AjMAAIDMjMIDNDMIjNDNg");

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f("#FF8C41").s().p("ArNAAILNrNILOLNIrOLOg");

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f("#FF8C41").s().p("AoAAAIIAoAIIBIAIoBIBg");
		this.shape_5._off = true;

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f("#FF8C41").s().p("AoPhEID6j7IIBIAIj6D7gAiwjdIDdjeIBRAAIGSGSIAACNIi/C/g");
		this.shape_6.setTransform(-2.7,-1.2);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f("#FF8C41").s().p("AoGhZIJYmWIA4BRIipNmIhRA3gACon+IFfIHIoHFeg");
		this.shape_7.setTransform(1,4.5);

		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f("#FF8C41").s().p("AnsgOIHZnZIIAIAInPHPg");
		this.shape_8.setTransform(2,-2.5);

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f("#FF8C41").s().p("AnKgyIGVmVIIAIBImOGNg");
		this.shape_9.setTransform(5.4,-5.7);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f("#FF8C41").s().p("AkpChIAAn0IBThUIIAIAIlNFPg");
		this.shape_10.setTransform(21.5,-8.9);

		this.shape_11 = new cjs.Shape();
		this.shape_11.graphics.f("#FF8C41").s().p("AkcBdIAAmqIA5g5IIAIAIkNENg");
		this.shape_11.setTransform(22.8,-12.2);

		this.shape_12 = new cjs.Shape();
		this.shape_12.graphics.f("#FF8C41").s().p("AjDAvIAAl+IGHGIIAAC2IhgBhg");
		this.shape_12.setTransform(23.4,-14.8);

		this.shape_13 = new cjs.Shape();
		this.shape_13.graphics.f("#FF8C41").s().p("AhXAlIAAjzICvCwIAADtg");
		this.shape_13.setTransform(29.5,-9.9);

		this.shape_14 = new cjs.Shape();
		this.shape_14.graphics.f("#FF8C41").s().p("AgnAMIAAhoIBQBRIAABog");
		this.shape_14.setTransform(37,-9.1);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},31).toE({state:[{t:this.shape_2}]},39).toE({state:[{t:this.shape_3}]},16).toE({state:[{t:this.shape_4}]},11).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},68).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},44).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},18).toE({state:[{t:this.shape_5}]},5).toE({state:[{t:this.shape_7}]},110).toE({state:[{t:this.shape_5}]},6).toE({state:[{t:this.shape_7}]},36).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_6}]},87).toE({state:[{t:this.shape_5}]},4).toE({state:[{t:this.shape_8}]},47).toE({state:[{t:this.shape_8}]},2).toE({state:[{t:this.shape_9}]},2).toE({state:[{t:this.shape_10}]},2).toE({state:[{t:this.shape_11}]},2).toE({state:[{t:this.shape_12}]},2).toE({state:[{t:this.shape_13}]},2).toE({state:[{t:this.shape_14}]},2).toE({state:[]},2).waitE(166));
		this.timeline.addTween(TTF(cjs.Tween.get(this.shape_5)).waitE(101).toE({_off:false},0).toE({_off:true},68).waitE(4).toE({_off:false},0).toE({_off:true},44).waitE(4).toE({_off:false},0).toE({_off:true},18).waitE(5).toE({_off:false},0).toE({_off:true},110).waitE(6).toE({_off:false},0).toE({_off:true},36).waitE(4).toE({_off:false},0).toE({_off:true},87).waitE(4).toE({_off:false},0).toE({_off:true},47).waitE(182));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-0.1,-7.7,7.8,8.2);

	(lib.main_head = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FFFFFF").s().p("Ag+AAIA+ggIA/AgIg/Ahg");
		this.shape.setTransform(-0.5,0.1);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#FFFFFF").s().p("AiOAAICOhLICPBLIiPBMg");
		this.shape_1.setTransform(-0.5,2.2);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#FFFFFF").s().p("AkdAAIEdiWIEeCWIkfCXg");
		this.shape_2.setTransform(-0.5,-1.1);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#FFFFFF").s().p("AmJAAIGJjPIGKDPImMDQg");
		this.shape_3.setTransform(-0.4,1.3);

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f("#000000").s().p("AhEAAIBEgjIBFAjIhFAlg");
		this.shape_4.setTransform(-0.4,2.4);

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f("#FFFFFF").s().p("AnsAAIHskEIHtEEInwEFg");
		this.shape_5.setTransform(-0.4,2.4);

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f("#000000").s().p("AifAAICfhUICgBUIigBVg");
		this.shape_6.setTransform(-0.4,1.3);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f("#FFFFFF").s().p("AopAAIIpkkIIqEkIotElg");
		this.shape_7.setTransform(-0.5,5.3);

		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f("#000000").s().p("Ah1AAIB1g+IB2A+Ih2A+g");
		this.shape_8.setTransform(-0.5,-7.6,1,1,0,0,0,-0.2,-0.1);

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f("#000000").s().p("Ah0AtIAAhZIDpAAIAABZg");
		this.shape_9.setTransform(-0.5,-3,1,1,0,0,0,-0.1,-0.1);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f("#000000").s().p("Ah1AAIB1g9IB2A9Ih2A+g");
		this.shape_10.setTransform(-0.5,1.5,1,1,0,0,0,-0.2,-0.1);

		this.shape_11 = new cjs.Shape();
		this.shape_11.graphics.f("#666666").s().p("AivAAICvhcICwBcIiwBdg");
		this.shape_11.setTransform(-0.4,1.7,1,1,0,0,0,-0.1,-0.1);

		this.shape_12 = new cjs.Shape();
		this.shape_12.graphics.f("#FFFFFF").s().p("Ao/AAII/kvII/EvIpCEwg");
		this.shape_12.setTransform(-0.4,4.1);

		this.shape_13 = new cjs.Shape();
		this.shape_13.graphics.f("#000000").s().p("Ah0BWIAAisIDpAAIAACsg");
		this.shape_13.setTransform(-0.5,-3.1,1,1,0,0,0,-0.1,4);

		this.shape_14 = new cjs.Shape();
		this.shape_14.graphics.f("#666666").s().p("Ak+AAIE+ioIE/CoIlACpg");
		this.shape_14.setTransform(-0.4,1.7,1,1,0,0,0,-0.2,-0.1);

		this.shape_15 = new cjs.Shape();
		this.shape_15.graphics.f("#000000").s().p("Ah1AAIB1g9IB2A9Ih2A/g");
		this.shape_15.setTransform(-0.5,-26.5,1,1,0,0,0,-0.2,-0.1);

		this.shape_16 = new cjs.Shape();
		this.shape_16.graphics.f("#000000").s().p("Ah0CNIAAkZIDpAAIAAEZg");
		this.shape_16.setTransform(-0.5,-3,1,1,0,0,0,-0.1,9.5);

		this.shape_17 = new cjs.Shape();
		this.shape_17.graphics.f("#666666").s().p("AmdAAIGdjaIGeDaImgDbg");
		this.shape_17.setTransform(-0.4,1.6,1,1,0,0,0,-0.3,-0.3);

		this.instance = new lib.bitmap_sence5_50();
		this.instance.parent = this;
		this.instance.setTransform(-49,-36,0.2,0.2);

		this.instance_1 = new lib.bitmap_sence5_34();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-52,-34);

		this.instance_2 = new lib.bitmap_sence5_33();
		this.instance_2.parent = this;
		this.instance_2.setTransform(0,-45);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.shape}]},4).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_3}]},2).toE({state:[{t:this.shape_5},{t:this.shape_4}]},2).toE({state:[{t:this.shape_7},{t:this.shape_6}]},2).toE({state:[{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8,p:{y:-7.6}}]},2).toE({state:[{t:this.shape_12},{t:this.shape_14},{t:this.shape_10},{t:this.shape_13},{t:this.shape_8,p:{y:-15.8}}]},2).toE({state:[{t:this.shape_12},{t:this.shape_17},{t:this.shape_10},{t:this.shape_16},{t:this.shape_15}]},2).toE({state:[{t:this.instance}]},2).toE({state:[{t:this.instance_2},{t:this.instance_1}]},188).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.instance_2},{t:this.instance_1}]},300).toE({state:[{t:this.instance}]},3).toE({state:[{t:this.shape_12},{t:this.shape_17},{t:this.shape_10},{t:this.shape_16},{t:this.shape_15}]},109).toE({state:[{t:this.shape_12},{t:this.shape_14},{t:this.shape_10},{t:this.shape_13},{t:this.shape_8,p:{y:-15.8}}]},2).toE({state:[{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8,p:{y:-7.6}}]},2).toE({state:[{t:this.shape_7},{t:this.shape_6}]},2).toE({state:[{t:this.shape_5},{t:this.shape_4}]},2).toE({state:[{t:this.shape_3}]},2).toE({state:[{t:this.shape_2}]},2).toE({state:[{t:this.shape_1}]},2).toE({state:[{t:this.shape}]},2).toE({state:[]},2).waitE(77));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;

	(lib.main_glass = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_3();
		this.instance.parent = this;
		this.instance.setTransform(-24,-11);

		this.instance_1 = new lib.bitmap_sence5_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-18,-40);

		this.instance_2 = new lib.bitmap_sence5_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-22,-38,0.103,0.103);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},9).toE({state:[{t:this.instance_1,p:{x:-30,y:-33}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-5,y:-32}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},3).toE({state:[{t:this.instance_1,p:{x:-30,y:-33}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-5,y:-32}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},209).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},168).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},112).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-18,y:-40}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-24,y:-11}}]},74).toE({state:[{t:this.instance_1,p:{x:-30,y:-33}},{t:this.instance,p:{scaleX:1.4,scaleY:1.4,x:-5,y:-32}}]},3).toE({state:[]},3).waitE(117));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(15).toE({_off:false},0).toE({_off:true},3).waitE(6).toE({_off:false},0).toE({_off:true},209).waitE(3).toE({_off:false},0).toE({_off:true},168).waitE(4).toE({_off:false},0).toE({_off:true},112).waitE(3).toE({_off:false},0).toE({_off:true},74).waitE(123));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;


	(lib.main_cube = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// layerN2
		this.instance = new lib.bitmap_sence5_32();
		this.instance.parent = this;
		this.instance.setTransform(-2,29);

		this.instance_1 = new lib.bitmap_sence5_31();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-7,23);

		this.instance_2 = new lib.bitmap_sence5_30();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-12,17);

		this.instance_3 = new lib.bitmap_sence5_29();
		this.instance_3.parent = this;
		this.instance_3.setTransform(-21,-5);

		this.instance_4 = new lib.bitmap_sence5_28();
		this.instance_4.parent = this;
		this.instance_4.setTransform(-21,-22);

		this.instance_5 = new lib.bitmap_sence5_27();
		this.instance_5.parent = this;
		this.instance_5.setTransform(-21,-28);

		this.instance_6 = new lib.bitmap_sence5_26();
		this.instance_6.parent = this;
		this.instance_6.setTransform(-22,-34);

		this.instance_7 = new lib.bitmap_sence5_25();
		this.instance_7.parent = this;
		this.instance_7.setTransform(-33,-44);

		this.instance_8 = new lib.bitmap_sence5_24();
		this.instance_8.parent = this;
		this.instance_8.setTransform(-38,-44);

		this.instance_9 = new lib.bitmap_sence5_23();
		this.instance_9.parent = this;
		this.instance_9.setTransform(-43,-44);

		this.instance_10 = new lib.bitmap_sence5_22();
		this.instance_10.parent = this;
		this.instance_10.setTransform(-51,-44);

		this.instance_11 = new lib.bitmap_sence5_21();
		this.instance_11.parent = this;
		this.instance_11.setTransform(-51,-44);

		this.instance_12 = new lib.bitmap_sence5_20();
		this.instance_12.parent = this;
		this.instance_12.setTransform(-52,-50);

		this.instance_13 = new lib.bitmap_sence5_19();
		this.instance_13.parent = this;
		this.instance_13.setTransform(-52,-59);

		this.instance_14 = new lib.bitmap_sence5_18();
		this.instance_14.parent = this;
		this.instance_14.setTransform(-59,-63);

		this.instance_15 = new lib.bitmap_sence5_17();
		this.instance_15.parent = this;
		this.instance_15.setTransform(-64,-69);

		this.instance_16 = new lib.bitmap_sence5_16();
		this.instance_16.parent = this;
		this.instance_16.setTransform(-57,-66);

		this.instance_17 = new lib.bitmap_sence5_15();
		this.instance_17.parent = this;
		this.instance_17.setTransform(-44,-61);

		this.instance_18 = new lib.bitmap_sence5_14();
		this.instance_18.parent = this;
		this.instance_18.setTransform(-44,-57);

		this.instance_19 = new lib.bitmap_sence5_13();
		this.instance_19.parent = this;
		this.instance_19.setTransform(-52,-60);

		this.instance_20 = new lib.bitmap_sence5_12();
		this.instance_20.parent = this;
		this.instance_20.setTransform(-52,-59);

		this.instance_21 = new lib.bitmap_sence5_9();
		this.instance_21.parent = this;
		this.instance_21.setTransform(-63,-72,0.61,0.61);
		this.instance_21._off = true;

		this.instance_22 = new lib.bitmap_sence5_11();
		this.instance_22.parent = this;
		this.instance_22.setTransform(-48,-54);

		this.instance_23 = new lib.bitmap_sence5_10();
		this.instance_23.parent = this;
		this.instance_23.setTransform(-57,-3);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance}]},7).toE({state:[{t:this.instance_1}]},2).toE({state:[{t:this.instance_2}]},2).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_4}]},2).toE({state:[{t:this.instance_5}]},2).toE({state:[{t:this.instance_6}]},2).toE({state:[{t:this.instance_7}]},2).toE({state:[{t:this.instance_8}]},2).toE({state:[{t:this.instance_9}]},2).toE({state:[{t:this.instance_10}]},2).toE({state:[{t:this.instance_11}]},2).toE({state:[{t:this.instance_12}]},2).toE({state:[{t:this.instance_13}]},2).toE({state:[{t:this.instance_14}]},37).toE({state:[{t:this.instance_15}]},3).toE({state:[{t:this.instance_16}]},6).toE({state:[{t:this.instance_17}]},2).toE({state:[{t:this.instance_18}]},2).toE({state:[{t:this.instance_19}]},2).toE({state:[{t:this.instance_20}]},2).toE({state:[{t:this.instance_21}]},2).toE({state:[{t:this.instance_21}]},3).toE({state:[{t:this.instance_23,p:{x:-57,y:-3}},{t:this.instance_22,p:{scaleX:1,scaleY:1,x:-48,y:-54}}]},77).toE({state:[{t:this.instance_21}]},2).toE({state:[{t:this.instance_23,p:{x:-57,y:-3}},{t:this.instance_22,p:{scaleX:1,scaleY:1,x:-48,y:-54}}]},126).toE({state:[{t:this.instance_21}]},3).toE({state:[{t:this.instance_23,p:{x:-57,y:-3}},{t:this.instance_22,p:{scaleX:1,scaleY:1,x:-48,y:-54}}]},266).toE({state:[{t:this.instance_21}]},3).toE({state:[{t:this.instance_22,p:{scaleX:1.22,scaleY:1.22,x:-66,y:-49}}]},72).toE({state:[{t:this.instance_23,p:{x:-57,y:-3}},{t:this.instance_22,p:{scaleX:1,scaleY:1,x:-48,y:-54}}]},4).toE({state:[{t:this.instance_23,p:{x:-29,y:-5}},{t:this.instance_22,p:{scaleX:1.22,scaleY:1.22,x:-99,y:-52}}]},3).toE({state:[]},3).waitE(69));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_21)).waitE(89).toE({_off:false},0).waitE(3).toE({scaleX:0.5,scaleY:0.5,x:-52,y:-60},0).toE({_off:true},77).waitE(2).toE({_off:false,y:-59},0).toE({_off:true},126).waitE(3).toE({_off:false},0).toE({_off:true},266).waitE(3).toE({_off:false},0).toE({_off:true},72).waitE(79));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;
	(lib.extend_line = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_2 (mask)
		var mask = new cjs.Shape();
		mask._off = true;
		var mask_graphics_0 = new cjs.Graphics().p("Al9FDIAAqpIL7AAIAALNg");
		var mask_graphics_1 = new cjs.Graphics().p("AgJFVIAAqpIATAAIAAKpg");
		var mask_graphics_12 = new cjs.Graphics().p("AgUFUIAAqpIApAAIAAKrg");
		var mask_graphics_14 = new cjs.Graphics().p("AgUFUIAAqpIApAAIAAKrg");
		var mask_graphics_16 = new cjs.Graphics().p("AgrFTIAAqpIBXAAIAAKtg");
		var mask_graphics_18 = new cjs.Graphics().p("AhKFRIAAqpICVAAIAAKxg");
		var mask_graphics_20 = new cjs.Graphics().p("Ah/FPIAAqpID/AAIAAK1g");
		var mask_graphics_22 = new cjs.Graphics().p("AiuFNIAAqpIFdAAIAAK5g");
		var mask_graphics_24 = new cjs.Graphics().p("AjbFLIAAqpIG3AAIAAK+g");
		var mask_graphics_26 = new cjs.Graphics().p("Aj+FJIAAqpIH9AAIAALBg");
		var mask_graphics_29 = new cjs.Graphics().p("AkeFHIAAqpII+AAIAALFg");
		var mask_graphics_32 = new cjs.Graphics().p("AlWFFIAAqpIKtAAIAALJg");
		var mask_graphics_35 = new cjs.Graphics().p("Al9FDIAAqpIL7AAIAALNg");
		var mask_graphics_577 = new cjs.Graphics().p("AlJFIIAAquIKTAAIAALNg");
		var mask_graphics_579 = new cjs.Graphics().p("AkUFNIAAqzIIpAAIAALNg");
		var mask_graphics_581 = new cjs.Graphics().p("AjZFSIAAq4IGzAAIAALNg");
		var mask_graphics_583 = new cjs.Graphics().p("AiVFZIAAq/IErAAIAALNg");
		var mask_graphics_585 = new cjs.Graphics().p("AhYFfIAArFICyAAIAALNg");
		var mask_graphics_587 = new cjs.Graphics().p("AgiFkIAArKIBFAAIAALNg");
		var mask_graphics_589 = new cjs.Graphics().p("AgiFkIAArKIBFAAIAALNg");

		this.timeline.addTween(TTF(cjs.Tween.get(mask)).toE({graphics:mask_graphics_0,x:-84.1,y:-12.4}).waitE(1).toE({graphics:mask_graphics_1,x:-32.9,y:-14.2}).waitE(11).toE({graphics:mask_graphics_12,x:-31.8,y:-14.1}).waitE(2).toE({graphics:mask_graphics_14,x:-31.8,y:-14.1}).waitE(2).toE({graphics:mask_graphics_16,x:-29.5,y:-14}).waitE(2).toE({graphics:mask_graphics_18,x:-26.4,y:-13.9}).waitE(2).toE({graphics:mask_graphics_20,x:-21.1,y:-13.6}).waitE(2).toE({graphics:mask_graphics_22,x:-16.4,y:-13.4}).waitE(2).toE({graphics:mask_graphics_24,x:-12,y:-13.2}).waitE(2).toE({graphics:mask_graphics_26,x:-8.4,y:-13}).waitE(3).toE({graphics:mask_graphics_29,x:-5.2,y:-12.9}).waitE(3).toE({graphics:mask_graphics_32,x:0.4,y:-12.6}).waitE(3).toE({graphics:mask_graphics_35,x:4.3,y:-12.4}).waitE(542).toE({graphics:mask_graphics_577,x:9.5,y:-12.4}).waitE(2).toE({graphics:mask_graphics_579,x:14.8,y:-12.4}).waitE(2).toE({graphics:mask_graphics_581,x:20.6,y:-12.4}).waitE(2).toE({graphics:mask_graphics_583,x:27.5,y:-12.4}).waitE(2).toE({graphics:mask_graphics_585,x:33.5,y:-12.4}).waitE(2).toE({graphics:mask_graphics_587,x:38.9,y:-12.4}).waitE(2).toE({graphics:mask_graphics_589,x:38.9,y:-12.4}).waitE(131));

		// 圖層_1
		this.instance = new lib.bitmap_sence5_45();
		this.instance.parent = this;
		this.instance.setTransform(-30,-18,0.087,0.087);

		var maskedShapeInstanceList = [this.instance];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(720));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;

	(lib.base_line = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_2 (mask)
		var mask = new cjs.Shape();
		mask._off = true;
		var mask_graphics_0 = new cjs.Graphics().p("Ai2A5IC5hxIC0Bxg");
		var mask_graphics_1 = new cjs.Graphics().p("Ai2A5IC5hxIC0Bxg");
		var mask_graphics_3 = new cjs.Graphics().p("AmHB7IGNj1IGBD1g");
		var mask_graphics_5 = new cjs.Graphics().p("AECDSIj3iuIkPCuImYAAIKnmjIKSGjg");
		var mask_graphics_7 = new cjs.Graphics().p("AG7ESImtkuInXEuImgAAIN3ojINcIjg");
		var mask_graphics_9 = new cjs.Graphics().p("AKtFpIqnneIrcHUImkgDISArHIR1LXg");
		var mask_graphics_11 = new cjs.Graphics().p("AKvGkICBhPIswo/Is7IRICSBbIl2AyIjWiFIT1sOIT2MoIj7CXg");
		var mask_graphics_13 = new cjs.Graphics().p("AIzFnID9icIswo/Is7IRIDsCUIAAEcIqmmoIT1sOIT2MoIrDGrg");
		var mask_graphics_15 = new cjs.Graphics().p("AF5GiIG3kQIswo+Is7IRIG7EVIAAEcIt1opIT1sPIT2MpIt9Icg");
		var mask_graphics_17 = new cjs.Graphics().p("Az1AkIT1sOIT2MoIxYKhIAAj/IKSmWIswo/Is7IRIK4G0IAAEbg");
		var mask_graphics_19 = new cjs.Graphics().p("Az1gEIT1sQIT2MpIz2MAgAs7gMINUIVIMXnoIswo/g");
		var mask_graphics_579 = new cjs.Graphics().p("Az1gEIT1sQIT2MpIz2MAgAs7gMINUIVIMXnoIswo/g");
		var mask_graphics_580 = new cjs.Graphics().p("Az1AkIT1sOIT2MoIxYKhIAAj/IKSmWIswo/Is7IRIK4G0IAAEbg");
		var mask_graphics_582 = new cjs.Graphics().p("AF5GiIG3kQIswo+Is7IRIG7EVIAAEcIt1opIT1sPIT2MpIt9Icg");
		var mask_graphics_584 = new cjs.Graphics().p("AIzFnID9icIswo/Is7IRIDsCUIAAEcIqmmoIT1sOIT2MoIrDGrg");
		var mask_graphics_586 = new cjs.Graphics().p("AKvGkICBhPIswo/Is7IRICSBbIl2AyIjWiFIT1sOIT2MoIj7CXg");
		var mask_graphics_588 = new cjs.Graphics().p("AKtFpIqnneIrcHUImkgDISArHIR1LXg");
		var mask_graphics_590 = new cjs.Graphics().p("AG7ESImtkuInXEuImgAAIN3ojINcIjg");
		var mask_graphics_592 = new cjs.Graphics().p("AECDSIj3iuIkPCuImYAAIKnmjIKSGjg");
		var mask_graphics_594 = new cjs.Graphics().p("AmHB7IGNj1IGBD1g");
		var mask_graphics_596 = new cjs.Graphics().p("Ai2A5IC5hxIC0Bxg");

		this.timeline.addTween(TTF(cjs.Tween.get(mask)).toE({graphics:mask_graphics_0,x:-0.8,y:-87.4}).waitE(1).toE({graphics:mask_graphics_1,x:-0.8,y:-72.6}).waitE(2).toE({graphics:mask_graphics_3,x:-1.1,y:-66.1}).waitE(2).toE({graphics:mask_graphics_5,x:-1.6,y:-57.4}).waitE(2).toE({graphics:mask_graphics_7,x:-1.9,y:-50.9}).waitE(2).toE({graphics:mask_graphics_9,x:-1.1,y:-42}).waitE(2).toE({graphics:mask_graphics_11,x:-0.5,y:-30.3}).waitE(2).toE({graphics:mask_graphics_13,x:-0.5,y:-16.5}).waitE(2).toE({graphics:mask_graphics_15,x:-0.5,y:-10.9}).waitE(2).toE({graphics:mask_graphics_17,x:-0.5,y:-3.6}).waitE(2).toE({graphics:mask_graphics_19,x:-0.5,y:0.5}).waitE(560).toE({graphics:mask_graphics_579,x:-0.5,y:0.5}).waitE(1).toE({graphics:mask_graphics_580,x:-0.5,y:-3.6}).waitE(2).toE({graphics:mask_graphics_582,x:-0.5,y:-10.9}).waitE(2).toE({graphics:mask_graphics_584,x:-0.5,y:-16.5}).waitE(2).toE({graphics:mask_graphics_586,x:-0.5,y:-30.3}).waitE(2).toE({graphics:mask_graphics_588,x:-1.1,y:-42}).waitE(2).toE({graphics:mask_graphics_590,x:-1.9,y:-50.9}).waitE(2).toE({graphics:mask_graphics_592,x:-1.6,y:-57.4}).waitE(2).toE({graphics:mask_graphics_594,x:-1.1,y:-66.1}).waitE(2).toE({graphics:mask_graphics_596,x:-0.8,y:-84.8}).waitE(124));

		// 圖層_1
		this.instance = new lib.bitmap_sence5_4();
		this.instance.parent = this;
		this.instance.setTransform(-120,-71,0.28,0.28);

		var maskedShapeInstanceList = [this.instance];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(720));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;


	(lib.base_foundation = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.bitmap_sence5_8();
		this.instance.parent = this;
		this.instance.setTransform(-64,-72);

		this.instance_1 = new lib.bitmap_sence5_7();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-136,-82);

		this.instance_2 = new lib.bitmap_sence5_6();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-78,-47);

		this.instance_3 = new lib.bitmap_sence5_5();
		this.instance_3.parent = this;
		this.instance_3.setTransform(-106,-63,0.5,0.5);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[]}).toE({state:[{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-78,y:-47}},{t:this.instance_1,p:{x:-136,y:-82}},{t:this.instance,p:{x:-64,y:-72}}]},5).toE({state:[{t:this.instance_2,p:{scaleX:1.1,scaleY:1.1,x:-145,y:-93}},{t:this.instance_1,p:{x:-104,y:-68}},{t:this.instance,p:{x:-16,y:-49}}]},2).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-78,y:-47}},{t:this.instance_1,p:{x:-136,y:-82}},{t:this.instance,p:{x:-64,y:-72}}]},167).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-104,y:-61}},{t:this.instance_1,p:{x:-115,y:-68}},{t:this.instance,p:{x:-54,y:-65}}]},153).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-104,y:-61}},{t:this.instance_1,p:{x:-115,y:-68}},{t:this.instance,p:{x:-54,y:-65}}]},148).toE({state:[{t:this.instance_3}]},2).toE({state:[{t:this.instance_2,p:{scaleX:1.1,scaleY:1.1,x:-145,y:-93}},{t:this.instance_1,p:{x:-104,y:-68}},{t:this.instance,p:{x:-16,y:-49}}]},189).toE({state:[{t:this.instance_2,p:{scaleX:1,scaleY:1,x:-78,y:-47}},{t:this.instance_1,p:{x:-136,y:-82}},{t:this.instance,p:{x:-64,y:-72}}]},4).toE({state:[]},4).waitE(40));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;


	(lib.triangle_orange_clip = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.triangle_orange();
		this.instance.parent = this;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({scaleX:1.4,scaleY:1.4,rotation:-85,x:36.4,y:-16.5},719).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-3.6,-4.2,7.3,8.4);

	(lib.rect_orange_clip = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.rect_orange();
		this.instance.parent = this;
		this.instance.setTransform(-3.7,3.7);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:180,x:-32.5,y:-25.1},719).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-3.9,-4.1,7.8,8.2);

	(lib.four_in_one_set = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_18
		this.instance = new lib.extend_line();
		this.instance.parent = this;
		this.instance.setTransform(-69,-25.9,1,1,0,0,180);
		this.instance._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).waitE(93).toE({_off:false},0).waitE(627));

		// 圖層_17
		this.instance_1 = new lib.extend_line();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-84,86.2,1,1,0,0,180);
		this.instance_1._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_1)).waitE(59).toE({_off:false},0).waitE(661));

		// 圖層_16
		this.instance_2 = new lib.extend_line();
		this.instance_2.parent = this;
		this.instance_2.setTransform(87,-23.5);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(77).toE({_off:false},0).waitE(643));

		// 圖層_15
		this.instance_3 = new lib.extend_line();
		this.instance_3.parent = this;
		this.instance_3.setTransform(97.3,75.6);
		this.instance_3._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_3)).waitE(49).toE({_off:false},0).waitE(671));

		// 圖層_14
		this.instance_4 = new lib.main_head();
		this.instance_4.parent = this;
		this.instance_4.setTransform(6.2,-118.2);
		this.instance_4._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_4)).waitE(68).toE({_off:false},0).toE({y:-151.4},320).toE({y:-118.2},331).waitE(1));

		// 圖層_13
		this.instance_5 = new lib.main_glass();
		this.instance_5.parent = this;
		this.instance_5.setTransform(-31.3,-46.8,1,1,0,0,180);
		this.instance_5._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_5)).waitE(65).toE({_off:false},0).waitE(655));

		// 圖層_12
		this.instance_6 = new lib.main_glass();
		this.instance_6.parent = this;
		this.instance_6.setTransform(46.3,-46.8);
		this.instance_6._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_6)).waitE(77).toE({_off:false},0).waitE(643));

		// 圖層_11
		this.instance_7 = new lib.main_cube();
		this.instance_7.parent = this;
		this.instance_7.setTransform(6.8,-63.5);
		this.instance_7._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_7)).waitE(56).toE({_off:false},0).toE({y:-80.4},326).toE({y:-63.5},337).waitE(1));

		// 圖層_10
		this.instance_8 = new lib.main_glass();
		this.instance_8.parent = this;
		this.instance_8.setTransform(-31.3,38.2,1,1,0,0,180);
		this.instance_8._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_8)).waitE(49).toE({_off:false},0).waitE(671));

		// 圖層_9
		this.instance_9 = new lib.main_glass();
		this.instance_9.parent = this;
		this.instance_9.setTransform(46.3,38.2);
		this.instance_9._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_9)).waitE(33).toE({_off:false},0).waitE(687));

		// 圖層_8
		this.instance_10 = new lib.main_cube();
		this.instance_10.parent = this;
		this.instance_10.setTransform(6.9,15.1);
		this.instance_10._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_10)).waitE(18).toE({_off:false},0).toE({y:4.7},364).toE({y:15.1},337).waitE(1));

		// 圖層_7
		this.instance_11 = new lib.side_cude();
		this.instance_11.parent = this;
		this.instance_11.setTransform(5,35.4,0.5,0.5,0,-1.8,178.2,0.1,0.2);
		this.instance_11._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_11)).waitE(31).toE({_off:false},0).toE({regY:0.1,scaleX:0.93,scaleY:0.93,x:-138.5,y:126.5},34).toE({x:-148.3,y:135.6},292).toE({x:-138.5,y:126.5},362).waitE(1));

		// 圖層_6
		this.instance_12 = new lib.side_cude_with_radius();
		this.instance_12.parent = this;
		this.instance_12.setTransform(2.1,-21.6,0.7,0.7,0,0,0,0.1,-0.1);
		this.instance_12._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_12)).waitE(81).toE({_off:false},0).toE({regX:0,regY:0,scaleX:1,scaleY:1,x:-131.7,y:-3.7},22).toE({x:-146.8,y:-9.2},254).toE({x:-131.7,y:-3.7},362).waitE(1));

		// 圖層_5
		this.instance_13 = new lib.side_cude();
		this.instance_13.parent = this;
		this.instance_13.setTransform(20.7,29.2,0.3,0.3,25.8,0,0,0.1,0.1);
		this.instance_13._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_13)).waitE(46).toE({_off:false},0).toE({regX:0,regY:0,scaleX:1,scaleY:1,rotation:26,x:148.6,y:86.8},23).toE({x:155.1,y:100.5},288).toE({x:148.6,y:86.8},362).waitE(1));

		// 圖層_4
		this.instance_14 = new lib.side_cude();
		this.instance_14.parent = this;
		this.instance_14.setTransform(24.3,-44.8,0.3,0.3,0,0,0,0,-0.1);
		this.instance_14._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_14)).waitE(64).toE({_off:false},0).toE({regY:0,scaleX:1,scaleY:1,x:148.4,y:-48},25).toE({x:166.8,y:-55.6},268).toE({x:148.4,y:-48},362).waitE(1));

		// 圖層_3
		this.instance_15 = new lib.base_foundation();
		this.instance_15.parent = this;
		this.instance_15.setTransform(7.2,77.5);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_15)).waitE(720));

		// 圖層_2
		this.instance_16 = new lib.base_line();
		this.instance_16.parent = this;
		this.instance_16.setTransform(6.3,80.5);
		this.instance_16._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_16)).waitE(87).toE({_off:false},0).toE({x:6.2,y:97.2},632).waitE(1));

		// 圖層_19
		this.instance_17 = new lib.text_clip_1("synched",0);
		this.instance_17.parent = this;
		this.instance_17.setTransform(21,18.9);
		this.instance_17._off = true;

		this.instance_18 = new lib.text_clip_2("synched",0);
		this.instance_18.parent = this;
		this.instance_18.setTransform(153,31.9);
		this.instance_18._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_17)).waitE(69).toE({_off:false},0).toE({_off:true,x:153,y:31.9},23).waitE(628));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_18)).waitE(69).toE({_off:false},23).waitE(501).toE({startPosition:0},0).toE({x:16.2,y:51},67).toE({_off:true},1).waitE(59));

		// 圖層_20
		this.instance_19 = new lib.text_clip_3("synched",0);
		this.instance_19.parent = this;
		this.instance_19.setTransform(-11.3,-22.5);
		this.instance_19._off = true;

		this.instance_20 = new lib.text_clip_4("synched",0);
		this.instance_20.parent = this;
		this.instance_20.setTransform(-155.3,-66.5);
		this.instance_20._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_19)).waitE(69).toE({_off:false},0).toE({_off:true,x:-155.3,y:-66.5},35).waitE(616));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_20)).waitE(69).toE({_off:false},35).waitE(496).toE({startPosition:0},0).toE({x:15.4,y:13.5},60).toE({_off:true},1).waitE(59));

		// 圖層_21
		this.instance_21 = new lib.text_clip_5("synched",0);
		this.instance_21.parent = this;
		this.instance_21.setTransform(22.4,-15.5);
		this.instance_21._off = true;

		this.instance_22 = new lib.text_clip_6("synched",0);
		this.instance_22.parent = this;
		this.instance_22.setTransform(154.4,-109.5);
		this.instance_22._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_21)).waitE(69).toE({_off:false},0).toE({_off:true,x:154.4,y:-109.5},49).waitE(602));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_22)).waitE(69).toE({_off:false},49).waitE(491).toE({startPosition:0},0).toE({x:15.4,y:12.5},51).toE({_off:true},1).waitE(59));

		// 圖層_1
		this.instance_23 = new lib.text_clip_7("synched",0);
		this.instance_23.parent = this;
		this.instance_23.setTransform(6.5,79.9);
		this.instance_23._off = true;

		this.instance_24 = new lib.text_clip_8("synched",0);
		this.instance_24.parent = this;
		this.instance_24.setTransform(-163.5,67.9);
		this.instance_24._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_23)).waitE(85).toE({_off:false},0).toE({_off:true,x:-163.5,y:67.9},24).waitE(611));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_24)).waitE(85).toE({_off:false},24).waitE(510).toE({startPosition:0},0).toE({x:15.7,y:37.8},41).toE({_off:true},1).waitE(59));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = null;

	(lib.circle_orange_clip = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.circle_orange();
		this.instance.parent = this;
		this.instance.setTransform(15.7,0.6);

		this.timeline.addTween(TTF(cjs.Tween.get(this.instance)).toE({rotation:60,x:56.2,y:26.6},719).waitE(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-4,-4.7,8.1,9.5);
	(lib.circle_orange = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// flash0.ai
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FF8C41").s().p("AgnACIAAgCIBPguIAAAAIAABcIgBABg");
		this.shape.setTransform(-15.6,-0.6);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#FF8C41").s().p("AAACSIgCgEIAAhYIABgFIBRAwIAAABIABAAIAAABIAAABIhRAugABRBiIAAgBIABAAIAAABgAhRAAIAAgCIBQguIAAABIAABdgAgCgzIAAhdIABgBIBQAvIAAACIhQAug");
		this.shape_1.setTransform(-11.4,-0.4);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#FF8C41").s().p("AhUCRIAAhbIABgFIBTAwIAAABIAAAAIAAABIhRAvgAAABiIAAgBIBSgvIACABIAABZIgIABgABSAvIAAhdIBRAuIAAABIhRAvgAiiAAIABgDIBOgtIABABIAABdgAAAhgIAAgDIBRguIADACIAABeIAAAAIAAABIABgBIgCABgAhUgzIAAhdIABgBIBTAwIhTAvgAhbiPIACAAIgCABIAAgBg");
		this.shape_2.setTransform(-3.3,-0.4);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#FF8C41").s().p("AABDGIAAgCIBUgwIAABgIgBACgAhTD0IAAi8IACgFIBRAwIAAAAIABAAIAAACIhTAxIBTAwIhRAvgAinDEIAAhfIBUAwIhSAvgABWCUIBSgwIABABIAABZIgEADgAABBjIAAAAIBTgwIABABIAABggAilBjIAAAAIgFADgACnBiIAAhfIBUAwIAAAAIhSAwgAj5AyIAAgCIBUgwIhUgwIBTgvIACAAIAADAIgBACgABTAxIAAheIBTAvIhSAwgAikAAIBTguIAAAAIAABegACnheIAAAAIAAgBIABAAIBTAwIAAACIhUAwgAj6gwIABAAIAAACIgBABgAABheIAAgDIBUgwIAABiIAAgBIAAABIABAAIgBABgAhTgxIAAjAIACgBIBRAvIAAACIABAAIAAABIhTAwIBTAxIhSAvgABWiRIBSgvIABAAIAABfgAinhhIAAhfIABAAIBTAwIhTAvgAABjCIBTgvIABABIAABfgACnjDIAAgDIAFADIgDABgAinjCIACAAIgBAAgAhSj0IABgBIAAABIAAAAg");
		this.shape_3.setTransform(-3.4,-0.6);

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f("#FF8C41").s().p("ABSFWIAAhgIBTAwIhSAwgAijEkIBRgvIAAABIAABegACmDIIACgDIBSAvIAAABIhUAxgAj3DzIBQguIACAAIAABegAAADFIAAgCIBUgxIAABgIgBACgAhUDzIAAi9IACgFIBSAwIAAABIAAAAIAAABIhTAxIBTAxIhSAvgAioDDIAAhgIBUAwIhTAwgABVCSIBSgwIABABIAABfgAAABiIAAgBIBTgvIABABIAABfgAimBhIAAAAIgFADgAD7AyIAAgDIBTgvIABBgIgBACIABAAIgBAAgACmBhIAAhgIBUAxIhSAwgAj6AwIAAgCIBUgvIhUgxIBTgvIACAAIAADBIgBABgAlOBgIAAhgIBUAwIhRAwgABSAvIAAhdIBTAuIhSAwgAilAAIBTgwIAAABIAABdgACmhgIAAABIABgCIAAAAIBTAxIAAACIhUAvgAD7gwIBSgwIABBggAlKhgIBQAuIAAADIhSAvgAAAhgIAAgDIBUgwIAABiIABAAIgBABIABgBIgBABgAhUgzIAAjAIACgBIBSAvIAAACIAAAAIAAABIhTAxIBTAwIhSAvgABViSIBSgwIABAAIAABfgAiohjIAAhfIABAAIBTAwIhTAvgAAAjEIBTgvIABABIAABfgACmjFIAAhcIBRAwIhPAtgAj5jzIBUgxIAABgIgCAAgABSj1IAAhfIBTAwIhSAwgAilklIBTgwIAAAAIAABfIAAABg");
		this.shape_4.setTransform(-3.3,-0.4);

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f("#FF8C41").s().p("AhVGzIAAhcIACgBIBSAwIAAABIABAAIAAABIhQAuIgFgDgAAAGHIBRgwIACABIAABZIgGADgAj7FVIBUgxIhUgwIBSgwIACABIAAC/IhUgvgAClEmIBQAvIhQAtgABRFVIAAhfIBTAwIhTAvgAhTFUIhTgvIBTgwIAAABIAABegAClDIIACgDIBSAvIAAACIhUAwgAlPEmIAAhhIAAgCIBUAxIAAACIhUAwgAD6D0IBSgwIACABIAABdIgCACgAAADEIAAgCIBTgwIAABgIgBACgAhVDzIAAi9IACgFIBSAwIAAAAIABAAIAAACIhVAxIBVAwIhTAwgAFMDCIAAhfIBTAwIhSAwgAipDCIAAhfIBTAwIhSAwgABUCSIBSgwIABABIAABfgAmgCRIBSgvIABAAIAABfgAAABhIAAAAIBRgwIACABIAABggAinBhIAAAAIgFADgAD6AxIAAgCIBTgvIhTgxIBSgwIACABIAAC/IgBACIABAAIgBABgAClBgIAAhfIBUAwIhTAwgAj7AwIAAgCIBUgvIhUgxIBSgvIACAAIAADAIAAACgAlPBfIAAhfIBUAwIhTAwgABRAvIAAheIBTAvIhTAwgAFOAAIBSguIAAABIABABIAABbgAimgBIBTgvIAAAAIAABegAmbgqIBKAqIhNAsIADhWgAClhgIgBABIABgCIAAAAIBUAwIAAACIhUAwgAlPhhIABgBIBTAwIAAACIhUAwgAAAhgIAAgDIBTgwIAABiIAAAAIAAAAIABAAIgCABgAhVgzIAAjAIACgBIBSAvIAAACIABAAIAAABIhVAwIBVAxIhTAvgAFMhiIAAhfIBRAuIAAADIhQAugABUiTIBSgvIABAAIAABfgAiphjIAAhfIABAAIBSAwIhSAvgAlOhjIhJgqIABgLIBIgqIABAAIAABfgAAAjEIBRgvIACABIAABfgAD6jzIAAgCIBNgtIAHAEIAABaIABgBIAAABIgCABgACljFIAAhfIBUAxIhTAvgAj7jzIAAgCIBUgxIhSgvIBSgvIAADAIgBAAgAlPjFIAAhfIBUAxIhTAvgABRj1IAAhfIBTAwIhTAvgAimklIBTgwIAAAAIAABfIAAAAgAClmFIgCABIABgCIABgBIBUAxIAAACIhUAwgAlPkkIAJgFIgJAFgAD6lWIAAAAIAAAAIAAAAgAAAmGIAAgCIBMgtIAHAEIAABaIAAAAIAAABIgBAAgAhVlXIAAhcIAEgCIBRAvIhTAwg");
		this.shape_5.setTransform(-3.2,-0.4);

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f("#FF8C41").s().p("AgXHfIBOgtIAAArQgYADgaAAgAhxHRIAAiAIACgBIBSAwIAAABIABAAIAAABIhUAwIBKAsQgjgDgogKgAA4GyIBSgvIABAAIAABKIgZAGgAjFGzIAAgwIABAAIBTAvIgkAUQgWgHgagMgAgcGBIBSgwIABABIAABggACJGAIAAhfIBUAwIhSAwgAkXFRIAAgCIBUgwIhUgxIBTgvIACAAIAADBIgCABgADeFRIAAgCIBUgwIhUgxIBSgvIACAAIAAC2IgJAIgAlrEzIAAgSIBUAwIgjAUQgbgXgWgbgAA1FQIAAhgIBTAwIhSAwgAhvFPIhTgwIBTgwIAAABIAABfgAEzEfIBSgwIABABIAAAuQgNASgOAPgAmEESIAYAOIgKAFgACJDCIACgDIBSAvIAAACIhUAxgAlrC/IAAgBIBUAwIAAACIhUAxgAgcC/IAAgCIBTgxIAABgIgBACgAGEDtIAAjAIABgBIgBAAIABgBIBRAwIAAABIABAAIAAACIhTAwIA+AkIgPAhIguAbgAhxDtIAAi9IACgFIBSAwIAAABIABAAIAAABIhUAxIBUAxIhTAvgAEwC9IAAhgIBTAwIhSAwgAjFC9IAAhgIBUAwIhTAwgAA4CMIBSgwIABABIAABfgAm8CLIBSgvIABAAIAABggAnFCPIAIgEIAAAagAgcBcIAAgBIBSgvIABABIAABfgAnICFQgKgkgFgpIAYgOIACACIAABfgAjDBbIAAAAIgFADgADeAsIAAgDIBUgvIhUgwIBSgxIACABIAADAIgBACIABAAIgBAAgAHXBbIABAAIAAABgACJBbIAAhfIBUAwIhSAwgAkXAqIAAgCIBUgvIhUgxIBTgvIACAAIAADBIgBABgAlrBaIAAhfIBUAvIhTAxgAA1ApIAAhdIBTAvIhSAvgAEzgGIBSgvIABABIAABdgAm/AoIAAhcIAAgBIBTAvIhTAvgAjCgGIBTgwIAAABIAABdgACJhmIAAABIABgCIAAAAIBTAxIAAACIhUAwgAlrhnIABgBIBTAwIAAADIhUAwgAgchmIAAgDIBTgwIAABiIAAAAIAAABIABgBIgBABgAGEg4IAAjAIABgBIAmAVQANAYAHATIg7AiIBUAxIAAAAIgBgBIAAABIhSAwgAnWhEQAGgmAOgsIAFgDIAABhIgCACgAhxg5IAAjAIACgBIBSAvIAAACIABAAIAAABIhUAxIBUAwIhTAvgAEwhoIAAhfIBTAwIhSAvgAA4iYIBSgwIABAAIAABfgAjFhpIAAhfIABAAIBTAwIhTAvgAlqhpIhSgvIBSgwIABAAIAABfgAgcjKIBSgvIABABIAABfgAnBibIAEgKIAAAMgADej5IAAgCIBUgxIhUgwIBCgmIASANIAACrIABgBIAAABIgCABgACJjLIAAheIBUAwIhSAvgAkXj5IAAgCIBUgxIhUgwIBTgwIACABIAADBIgCAAgAlrjLIAAheIBUAwIhTAvgAA1j7IAAhfIBTAwIhSAwgAEzkrIAwgcQAYAbALAPIAAAigAjCkrIBTgwIAAAAIAABfIAAABgAlwktIAEADIgLAGgACJmLIgBABIAAgCIACAAIBTAwIAAACIhUAxgAlrkyQAZgfAggbIAbAQIAAACIhUAxgAgcmMIAAgCIBTgxIAABiIABAAIgBABIAAAAgAhxldIAAh0QAXgFAegEIg0AdIBUAxIhTAwgAjFmOIAAglQAegOAfgJIAXANIhTAvgAA4m+IAqgYQATAEAWAGIAAA+gAAAnfIAFAAQAeAAAUADIAAAdg");
		this.shape_6.setTransform(-0.4,0.2);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f("#FF8C41").s().p("AlJFKQiJiIAAjCQAAjACJiJQCJiJDAAAQDCAACICJQCJCJAADAQAADCiJCIQiICJjCAAQjAAAiJiJg");
		this.shape_7._off = true;

		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f("#FF8C41").s().p("AhWHuIgGgBIAMhFQi6gjhuicQhuieAhi+QAii+CehwQCchsC6AeIgMBFIAGABQC/AiBuCeQBwCfgiC9QgiC/ieBvQh6BViMAAQgqAAgsgIg");
		this.shape_8.setTransform(0,9.4);
		this.shape_8._off = true;

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f("#FF8C41").s().p("AAqHpIAAsqIAZgBQCoAAB3B3QB4B3AACnQAACph4B2Qh3B4ioAAIgZgBgAlaD7Qh+h/gBizQABi0B+iAQB2h1CjgJIAANjQijgKh2h1g");
		this.shape_9.setTransform(0,-2.3);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f("#FF8C41").s().p("ACJGXIAAqAIATAAQCGAABdBdQBfBfAACEQAACFhfBdQhdBfiGAAIgTgBgAl1DHQhohoAAiTQAAiTBohpQBhhgCFgHIAALGQiFgHhhhhg");
		this.shape_10.setTransform(0.9,-2.6);

		this.shape_11 = new cjs.Shape();
		this.shape_11.graphics.f("#FF8C41").s().p("ADzFWIAAnZIAPgBQBiAABGBGQBGBFAABiQAABihGBGQhGBGhiAAIgPgBgAmVC5QhahaAAiAQAAiABahbQBVhUBzgGIAAJqQhzgHhVhUg");
		this.shape_11.setTransform(-2.2,-4.5);

		this.shape_12 = new cjs.Shape();
		this.shape_12.graphics.f("#FF8C41").s().p("AGQD4IAAkbIAJgBQA7AAApApQAqAqAAA7QAAA7gqAqQgpAqg7AAIgJgBgAnnB5Qg/hAAAhZQAAhaA/g/QA7g7BRgEIAAGwQhRgFg7g6g");
		this.shape_12.setTransform(-1.6,-4.6);

		this.shape_13 = new cjs.Shape();
		this.shape_13.graphics.f("#FF8C41").s().p("AIACzIAAitIAGgBQAkAAAZAaQAaAaAAAkQAAAkgaAZQgZAagkAAIgGgBgAo1AxQgngoAAg2QAAg4AngnQAlglAygCIAAELQgygDglgkg");
		this.shape_13.setTransform(-2.7,-3.2);

		this.shape_14 = new cjs.Shape();
		this.shape_14.graphics.f("#FF8C41").s().p("AJnCJIAAhiIADAAQAUAAAOAOQAOAPAAAUQAAAUgOAOQgOAPgUAAIgDAAgAqBAKQgZgYAAgkQAAgkAZgZQAYgXAggCIAACrQgggCgYgXg");
		this.shape_14.setTransform(-3.2,-2.8);

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.shape}]}).toE({state:[{t:this.shape_1}]},3).toE({state:[{t:this.shape_2}]},3).toE({state:[{t:this.shape_3}]},54).toE({state:[{t:this.shape_4}]},3).toE({state:[{t:this.shape_5}]},2).toE({state:[{t:this.shape_6}]},2).toE({state:[{t:this.shape_7}]},2).toE({state:[{t:this.shape_8}]},50).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},24).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},91).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},34).toE({state:[{t:this.shape_7}]},6).toE({state:[{t:this.shape_8}]},97).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_8}]},43).toE({state:[{t:this.shape_7}]},5).toE({state:[{t:this.shape_7}]},112).toE({state:[{t:this.shape_9}]},4).toE({state:[{t:this.shape_10}]},3).toE({state:[{t:this.shape_11}]},3).toE({state:[{t:this.shape_12}]},3).toE({state:[{t:this.shape_13}]},3).toE({state:[{t:this.shape_14}]},3).toE({state:[]},2).waitE(146));
		this.timeline.addTween(TTF(cjs.Tween.get(this.shape_7)).waitE(69).toE({_off:false},0).toE({_off:true},50).waitE(6).toE({_off:false},0).toE({_off:true},24).waitE(6).toE({_off:false},0).toE({_off:true},91).waitE(5).toE({_off:false},0).toE({_off:true},34).waitE(6).toE({_off:false},0).toE({_off:true},97).waitE(5).toE({_off:false},0).toE({_off:true},43).waitE(5).toE({_off:false},0).waitE(112).toE({_off:true},4).waitE(163));
		this.timeline.addTween(TTF(cjs.Tween.get(this.shape_8)).waitE(119).toE({_off:false},0).toE({_off:true},6).waitE(24).toE({_off:false},0).toE({_off:true},6).waitE(91).toE({_off:false},0).toE({_off:true},5).waitE(34).toE({_off:false},0).toE({_off:true},6).waitE(97).toE({_off:false},0).toE({_off:true},5).waitE(43).toE({_off:false},0).toE({_off:true},5).waitE(279));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-19.6,-5.3,8,9.5);

	(lib.sence_1_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_1_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-170,-12,1.29,1.29);

		this.instance_1 = new lib.sence_1_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-211,-18,0.71,0.71);

		this.instance_2 = new lib.sence_1_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-160.3,-22.1,0.27,0.27);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance_1,p:{scaleX:0.71,scaleY:0.71,x:-211,y:-18}},{t:this.instance,p:{scaleX:1.29,scaleY:1.29,x:-170,y:-12}}]}).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},3).toE({state:[{t:this.instance,p:{scaleX:1,scaleY:1,x:-181,y:-8}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},131).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},212).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},101).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},144).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance,p:{scaleX:1,scaleY:1,x:-181,y:-8}}]},90).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-139,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-180,y:-7}}]},5).toE({state:[{t:this.instance_1,p:{scaleX:0.71,scaleY:0.71,x:-211,y:-18}},{t:this.instance,p:{scaleX:1.29,scaleY:1.29,x:-170,y:-12}}]},3).toE({state:[]},2).waitE(11));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(9).toE({_off:false},0).toE({_off:true},131).waitE(3).toE({_off:false},0).toE({_off:true},212).waitE(3).toE({_off:false},0).toE({_off:true},111).waitE(3).toE({_off:false},0).toE({_off:true},144).waitE(3).toE({_off:false},0).toE({_off:true},90).waitE(11));
	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-211,-18,455.1,46);

	(lib.sence_2_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_2_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-176,-10);

		this.instance_1 = new lib.sence_2_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-204,-51,1.36,1.36);

		this.instance_2 = new lib.sence_2_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-159,-30,0.31,0.31);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance_1,p:{scaleX:1.36,scaleY:1.36,x:-204,y:-51}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-176,y:-10}}]}).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:-20}}]},4).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},286).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},72).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},94).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},122).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-159,y:-20}}]},99).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-213,y:-45}},{t:this.instance,p:{scaleX:0.72,scaleY:0.72,x:-74,y:-13}}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1.36,scaleY:1.36,x:-204,y:-51}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-176,y:-10}}]},4).toE({state:[]},4).waitE(11));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(11).toE({_off:false},0).toE({_off:true},286).waitE(3).toE({_off:false},0).toE({_off:true},72).waitE(4).toE({_off:false},0).toE({_off:true},94).waitE(3).toE({_off:false},0).toE({_off:true},122).waitE(4).toE({_off:false},0).toE({_off:true},109).waitE(12));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-204,-51,431.1,91);

	(lib.sence_3_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_3_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-91,-16,1.5,1.5);

		this.instance_1 = new lib.sence_3_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-162,-50);

		this.instance_2 = new lib.sence_3_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-131.7,-35.5,0.37,0.37);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance_1,p:{x:-162,y:-50}},{t:this.instance,p:{scaleX:1.5,scaleY:1.5,x:-91,y:-16}}]}).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},3).toE({state:[{t:this.instance,p:{scaleX:1,scaleY:1,x:-104,y:-8}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},49).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},207).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},136).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},114).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},103).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{x:-162,y:-50}},{t:this.instance,p:{scaleX:1.5,scaleY:1.5,x:-91,y:-16}}]},56).toE({state:[{t:this.instance_1,p:{x:-168,y:-22}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-58,y:-3}}]},5).toE({state:[{t:this.instance,p:{scaleX:1,scaleY:1,x:-104,y:-8}}]},5).toE({state:[]},5).waitE(11));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(9).toE({_off:false},0).toE({_off:true},49).waitE(4).toE({_off:false},0).toE({_off:true},217).waitE(4).toE({_off:false},0).toE({_off:true},136).waitE(4).toE({_off:false},0).toE({_off:true},114).waitE(4).toE({_off:false},0).toE({_off:true},103).waitE(4).toE({_off:false},0).toE({_off:true},56).waitE(16));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-162,-50,348.5,100);
	(lib.sence_4_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_4_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-96,-6);

		this.instance_1 = new lib.sence_4_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-184,-46);

		this.instance_2 = new lib.sence_4_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-135.2,-35.7,0.38,0.38);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-184,y:-46}},{t:this.instance,p:{x:-96,y:-6,scaleX:1,scaleY:1}}]}).toE({state:[{t:this.instance_1,p:{scaleX:1.46,scaleY:1.46,x:-197,y:-49}}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},3).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},23).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},110).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},147).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},117).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},83).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},116).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-147,y:-37}},{t:this.instance,p:{x:-92,y:-8,scaleX:1,scaleY:1}}]},63).toE({state:[{t:this.instance_1,p:{scaleX:1.46,scaleY:1.46,x:-197,y:-49}}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-204,y:-37}},{t:this.instance,p:{x:12,y:15,scaleX:0.6,scaleY:0.6}}]},4).toE({state:[]},3).waitE(11));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(9).toE({_off:false},0).toE({_off:true},23).waitE(3).toE({_off:false},0).toE({_off:true},110).waitE(4).toE({_off:false},0).toE({_off:true},147).waitE(3).toE({_off:false},0).toE({_off:true},117).waitE(3).toE({_off:false},0).toE({_off:true},83).waitE(4).toE({_off:false},0).toE({_off:true},136).waitE(3).toE({_off:false},0).toE({_off:true},63).waitE(12));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-184,-46,359,93);

	(lib.sence_5_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_5_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-148,-13,0.59,0.59);

		this.instance_1 = new lib.sence_5_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-191,-12);

		this.instance_2 = new lib.sence_5_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-211.6,-28,0.28,0.28);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance,p:{scaleX:0.59,scaleY:0.59,x:-148,y:-13}}]}).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1.69,scaleY:1.69,x:-294,y:-47}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-88,y:-36}}]},4).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},276).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},71).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},117).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},114).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-191,y:-12}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-177,y:-35}}]},93).toE({state:[{t:this.instance_1,p:{scaleX:1.69,scaleY:1.69,x:-294,y:-47}},{t:this.instance,p:{scaleX:1,scaleY:1,x:-88,y:-36}}]},5).toE({state:[{t:this.instance,p:{scaleX:0.59,scaleY:0.59,x:-148,y:-13}}]},5).toE({state:[]},3).waitE(11));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(12).toE({_off:false},0).toE({_off:true},286).waitE(4).toE({_off:false},0).toE({_off:true},71).waitE(3).toE({_off:false},0).toE({_off:true},117).waitE(3).toE({_off:false},0).toE({_off:true},114).waitE(3).toE({_off:false},0).toE({_off:true},93).waitE(14));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-148,-13,198.9,33.1);

	(lib.sence_6_text = function(mode,startPosition,loop=false) {
		this.initialize(mode,startPosition,loop,{});

		// 圖層_1
		this.instance = new lib.sence_6_text_bitmap_3();
		this.instance.parent = this;
		this.instance.setTransform(-217,-11);

		this.instance_1 = new lib.sence_6_text_bitmap_2();
		this.instance_1.parent = this;
		this.instance_1.setTransform(-77,-32);

		this.instance_2 = new lib.sence_6_text_bitmap_1();
		this.instance_2.parent = this;
		this.instance_2.setTransform(-146.1,-38.6,0.42,0.42);
		this.instance_2._off = true;

		this.timeline.addTween(TTF(cjs.Tween.get({})).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-77,y:-32}},{t:this.instance,p:{x:-217,y:-11,scaleX:1,scaleY:1}}]}).toE({state:[{t:this.instance_1,p:{scaleX:0.63,scaleY:0.63,x:-110,y:-12}}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-168,y:-31}},{t:this.instance,p:{x:-103,y:-12,scaleX:1,scaleY:1}}]},4).toE({state:[{t:this.instance_2}]},4).toE({state:[{t:this.instance_1,p:{scaleX:0.77,scaleY:0.77,x:-74,y:-14}},{t:this.instance,p:{x:-120,y:-22,scaleX:0.77,scaleY:0.77}}]},63).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:0.77,scaleY:0.77,x:-74,y:-14}},{t:this.instance,p:{x:-120,y:-22,scaleX:0.77,scaleY:0.77}}]},177).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:0.77,scaleY:0.77,x:-74,y:-14}},{t:this.instance,p:{x:-120,y:-22,scaleX:0.77,scaleY:0.77}}]},186).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:0.77,scaleY:0.77,x:-74,y:-14}},{t:this.instance,p:{x:-120,y:-22,scaleX:0.77,scaleY:0.77}}]},156).toE({state:[{t:this.instance_2}]},3).toE({state:[{t:this.instance_1,p:{scaleX:0.63,scaleY:0.63,x:-110,y:-12}}]},101).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-168,y:-31}},{t:this.instance,p:{x:-103,y:-12,scaleX:1,scaleY:1}}]},4).toE({state:[{t:this.instance_1,p:{scaleX:1,scaleY:1,x:-77,y:-32}},{t:this.instance,p:{x:-217,y:-11,scaleX:1,scaleY:1}}]},4).toE({state:[]},4).waitE(1));
		this.timeline.addTween(TTF(cjs.Tween.get(this.instance_2)).waitE(12).toE({_off:false},0).toE({_off:true},63).waitE(3).toE({_off:false},0).toE({_off:true},177).waitE(3).toE({_off:false},0).toE({_off:true},186).waitE(3).toE({_off:false},0).toE({_off:true},156).waitE(3).toE({_off:false},0).toE({_off:true},101).waitE(13));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-217,-32,432,96);
}